const translationFr = {
    // metadata
    'metadata.description': 'Le back-office Innovorder',

    // Cookies
    'cookies.banner.message':
        "Notre site web utilise des cookies pour améliorer votre expérience. En continuant à naviguer, vous acceptez l'utilisation de ces cookies. Pour en savoir plus sur notre politique de confidentialité et pour gérer vos préférences de cookies, veuillez consulter notre page dédiée.",
    'cookies.banner.accept': 'Accepter',
    'cookies.banner.decline': 'Refuser',

    // legends
    'legend.DELIVERY': 'Livraison',
    'legend.DRIVE': 'Drive',
    'legend.SIT_IN': 'Sur place',
    'legend.TAKE_AWAY': 'A emporter',
    'legend.KIOSK': 'Borne',
    'legend.WEB': 'Commande en ligne',
    'legend.RECEPTION': 'Reception',
    'legend.POS': 'Caisse',
    'legend.LOYALTY': 'Fidélité',
    'legend.EWALLET_KIOSK': 'Kiosk ewallet',
    'legend.VENDING_MACHINE': 'Automates',

    // analytics page
    'analyticsPage.needBrandSelection': 'Comme vous êtes admin, vous devez selectionner au minimum une enseigne.',
    'analyticsPage.notAuthorizedToSeeBrand': "Vous n'êtes pas autorisé à voir cette enseigne.",
    'analyticsPage.cannotMixEducationAndNonEducationBrands':
        'Vous ne pouvez pas sélectionner à la fois des enseignes de restauration collective et commerciale.',
    'analyticsPage.reload': 'Rafraîchir les données',
    'beta_banner.message':
        '👋 Ceci est une version  <b> beta</b>, de nombreuses améliorations/corrections vont arriver.',
    'analytics.metabaseError': 'une erreur est survenue, réessayez plus tard..',
    'analytics.noAdmin':
        "Malheureusement, IO Analytics n'est pas encore disponible en mode admin... Rassurez-vous, c'est pour bientôt !",
    'analytics.realTime': 'Temps réel',
    'analytics.ranking': 'Classement',
    'analytics.products': 'Produits',
    'analytics.sales': 'Ventes',
    'analytics.salesSummary': 'Synthèse financière',
    'analytics.demoStaging': 'Démo (Staging)',
    'analytics.attendance': 'Fréquentation',
    'analytics.billing': 'Facturation',
    'analytics.dashboard': 'Metabase dashboard',
    'analytics.filter.restaurant': 'Filtrer par restaurant',
    'analytics.filter.group': 'Filtrer par groupe',
    'analytics.filter.consumption': 'Mode de consommation',
    'analytics.filter.channel': 'Canaux',
    'analytics.filter.HT': 'HT',
    'analytics.filter.TTC': 'TTC',
    'analytics.filter.takeAway': 'À emporter',
    'analytics.filter.sitIn': 'Sur place',
    'analytics.filter.delivery': 'En livraison',
    'analytics.filter.drive': 'Drive',
    'analytics.filter.kiosk': 'Borne',
    'analytics.filter.web': 'Commande en ligne',
    'analytics.filter.pos': 'Caisse',
    'analytics.filter.ubereats': 'Ubereats',
    'analytics.filter.deliveroo': 'Deliveroo',
    'analytics.filter.justeat': 'Justeat',
    'analytics.filter.vendingmachine': 'Distribution Automatique',

    // Leaderboard
    'leaderboard.title': 'Classement des restaurants',
    'leaderboard.ranking': 'Position',
    'leaderboard.restaurantName': 'Restaurants',
    'leaderboard.revenue': "Chiffre d'affaires",
    'leaderboard.averageBasket': 'Panier moyen',
    'leaderboard.ordersCount': 'Commandes',
    'leaderboard.RestaurantSearchPlaceholder': 'Rechercher un restaurant',

    // Tiles
    'tile.genericErrorMessage': 'Une erreur est survenue !',
    'tile.errorHint': 'Veuillez rafraîchir les données',

    // Random
    'random.or': 'ou',

    // Tooltip
    'tooltip.example.label': 'Exemple :',

    // Paiement IO Pay Config
    'iopay.configuration.title': 'Paramètres Adyen',
    'iopay.commissions.online.title': 'Commissions en ligne',
    'iopay.commissions.proximity.title': 'Commissions en proximité',
    'iopay.form.name': 'Label',
    'iopay.form.placeholder.name': 'Label',
    'iopay.form.accountHolder': 'Identifiant du titulaire de compte',
    'iopay.form.placeholder.accountHolder': 'AH111222AAABBB',
    'iopay.form.balanceAccount': 'Identifiant du compte financier',
    'iopay.form.placeholder.balanceAccount': 'BA111222AAABBB',
    'iopay.form.storeId': 'Identifiant du vendeur',
    'iopay.form.placeholder.storeId': 'Identifiant du vendeur',
    'iopay.form.transferInstrumentId': "Identifiant de l'instrument de transfert",
    'iopay.form.placeholder.transferInstrumentId': 'SE111222AAABBB',
    'iopay.form.fixOnlineCommissionAmount': "Montant des commisions fixes (en centimes d'euro)",
    'iopay.form.fixProximityCommissionAmount': "Montant des commisions fixes (en centimes d'euro)",
    'iopay.form.placeholder.fixOnlineCommissionAmount': "Montant des commisions fixes (en centimes d'euro)",
    'iopay.form.placeholder.fixProximityCommissionAmount': "Montant des commisions fixes (en centimes d'euro)",
    'iopay.form.variableOnlineCommissionPercent': 'Pourcentage des commissions variables',
    'iopay.form.variableProximityCommissionPercent': 'Pourcentage des commissions variables',
    'iopay.form.placeholder.variableOnlineCommissionPercent': 'Pourcentage des commissions variables',
    'iopay.form.placeholder.variableProximityCommissionPercent': 'Pourcentage des commissions variables',

    // Edenred Config
    'edenred.configuration.title': 'Paramétrage du module Edenred',
    'edenred.form.description':
        "Configurez l'intégration Edenred en renseignant les informations nécessaires. Une fois enregistrées, le Merchant ID du restaurant sera automatiqument récupéré.",
    'edenred.form.warning.toSend': 'Informations enregistrées & encore modifiables avant envoi à Edenred.',
    'edenred.form.warning.sent': 'En cours de traitement par Edenred.',
    'edenred.form.mid': 'Merchant ID',
    'edenred.form.name': 'Nom du restaurant',
    'edenred.form.placeholder.name': 'Le nom de mon restaurant',
    'edenred.form.siret': 'Siret',
    'edenred.form.placeholder.siret': '12345678900012',
    'edenred.form.address': 'Adresse',
    'edenred.form.placeholder.address': '5 avenue Anatole France',
    'edenred.form.zipCode': 'Code postal',
    'edenred.form.placeholder.zipCode': '75007',
    'edenred.form.city': 'Ville',
    'edenred.form.placeholder.city': 'Paris',

    // Paygreen Config
    'paygreen.configuration.title': 'Paramétrage du module pour Titres Restaurants',
    'paygreen.form.description':
        'Une fois votre compte créé grâce au formulaire mis à disposition ci-dessus, les clés publiques et privées vous seront transmises pour paramétrage du module.',
    'paygreen.form.ongoing_v3_migration':
        'Une migration de la version de Paygreen est en cours de préparation, aucune action sur le backoffice n’est nécessaire de votre part',
    'paygreen.form.enablePaygreenV3': 'Activer Paygreen V3',
    'paygreen.form.label': 'Nom de l’intégration',
    'paygreen.form.publicKey': 'V2 Clé publique (shopId)',
    'paygreen.form.privateKey': 'V2 Clé privée (token)',
    'paygreen.form.secretKey': 'V3 Clé Secrète',
    'paygreen.form.shopId': 'V3 Shop ID',
    'paygreen.form.subShopId': 'V3 Sous shop ID (à renseigner uniquement si en mode marketplace)',
    'paygreen.form.supportsLuncheon': 'Paiements avec Pass Restaurant (Sodexo) ou Chèque Déjeuner (Up)',
    'paygreen.form.supportsSwile': 'Paiements avec Swile (ex Lunchr)',
    'paygreen.form.supportsRestoflash': 'Paiements avec Resto Flash',
    'paygreen.form.placeholder.enablePaygreenV3': 'Activer Paygreen V3',
    'paygreen.form.placeholder.label': 'Nom de l’intégration',
    'paygreen.form.placeholder.publicKey': 'V2 Clé publique (shopId)',
    'paygreen.form.placeholder.privateKey': 'V2 Clé privée (token)',
    'paygreen.form.placeholder.secretKey': 'V3 Clé Secrète',
    'paygreen.form.placeholder.shopId': 'V3 Shop ID',
    'paygreen.form.placeholder.subShopId': 'V3 Sous shop ID (à renseigner uniquement si en mode marketplace)',
    'paygreen.form.placeholder.supportsLuncheon': 'Paiements avec Pass Restaurant (Sodexo) ou Chèque Déjeuner (Up)',
    'paygreen.form.placeholder.supportsSwile': 'Paiements avec Swile (ex Lunchr)',
    'paygreen.form.placeholder.supportsRestoflash': 'Paiements avec Resto Flash',

    // Marketplace Ubereats Config
    'ubereats.title': 'Paramètres UberEats',
    'ubereats.description.firstpart':
        'Configurez votre intégration Ubereat en définissant votre référence UUID disponible depuis l’interface ubereat de votre restaurant. Si vous ne savez pas où trouver cette information:',
    'ubereats.description.secondpart': 'Comment trouver le Store ID de mon restaurant ?',
    'ubereats.description.thirdpart':
        'Une fois configurée, votre caisse recevra automatiquement les commandes Ubereat dans la rubrique livraison.',
    'ubereats.storid': 'ID de la boutique',
    'ubereats.activestorids': 'Store ID actif(s)',

    // Marketplace Deliverect Config
    'deliverect.title': 'Paramétrage du module Deliverect',
    'deliverect.subtitle': 'Comment configurer mon intégration avec Deliverect ?',
    'deliverect.description.firstpart':
        'Vous devez au préalable vous rapprochez d’un account manager pour vous permettre de créer un compte sur l’environnement Deliverect.',
    'deliverect.description.secondpart':
        'Une fois ce compte activé. La possibilité d’activé l’envoi des commandes sur les canaux de votre choix seront possible directement depuis cette interface.',
    'deliverect.description.thirdpart':
        'Vous pourrez également procéder à la synchronisation de vos produits dans l’interface.',
    'deliverect.contact': 'Contactez un account manager',

    // Marketplace Deliveroo config
    'deliveroo.title': 'Paramétrage du module Deliveroo',
    'deliveroo.subtitle': 'Comment configurer mon intégration avec Deliveroo ?',
    'deliveroo.description.firstpart':
        'Vous devez au préalable vous rapprochez d’un account manager pour vous permettre de créer un compte sur l’environnement Deliveroo.',
    'deliveroo.description.secondpart':
        'Une fois ce compte configuré, votre caisse recevra automatiquement les commandes Deliveroo dans la rubrique livraison.',
    'deliveroo.description.thirdpart':
        'Vous pourrez également procéder à la synchronisation de vos produits depuis l’interface Deliveroo.',
    'deliveroo.contact': 'Contactez un account manager',

    // Module Crous Configuration
    'crous.title': 'Paramétrage du module de synchronisation catalogue CROUS',
    'crous.description':
        'Choisissez le restaurant dont vous souhaitez importer le catalogue et entrez le numéro de caisse du CROUS communiqué par le client (pos_id)',
    'crous.listcrousrestaurants.label': 'Restaurants Crous',
    'crous.listcrousrestaurants.placeholder': 'Sélectionnez un restaurant',
    'crous.numerocaisse.label': 'Numéro de caisse du Crous',
    'crous.numerocaisse.placeholder': 'Veuillez saisir le numéro de caisse du Crous',
    'crous.apikey.label': 'Clé API du Crous',
    'crous.apikey.placeholder': 'Veuillez saisir la clé API du Crous',

    // Marketplace Common config
    'marketplace.vatdefault.placeholder': 'TVA par défaut (%)',
    'marketplace.vatdefault.message': 'TVA par défaut',
    'marketplace.storid.label': 'ID de vos locations :',
    'marketplace.storid.placeholder': 'Indiquer une / des locations ID',
    'marketplace.storid.unknown': 'ID de la boutique inconnu',
    'marketplace.storid.alreadyused': 'Cet UUID est déjà présent ({name})',
    'marketplace.activestorids.label': 'Marques virtuelles actives :',
    'marketplace.activestorids.emptystate': 'Vous n’avez aucune marque virtuelle d’active',
    'marketplace.location.title': 'Marque {counter}',
    'marketplace.location.delete': 'Supprimer',

    // Status
    'status.status': 'Statut',
    'status.active': 'Active',
    'status.inactive': 'Inactive',
    'status.disabled': 'Indisponible',
    'status.loading': 'Chargement',
    'status.unknown': 'Inconnu',
    'status.new': 'Nouveau',
    'status.file_uploaded': 'Fichier téléchargé',
    'status.processing': 'Traitement en cours',
    'status.done': 'Terminé',
    'status.error': 'Erreur',

    // Date
    'date.created': 'Date de création',
    'date.updated': 'Date de mise à jour',

    // External Pos Config
    'external_pos.pos_ref.label': 'ID du POS Deliverect :',
    'external_pos.pos_ref.placeholder': "Indiquer l'ID de votre POS Deliverect",
    'external_pos.title': 'Paramétrage du POS externe Deliverect',
    'external_pos.subtitle': 'Comment configurer mon POS externe Deliverect ?',
    'external_pos.description.firstpart':
        'Vous devez au préalable vous rapprochez d’un account manager pour vous permettre de créer un compte sur l’environnement Deliverect.',
    'external_pos.description.secondpart':
        'Une fois votre POS externe Deliverect configuré, il recevra les commandes passées sur les canaux Innovorder activés.',
    'external_pos.description.thirdpart':
        'Avec cette intégration, nous vous recommandons de gérer et synchroniser vos menus depuis Deliverect.',
    'external_pos.contact': 'Contactez un account manager',
    'external_pos.channels.title': 'Intégration POS externe Deliverect :',
    'external_pos.channels.subtitle': 'Canaux actifs :',

    // Webhook Config
    'webhook_url.label': 'Url du Webhook',
    'webhook_url.placeholder': 'URL du Webhook',
    'webhook_secret.label': 'Clé secrète du Webhook',
    'webhook_secret.placeholder': 'Indiquez la clé secrète du webhook',
    'webhook.headers.label': 'Headers HTTP additionnels',
    'webhook.headers.name.placeholder': 'Nom de header',
    'webhook.headers.value.placeholder': 'Valeur de header',
    'webhook.channels.title': 'Canaux de déclenchement Webhook',
    'webhook.channels.subtitle': 'Canaux disponibles :',
    'webhook.title': 'Configuration du webhook',
    'webhook.firstpart.subtitle': 'Rôle de ce webhook',
    'webhook.firstpart.description':
        "Le rôle de ce webhook est de notifier qu'une commande a été passée par un de vos convives sur Innovorder.\n" +
        'Si une vente s’opère pour un convive identifié par un badge alors un call est réalisé sur ce webhook pour lui envoyer les informations nécessaires concernant cette commande.',
    'webhook.secondpart.subtitle': 'Comment configurer le webhook ?',
    'webhook.secondpart.description':
        'Il faut renseigner l’URL du webhook.\n' +
        'La clé secrète du webhook est générée automatiquement.\n' +
        'Il suffit de cliquer sur les canaux à activer pour ce webhook.\n' +
        "Une fois configuré, le service doit renvoyer un code de réponse HTTP 200 avec un corps de réponse vide pour accuser réception de l'événement webhook.",
    'webhook.documentationLink': 'Consulter la documentation de ce webhook',
    'webhook.modal.warning': 'Attention',
    'webhook.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'webhook.channels.kiosk': 'Borne',
    'webhook.channels.web': 'CEL',
    'webhook.channels.pos': 'POS',
    'webhook.channels.trayScan': 'Scan Plateau',
    'webhook.channels.vendingMachine': 'Distribution\nautomatique',
    'webhook.eventTypes.title': "Types d'événements",
    'webhook.eventTypes.subtitle': "Types d'événements disponibles :",
    'webhook.brand.title': 'Paramétrage des webhooks',
    'webhook.brand.firstpart.subtitle': 'Rôle de ce webhook',
    'webhook.brand.firstpart.description':
        'Les webhooks vous permettent de recevoir des notifications en temps réel lorsque des événements spécifiques se produisent dans votre système Innovorder. Vous pouvez configurer des webhooks pour être déclenchés par différents événements tels que les mises à jour des données clients, les événements de transaction, ou les notifications de commandes. Quand un événement se produit, Innovorder enverra une requête HTTP POST à votre endpoint spécifié avec les données pertinentes',
    'webhook.brand.secondpart.subtitle': 'Comment configurer le webhook ?',
    'webhook.brand.secondpart.description':
        "1.Fournissez l'URL du webhook où vous souhaitez recevoir les notifications.\n2. Sélectionnez les types d'événements que vous voulez surveiller parmi les options disponibles.\n3. Choisissez les canaux où ces événements doivent déclencher le webhook.\n4. Ajoutez des en-têtes HTTP supplémentaires si requis par votre endpoint.\n5. La clé secrète du webhook est générée automatiquement pour la sécurité.\n\nVotre endpoint doit retourner un code de statut HTTP 200 pour confirmer la réception de l'événement webhook.",
    'webhook.system.badge': 'Système',
    'webhook.system.readonly': 'Ce webhook est géré par le système et ne peut pas être modifié.',

    // Login
    'login.panelTitle': 'Bienvenue sur votre Backoffice',
    'login.login': 'Se connecter',
    'login.password': 'Mot de passe',
    'login.ssoChecking': 'Vérification du SSO…',
    'login.ssoEnabled': 'Le SSO est activé pour cet email.',
    'login.ssoLogin': 'Se connecter avec SSO',
    'login.ssoFailed': 'Connexion SSO échouée. Veuillez réessayer.',
    'login.ssoLoginRequired': 'Ce compte nécessite une connexion SSO. Redirection en cours…',
    'login.noBrandsConfigured': "Aucune enseigne n'est configurée pour cet utilisateur.",
    'login.guestBrandLoginFailed': 'Échec de la connexion. Veuillez réessayer.',
    'login.rememberMe': 'Se souvenir de moi',
    'login.forgotPassword': 'Mot de passe oublié ?',
    'login.accountLocked': 'Compte temporairement bloqué. Réessayez dans {minutes} minutes.',
    'login.captchaRequired': 'Vérification de sécurité requise.',
    'login.ipNotAllowed': 'Connexion non autorisée depuis cette adresse IP.',
    'login.accountDisabled': 'Ce compte a été désactivé pour cause d’inactivité.',

    // Extend account
    'extendAccount.title': 'Prolongation de votre compte',
    'extendAccount.loadingBody': 'Vérification du lien en cours…',
    'extendAccount.successTitle': 'Compte prolongé',
    'extendAccount.successBody': 'Votre compte a bien été prolongé. Vous pouvez maintenant vous reconnecter.',
    'extendAccount.invalidTitle': 'Lien invalide',
    'extendAccount.invalidBody': 'Ce lien de prolongation est invalide ou a expiré.',
    'extendAccount.expiredHint': 'Pour récupérer l’accès à votre compte, contactez votre administrateur.',
    'extendAccount.missingTokenBody': 'Le lien est incomplet. Ouvrez à nouveau le lien depuis votre email.',
    'extendAccount.backToLogin': 'Retour à la connexion',

    // Forgot Password
    'forgotPassword.title': 'Mot de passe oublié',
    'forgotPassword.subtitle': 'Entrez votre email pour recevoir un lien de réinitialisation.',
    'forgotPassword.submit': 'Envoyer le lien',
    'forgotPassword.backToLogin': 'Retour à la connexion',
    'forgotPassword.successTitle': 'Email envoyé',
    'forgotPassword.successMessage':
        "Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception.",
    'forgotPassword.recaptchaLoading': 'Chargement de reCAPTCHA…',
    'forgotPassword.recaptchaFailed': 'Vérification reCAPTCHA échouée. Veuillez réessayer.',
    'forgotPassword.recaptchaUnavailable': 'reCAPTCHA indisponible. Rafraîchissez la page et réessayez.',
    'forgotPassword.recaptchaNotConfigured':
        "Configuration manquante (REACT_APP_RECAPTCHA_SITE_KEY). Contactez l'administrateur.",

    // Reset Password
    'resetPassword.title': 'Nouveau mot de passe',
    'resetPassword.subtitle': 'Choisissez un nouveau mot de passe pour votre compte.',
    'resetPassword.submit': 'Réinitialiser',
    'resetPassword.backToLogin': 'Retour à la connexion',
    'resetPassword.successTitle': 'Mot de passe mis à jour',
    'resetPassword.successMessage':
        'Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter.',
    'resetPassword.invalidLinkTitle': 'Lien invalide',
    'resetPassword.invalidLink':
        'Ce lien de réinitialisation est invalide ou a expiré. Demandez un nouveau lien depuis la page de connexion.',
    'resetPassword.passwordTooShort': 'Le mot de passe doit contenir au moins {min} caractères.',
    'resetPassword.passwordsMismatch': 'Les deux mots de passe ne correspondent pas.',

    // MFA
    'mfa.verify.title': 'Vérification en deux étapes',
    'mfa.verify.subtitle': "Entrez le code à 6 chiffres généré par votre application d'authentification.",
    'mfa.verify.backupTitle': 'Code de secours',
    'mfa.verify.backupSubtitle': 'Entrez un de vos codes de secours à usage unique.',
    'mfa.verify.submit': 'Vérifier',
    'mfa.verify.useBackupInstead': 'Utiliser un code de secours à la place',
    'mfa.verify.useTotpInstead': "Utiliser l'application d'authentification",
    'mfa.verify.useDifferentMethod': 'Utiliser une autre méthode',
    'mfa.verify.chooser.title': 'Choisir une méthode',
    'mfa.verify.chooser.subtitle': 'Quelle méthode souhaitez-vous utiliser pour vérifier votre identité ?',
    'mfa.verify.chooser.webauthnHint': 'Utilisez votre clé de sécurité ou votre biométrie.',
    'mfa.verify.chooser.totpHint': "Entrez le code de votre application d'authentification.",
    'mfa.verify.failed': 'Code invalide. Veuillez réessayer.',
    'mfa.verify.tokenExpired': 'La session MFA a expiré. Veuillez vous reconnecter.',
    'mfa.verify.tabs.totp': "Application d'authentification",
    'mfa.verify.tabs.webauthn': 'Clé de sécurité / biométrie',
    'mfa.verify.webauthn.title': 'Vérifier avec votre clé de sécurité',
    'mfa.verify.webauthn.subtitle':
        'Touchez votre clé de sécurité, utilisez Touch ID ou un autre authentificateur de la plateforme.',
    'mfa.verify.webauthn.authenticate': 'Authentifier',
    'mfa.verify.webauthn.failed': "Échec de l'authentification. Veuillez essayer une autre méthode.",
    'mfa.verify.webauthn.noCredentials': "Aucune clé de sécurité n'est enregistrée pour ce compte.",
    'mfa.verify.webauthn.ceremonyFailed':
        "L'authentification a été annulée ou votre navigateur l'a refusée. Veuillez réessayer.",
    'mfa.setup.title': "Configurer l'authentification à deux facteurs",
    'mfa.setup.subtitle':
        "Scannez ce QR code avec votre application d'authentification (Google Authenticator, 1Password, etc.) puis entrez le code généré.",
    'mfa.setup.loadingQr': 'Chargement du QR code...',
    'mfa.setup.copySecret': 'Copier la clé secrète',
    'mfa.setup.copied': 'Copié !',
    'mfa.setup.confirm': 'Confirmer',
    'mfa.setup.invalidCode': 'Code invalide. Vérifiez la synchronisation de votre application.',
    'mfa.setup.backupTitle': 'Sauvegardez vos codes de secours',
    'mfa.setup.backupSubtitle':
        "Conservez ces codes dans un endroit sûr. Ils vous permettront de vous connecter si vous perdez l'accès à votre application d'authentification. Chaque code ne peut être utilisé qu'une seule fois.",
    'mfa.setup.backupAcknowledge': "J'ai sauvegardé mes codes, continuer",
    'mfa.setup.tabs.totp': "Application d'authentification",
    'mfa.setup.tabs.webauthn': 'Clé de sécurité / biométrie',
    'mfa.setup.webauthn.title': 'Enregistrer une clé de sécurité',
    'mfa.setup.webauthn.subtitle':
        "Utilisez une clé matérielle (YubiKey), Touch ID, Windows Hello ou un autre authentificateur. Vous pouvez nommer cet appareil pour l'identifier plus tard.",
    'mfa.setup.webauthn.deviceNamePlaceholder': "Nom de l'appareil (ex. 'Mon ordinateur')",
    'mfa.setup.webauthn.register': 'Enregistrer',
    'mfa.setup.webauthn.ceremonyFailed':
        "L'enregistrement a été annulé ou votre navigateur l'a refusé. Veuillez réessayer.",
    'mfa.setup.webauthn.finalizing': 'Finalisation de votre clé de sécurité…',

    // Activate Account
    'activateAccount.title': 'Activation de compte',
    'activateAccount.submit': 'Activer mon compte',
    'activateAccount.submitting': 'Activation en cours...',
    'activateAccount.loading': 'Vérification du token...',
    'activateAccount.resend': "Renvoyer l'email d'activation",
    'activateAccount.resending': 'Renvoi en cours...',
    'activateAccount.renewSuccess':
        "Un nouvel email d'activation a été envoyé. Veuillez vérifier votre boîte de réception.",
    'activateAccount.error.missingToken': 'Token manquant',
    'activateAccount.error.invalidToken': 'Token expiré',
    'activateAccount.error.password.minLength': 'Le mot de passe doit contenir au moins {min} caractères',
    'activateAccount.error.password.maxLength': 'Le mot de passe ne doit pas dépasser {max} caractères',
    'activateAccount.error.password.requireUppercase': 'Le mot de passe doit contenir au moins une majuscule',
    'activateAccount.error.password.requireLowercase': 'Le mot de passe doit contenir au moins une minuscule',
    'activateAccount.error.password.requireNumbers': 'Le mot de passe doit contenir au moins un chiffre',
    'activateAccount.error.password.requireSpecialCharacters':
        'Le mot de passe doit contenir au moins un caractère spécial',
    'activateAccount.password.placeholder': 'Mot de passe',
    'activateAccount.confirmPassword.placeholder': 'Confirmer le mot de passe',

    // SideBar
    'sidebar.overview': "Vue d'ensemble",
    'sidebar.orders': 'Commandes',
    'sidebar.customers': 'Clients',
    'sidebar.brand': 'Enseigne',
    'sidebar.brands': 'Enseignes',
    'sidebar.restaurants': 'Restaurants',
    'sidebar.loyalty': 'Fidélité',
    'sidebar.coupons': 'Codes promo',
    'sidebar.paymentMeans': 'Moyens de paiement',
    'sidebar.integrations': 'Intégrations',
    'sidebar.reports': 'Rapports',
    'sidebar.reportsSales': 'Ventes',
    'sidebar.reportsEwallets': 'Soldes Badges',
    'sidebar.monthly_sales_report': 'Rapport des ventes mensuels',
    'sidebar.exports': 'Exports',
    'sidebar.exportsAccounting': 'Comptable',
    'sidebar.exportsEwallets': 'E-wallet',
    'sidebar.exportsSales': 'Synthèse financière',
    'sidebar.salesSummary': 'Synthèse financière',
    'sidebar.exportsPreInvoicing': 'Pré-facturation',
    'sidebar.exportsBadge': 'Mouvements des badges',
    'sidebar.reportGenerationsHistory': 'Historique des générations',
    'sidebar.help': "Besoin d'aide ?",
    'sidebar.languages': 'Langues',
    'sidebar.account': 'Mon compte',
    'sidebar.media': 'Médias',
    'sidebar.marketplaces': 'Marketplaces',
    'sidebar.urssaf': 'Minimum Urssaf',
    'sidebar.vatRatesMatrix': 'Référentiel TVA',
    'sidebar.autoBilling': 'Facturation automatique',
    'sidebar.logout': 'Se déconnecter',
    'sidebar.password': 'Mon mot de passe',
    'sidebar.security': 'Sécurité',
    'security.title': 'Sécurité',
    'security.loading': 'Chargement…',
    'security.actions.remove': 'Supprimer',
    'security.actions.cancel': 'Annuler',
    'security.totp.title': "Application d'authentification",
    'security.totp.subtitle':
        'Codes à usage unique générés par une application comme Google Authenticator ou 1Password.',
    'security.totp.label': "Application d'authentification",
    'security.totp.added': 'Ajouté le {date}',
    'security.totp.empty': "Aucune application d'authentification configurée.",
    'security.totp.add': "Ajouter une application d'authentification",
    'security.totp.modalTitle': "Configurer une application d'authentification",
    'security.totp.confirmRemove': "Êtes-vous sûr de vouloir supprimer votre application d'authentification ?",
    'security.passkeys.title': 'Clés de sécurité et passkeys',
    'security.passkeys.subtitle':
        'Clés matérielles, Touch ID, Windows Hello et autres authentificateurs enregistrés pour ce compte.',
    'security.passkeys.empty': 'Aucune clé de sécurité enregistrée.',
    'security.passkeys.unnamedDevice': 'Appareil sans nom',
    'security.passkeys.lastUsed': 'Dernière utilisation : {date}',
    'security.passkeys.added': 'Ajoutée le {date}',
    'security.passkeys.add': 'Ajouter une clé de sécurité',
    'security.passkeys.confirmRemove':
        'Êtes-vous sûr de vouloir supprimer cette clé ? Vous ne pourrez plus utiliser cet appareil pour vous connecter.',
    'security.passkeys.ceremonyFailed':
        "L'enregistrement a été annulé ou votre navigateur l'a refusé. Veuillez réessayer.",
    'security.passkeys.requestFailed': 'Une erreur est survenue. Veuillez réessayer.',
    'security.allowedIps.title': 'Adresses IP autorisées',
    'security.allowedIps.subtitle':
        "Limitez votre connexion à une liste d'IP ou de plages CIDR. Les IP autorisées contournent aussi les CAPTCHA et compteurs d'échec.",
    'security.allowedIps.empty': 'Aucune restriction. Vous pouvez vous connecter depuis n’importe quelle adresse IP.',
    'security.allowedIps.add': 'Ajouter',
    'security.allowedIps.placeholder': '192.168.1.1 ou 10.0.0.0/24',
    'security.allowedIps.invalid': 'Adresse IP ou plage CIDR invalide.',
    'security.allowedIps.confirmRemoveTitle': 'Retirer cette adresse IP ?',
    'security.allowedIps.confirmRemove': 'Cette adresse ne sera plus autorisée à se connecter à votre compte.',
    'security.allowedIps.cancel': 'Annuler',
    'security.allowedIps.warning':
        'Attention : tant que la liste contient au moins une entrée, vous ne pourrez plus vous connecter depuis une autre IP.',
    'sidebar.billing': 'Mon espace facturation',
    'sidebar.ioPay': 'Paiements',
    'sidebar.news': 'Nouveautés',
    'sidebar.analytics': 'Analytics',

    // Messages
    'message.message': 'Message',

    // Names
    'name.name': 'Nom',
    'name.firstName': 'Prénom',
    'name.lastName': 'Nom',

    // Not found
    'notFound.message': 'Désolé, votre page est introuvable.',
    'notFound.backToHome': 'Revenir à l’accueil',
    'permissionDenied.title': 'Accès interdit',
    'permissionDenied.message': 'Nous sommes désolés, mais vous n’avez pas la permission d’accéder à cette page.',
    'permissionDenied.backToHome': 'Revenir à l’accueil',

    // Error page
    'errorPage.message':
        'Nous sommes désolés, nous rencontrons une difficulté technique. Nous mettons tout en oeuvre pour résoudre ce problème !',
    'errorPage.support': 'Contactez notre support',

    // Files
    'file.noFile': 'Aucun fichier',
    'file.cannotProcessJson': 'Le fichier JSON ne peut pas être traité. Vérifiez son format.',
    'file.fileNotAllowed': "Ce type de fichier n'est pas autorisé. Extensions autorisées : {allowedExtensionsString}",
    'file.fileTemplate': 'modèle de fichier',
    'file.metabaseLink': 'lien metabase',

    // File input
    'fileInput.placeholder.title': 'Insérez vos fichiers !',
    'fileInput.placeholder.drop': 'Déposez vos fichiers ici !',
    'fileInput.placeholder': 'Glissez et déposez un ou des fichiers dans la fenêtre',
    'fileInput.browse': 'Importer depuis votre ordinateur',

    // Image input
    'imageInput.section.modal.title': 'Ajouter une image',
    'imageInput.section.modal.resize.label': 'Mode image de fond',
    'imageInput.section.modal.resize.details':
        'Utilisez cette option lorsque vous envoyez des images qui seront utilisées comme arrière-plan pour des bornes ou la commande en ligne.',
    'imageInput.section.library.title': 'Depuis la galerie',
    'imageInput.section.upload.title': 'Depuis mon ordinateur',

    // Languages
    'languages.fr_FR': 'Français',
    'languages.en_EN': 'Anglais',
    'languages.it_IT': 'Italien',
    'languages.sodexo_SODEXO': 'Sodexo',
    'languages.es_ES': 'Espagnol',
    'languages.zh-CN_ZH-CN': 'Chinois (Simplifié)',
    'languages.zh-TW_ZH-TW': 'Chinois (Traditionnel)',
    'languages.ar_AR': 'Arabe',
    'languages.de_DE': 'Allemand',

    // UI
    'button.add': 'Ajouter',
    'button.delete': 'Supprimer',
    'button.edit': 'Modifier',
    'button.configure': 'Configurer',
    'button.cancel': 'Annuler',
    'button.close': 'Fermer',
    'button.generate': 'Générer',
    'button.save': 'Enregistrer',
    'button.import': 'Importer',
    'button.publish': 'Publier',
    'button.saveAndPublish': 'Enregistrer et publier',
    'button.uploadFile': 'Télécharger un fichier',
    'button.previous': 'Précédent',
    'button.next': 'Suivant',
    'button.ok': 'OK',
    'button.validate': 'Valider',
    'button.refresh': 'Rafraîchir',
    'button.confirm': 'Confirmer',
    'button.yes': 'Oui',
    'button.understand': 'J’ai compris',
    'button.convertToCrossSell': 'Convertir en vente additionnelle',
    'button.convertToCustomization': 'Convertir en personnalisation',
    'button.skipStep': 'Ignorer cette étape',
    'button.block': 'Bloquer',
    'button.unblock': 'Débloquer',
    'select.selectAll': 'Tout sélectionner',
    'switch.activate': 'Activer',
    'form.preventLeave': 'Vous avez des modifications non sauvegardées, êtes-vous sûr de vouloir quitter cette page ?',
    'field.required': 'Ce champ est requis',
    'field.optional': '(optionnel)',
    'field.greaterThanZero': 'Ce champ doit être supérieur à 0',
    'field.invalidEmail': 'Ce mail est invalide',
    'field.invalidURL': 'Cet URL est invalide',
    'field.atLeastOneEventType': "Au moins un type d'événement doit être sélectionné",
    'field.unmatchedPassword': 'Les deux mots de passe doivent être indentiques',
    'field.invalidPassword': 'votre mot de passe doit compter au moins 8 caractères',
    'field.invalidPhoneNumber': 'Numéro de téléphone invalide',
    'field.duplicate_email': 'Cet e-mail existe déjà',
    'field.duplicate_student_number': 'Ce N° Convive existe déjà',
    'field.duplicate_badge_number': 'Ce N° de badge existe déjà',
    'field.minTwo': 'Ce champ doit compter au moins 2 caractères',
    'field.ewallet_is_not_null_to_postpayment':
        'Pour convertir le convive en type de compte post-payeur, son solde doit obligatoirement être à 0€',
    'select.enabled': 'Activé',
    'select.customised': 'Personnalisé',
    'select.disabled': 'Désactivé',
    'table.search': 'Rechercher',
    'table.searchColumn': 'Rechercher {name}',
    'table.searchColumn.placeholder': 'Rechercher une valeur',
    'table.searchColumn.placeholder.from': 'Min',
    'table.searchColumn.placeholder.to': 'Max',
    'table.searchColumn.clearFilter': 'Retirer filtres',
    'table.clearAllFilters': 'Retirer tous les filtres',
    'table.rowsPerPage': 'Lignes par page',
    'table.firstPage': 'Première',
    'table.lastPage': 'Dernière',
    'table.noRowsAfterFilter': 'Aucun résultat ne correspond à votre recherche',
    'table.noRowsAfterFilter.dateRangeHint': 'Avez-vous essayé de changer la plage de dates ?',
    'table.noRowsAfterFilter.dateRangePresetHint': 'Pas de résultats sur les {days} derniers jours.',
    'table.noRowsAfterFilter.dateRangeCustomHint': 'Pas de résultats sur la période sélectionnée.',
    'table.noRowsAfterFilter.dateRangeAction': 'Modifiez la fenêtre de dates pour afficher des commandes.',
    'table.sort': 'Tri par {name}',
    'table.columnSelection.button': 'Gestion colonne',
    'table.columnSelection.buttonFiltered': 'Gestion colonne ({count})',
    'table.columnSelection.header': 'Filtrer les colonnes',
    'table.columnSelection.placeholder': 'Rechercher une colonne',
    'table.columnSelection.allEntries': 'Toutes les colonnes',
    'table.selection.count':
        '{count} ligne{count, plural, =1 {} other {s}} sélectionnée{count, plural, =1 {} other {s}}',
    'table.empty': 'Aucune donnée disponible',
    'pagination.previous': 'Précédent',
    'pagination.next': 'Suivant',
    'navigation.back': 'Retour',
    'navigation.next': 'Suivant',
    'navigation.disabled': 'Retour',
    'navigation.backToV1': "Retourner à l'ancienne version",
    'savingBar.changesDone':
        '{changesCount, plural, =0 {} one {# modification effectuée} other {# modifications effectuées}}',
    'ticketLabel.name.mismatch.confirmation':
        'Attention, le nom du produit a été changé, mais le libellé de production est resté le même. Confirmez-vous ce changement ?',

    // Form
    'form.validation.integer': 'Ce champ doit être un entier',
    'form.validation.positive': 'Ce champ doit être positif',
    'form.validation.positiveOrZero': 'Ce champ doit être positif ou égal à zéro',
    'form.validation.length': 'Ce champ doit contenir {length} caractères',
    'form.validation.maxLength': 'Ce champ dépasse la taille autorisée',
    'form.validation.email': 'Ce champ doit être un email valide',
    'form.validation.mustMatchValue': 'Ce champ doit être {value1} ou {value2 }',
    'form.validation.siret.length': 'Le numéro SIRET doit avoir une longueur de 14 caractères (sans espaces)',
    'form.validation.siret.invalid': 'Le numéro SIRET est invalide',

    // Integrations
    'integrations.section.title': 'Solutions de paiement',
    'integrations.section.subtitle':
        'Les solutions de paiement vous permettent d’offrir des fonctionnalités telles que le paiement en ligne par carte bancaire ou sur TPE en point de vente.',
    'integrations.stripe': 'Stripe',
    'integrations.stripeDescription':
        'Intégrez Stripe à votre site et permettez à vos clients de connecter facilement leur compte pour une expérience de commande en ligne optimale.',
    'integrations.configured': 'Configuré',
    'integrations.notConfigured': 'Non configuré',
    'integrations.webhooks.title': 'Webhooks',
    'integrations.webhooks.description':
        'Les différentes intégrations Webhook sont listées ici. Il est possible de créer un nouveau Webhook en cliquant sur le bouton "+" ou de modifier un Webhook existant en cliquant dessus. Un statut permet de visualiser l\'état de configuration.',

    // Pricing Rule
    'pricingRule.emptyMessage': 'Aucun régime tarifaire affilié à cette enseigne.',
    'pricingRule.tableCard.title': 'Régimes tarifaires',
    'pricingRule.tableCard.subtitle':
        'Les régimes tarifaires sont des ensembles d’une ou plusieurs admission(s), subvention(s) et composant(s) hors CA.',
    'pricingRule.tableCard.description': `Si le régime tarifaire contient une subvention en % et une subvention en €, placez la subvention qui doit être déduite sur l'ensemble du montant de la commande en première position. Les subventions suivantes porteront sur le montant restant à payer, après déduction des subventions placées avant.`,
    'pricingRule.tableCard.action': '+ Créer un nouveau régime',
    'pricingRule.code': 'Code',
    'pricingRule.applyScope': 'Stratégie',
    'pricingRule.strategy': 'Stratégie',
    'pricingRule.labelTicket': 'Label du ticket',
    'pricingRule.grants_fees.amount': 'Montant',
    'pricingRule.grants_fees.dailyLimit': 'Limite journalière',
    'pricingRule.grants': 'Subventions',
    'pricingRule.entranceFees': 'Admissions',
    'pricingRule.excludedTurnover': 'Hors CA',
    'pricingRule.associatedPricingRules': 'Régimes tarifaires associés',
    'pricingRule.action': 'Action',
    'pricingRule.product': 'Part alimentaire',
    'pricingRule.fee': "Frais dont droit d'entrée",
    'pricingRule.modal.warning': 'Attention',
    'pricingRule.modal.required': 'Le champ `Régime tarifaire` est obligatoire',
    'pricingRule.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'pricingRule.modal.delete.error.detail': 'Ce régime tarifaire est lié à un ou plusieurs convives',
    'pricingRule.modal.unassociatedUser': "convive n'aura plus de régime tarifaire",
    'pricingRule.modal.unassociatedUsers': "convives n'auront plus de régime tarifaire",
    'pricingRule.form.title': 'Régime tarifaire',
    'pricingRule.form.description':
        'Configurez le régime tarifaire en groupant les subventions existantes de votre choix.',
    'pricingRule.form.creation': 'Création d’un régime tarifaire',
    'pricingRule.form.update': 'Modification d’un régime tarifaire',
    'pricingRule.form.pricingRuleCode': 'Code régime tarifaire',
    'pricingRule.form.applyScope': 'Stratégie',
    'pricingRule.form.authorizedChannels': 'Canaux autorisés',
    'pricingRule.form.isUrssafEnabled': 'Appliquer le minimum URSSAF à ce régime tarifaire ?',
    'pricingRule.form.composition': 'Définissez la composition de ce régime tarifaire',
    'pricingRule.form.compositionDescription':
        'Les régimes tarifaires sont des ensembles d’une ou plusieurs admission(s), subvention(s) et composant(s) hors CA.',
    'pricingRule.emptyGrant': 'Aucune subvention associée à ce régime tarifaire.',
    'pricingRule.emptyEntranceFee': 'Aucun admission associée à ce régime tarifaire.',
    'pricingRule.emptyTurnoverExcluded': 'Aucun composant hors CA associé à ce régime tarifaire.',
    'pricingRule.emptyAssociatedPricingRule': 'Aucun régime tarifaire associé à ce régime tarifaire.',
    'pricingRule.noResult': 'Aucun résultat',
    'pricingRule.addGrant': 'Ajouter une subvention',
    'pricingRule.addEntranceFee': 'Ajouter une admission',
    'pricingRule.addComponentWithoutTurnover': 'Ajouter un composant hors CA',
    'pricingRule.addAssociatedPricingRule': 'Ajouter un régime tarifaire associé',
    'pricingRule.search': 'Rechercher un régime tarifaire',
    'pricingRule.channels.kiosk': 'Borne',
    'pricingRule.channels.pos': 'Caisse',
    'pricingRule.channels.web': 'Commande en ligne',
    'pricingRule.channels.ewalletKiosk': 'Borne de rechargement',
    'pricingRule.channels.vendingMachine': 'Distribution automatique',
    'pricingRule.action.import': 'Importer',
    'pricingRule.action.export': 'Exporter',
    'pricingRule.modal.import.title': 'Importer des admissions, subventions et régimes tarifaires',
    'pricingRule.modal.import.firstPart': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'pricingRule.modal.import.secondPart':
        'Remplir le fichier modèle avec les informations de vos admissions, subventions et régimes tarifaires à ajouter ou modifier',
    'pricingRule.modal.import.thirdPart': 'Importer votre nouveau fichier en cliquant sur le bouton ci-dessous',
    'pricingRule.modal.import.warning':
        "La suppression d'une admission, subvention ou d'un régime tarifaire se fait uniquement depuis le backoffice Innovorder",
    'pricingRule.modal.import.secondWarning':
        "⚠️\nL'import d'admission ou de subvention supprime DÉFINITIVEMENT les valeurs personnalisées. \n(les valeurs personnalisées par restaurant ou par service)\n",
    'pricingRule.modal.import.report.title': "Rapport de l'import",
    'pricingRule.modal.import.report.result': "Résultat de l'import",
    'pricingRule.modal.import.report.success': 'Succès',
    'pricingRule.modal.import.report.error': 'Echec',
    'pricingRule.modal.import.report.warning': 'Alerte',
    'pricingRule.modal.import.report.entranceFees': 'Admissions',
    'pricingRule.modal.import.report.grants': 'Subventions',
    'pricingRule.modal.import.report.pricingRules': 'Régimes tarifaires',
    'pricingRule.modal.import.report.successMessage': '• création: {created}\n • modification: {updated}',
    'pricingRule.modal.import.report.errorMessage': '• Ligne {line} - {field}: {message}',

    'pricingRule.export.report.entranceFee.entranceFeeId': "Identifiant de l'admission",
    'pricingRule.export.report.entranceFee.code': 'Code admission',
    'pricingRule.export.report.entranceFee.labelTicket': 'Label du ticket',
    'pricingRule.export.report.entranceFee.amount': 'Montant (en €)',
    'pricingRule.export.report.entranceFee.dailyLimit': 'Limite journalière',
    'pricingRule.export.report.entranceFee.strategy':
        'Stratégie (1 pour toujours / 2 pour limite journalière + produit affecté)',
    'pricingRule.export.report.entranceFee.vat': 'TVA',
    'pricingRule.export.report.entranceFee.type': "Chiffre d'affaires (inclus/exclus)",
    'pricingRule.export.report.entranceFee.type.admissionfee': 'inclus',
    'pricingRule.export.report.entranceFee.type.royaltyfee': 'exclus',
    'pricingRule.export.report.entranceFee.active':
        'Actif sur tous les restaurants par défaut (oui / non) (concerne uniquement la création)',

    'pricingRule.export.report.grant.grantId': 'Identifiant de la subvention',
    'pricingRule.export.report.grant.code': 'Code subvention',
    'pricingRule.export.report.grant.labelTicket': 'Label du ticket',
    'pricingRule.export.report.grant.threshold': 'Seuil de déclenchement en € (vide si aucun)',
    'pricingRule.export.report.grant.type': 'Type de montant (Absolu / Pourcentage)',
    'pricingRule.export.report.grant.type.absolute': 'Absolu',
    'pricingRule.export.report.grant.type.rate': 'Pourcentage',
    'pricingRule.export.report.grant.ceiling': 'Plafond de subvention en € (obligatoire si type = Pourcentage)',
    'pricingRule.export.report.grant.amount': 'Montant (en €)',
    'pricingRule.export.report.grant.dailyLimit': 'Limite journalière',
    'pricingRule.export.report.grant.strategy':
        'Stratégie (1 pour limite journalière + montant / 2 pour limite journalière + montant + produits affectés)',
    'pricingRule.export.report.grant.tag': "Tags (vide si pas d'applications sur tag)",
    'pricingRule.export.report.grant.active': 'Actif sur tous les restaurants par défaut (oui / non)',

    'pricingRule.export.report.pricingRule.pricingRuleId': 'Identifiant du régime tarifaire',
    'pricingRule.export.report.pricingRule.code': 'Code régime tarifaire',
    'pricingRule.export.report.pricingRule.canals':
        'Canaux (caisse, borne de rechargement, distribution automatique, borne et/ou commande en ligne)',
    'pricingRule.export.report.pricingRule.isUrssafEnabled':
        "Appliquer le minimum URSSAF(uniquement pour l'API panier) ? (oui/non)",
    'pricingRule.export.report.pricingRule.entranceFees':
        'Admission(s) comprises (indiquer le code et si plusieurs, séparer par une virgule + espace)',
    'pricingRule.export.report.pricingRule.grants':
        'Subvention(s) comprises (indiquer le code et si plusieurs, séparer par une virgule + espace)',
    'pricingRule.export.report.pricingRule.includeCA': 'Hors CA comprises',
    'pricingRule.export.report.pricingRule.applyScope': "Stratégie (frais dont droit d'entrée et/ou part alimentaire)",
    'pricingRule.export.report.pricingRule.applyScope.product': 'part alimentaire',
    'pricingRule.export.report.pricingRule.applyScope.fee': "frais dont droit d'entrée",

    // EntranceFee
    'entranceFee.create': 'Création d’une admission',
    'entranceFee.title': 'Admission',
    'entranceFee.description':
        'Indiquez le nom, le montant et les régles, de l‘admission pour l’ensemble de vos établissements.',
    'entranceFee.customUse': 'Applications particulières de l’admission',
    'entranceFee.descCustomUse': 'Activation et personnalisation par restaurant de l’admission',
    'entranceFee.warningForm': `Complétez bien tous les champs de votre admission avant de l'activer sur vos restaurants.`,
    'entranceFee.default': 'Par défaut',
    'entranceFee.code': 'Code admission',
    'entranceFee.codeAlreadyUsed': 'Code admission déjà utilisé',
    'entranceFee.labelTicket': 'Label du ticket',
    'entranceFee.amount': 'Montant',
    'entranceFee.vat': 'Tva',
    'entranceFee.strategy': 'Stratégie',
    'entranceFee.dailyLimit': 'Limite journalière',
    'entranceFee.type': "Chiffre d'affaires",
    'entranceFee.select.always': 'Limite journalière',
    'entranceFee.select.daily': 'Limite journalière + produit affecté',
    'entranceFee.select.salesExcluded': 'Exclus',
    'entranceFee.select.salesIncluded': 'Inclus',
    'entranceFee.emptyMessage': "Aucun frais d'admission affilié à cette enseigne.",
    'entranceFee.table.state': "État d'activation",
    'entranceFee.table.services': 'Services activés',
    'entranceFee.table.state.enabled': 'Activé',
    'entranceFee.table.state.customised': 'Activé avec valeurs personnalisées',
    'entranceFee.table.state.disabled': 'Désactivé',
    'entranceFee.tableCard.title': 'Admissions',
    'entranceFee.tableCard.subtitle': 'Créez et gérez les différents frais d’admissions utilisés dans vos restaurants',
    'entranceFee.tableCard.action': '+ Créer une nouvelle admission',
    'entranceFee.restaurants': 'Restaurants',
    'entranceFee.restaurant': 'Restaurant',
    'entranceFee.action': 'Action',
    'entranceFee.modal.warning': 'Attention',
    'entranceFee.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'entranceFee.search': 'Rechercher une admission',

    'entranceFee.configuration.title': `Application particulière d'admission - {name}`,
    'entranceFee.configuration.header.title': 'Gérer les services de ce restaurant',
    'entranceFee.configuration.search': 'Rechercher un service',
    'entranceFee.configuration.table.activation': 'Activation',
    'entranceFee.configuration.table.name': 'Nom du service',
    'entranceFee.configuration.table.time': 'Horaires',
    'entranceFee.configuration.table.days': 'Période',
    'entranceFee.configuration.table.amount': 'Montant',
    'entranceFee.configuration.table.vat': 'TVA',
    'entranceFee.configuration.table.defaultShift': 'Service par défaut',
    'entranceFee.warningShifts.title': 'Confirmation de la modification',
    'entranceFee.warningShifts.shift': 'Service : {time} - Montant : {amount} - Différence : {variation}',
    'entranceFee.warningShifts.shift.amount': "\nMontant de l'admission : {amount}",
    'entranceFee.warningShifts.confirm': 'Êtes-vous sûr de vouloir continuer ?',

    // Grant
    'grant.create': 'Création d’une subvention',
    'grant.title': 'Subvention',
    'grant.description':
        'Indiquez le montant et les règles d’application de la subvention pour l’ensemble de vos établissements.',
    'grant.description.title1': 'Stratégie 1 : Limite journalière + montant',
    'grant.customUse': 'Applications particulières de la subvention',
    'grant.descCustomUse': 'Activation et personnalisation par restaurant de la subvention',
    'grant.warningLimit': '⚠️ La limite journalière personnalisée ne peut être supérieure à celle définie par défaut.',
    'grant.warningForm': `Complétez bien tous les champs de votre subvention avant de l'activer sur vos restaurants.`,
    'grant.desc1': `La subvention s’applique sur tous les produits du panier en respectant les règles suivantes :
        Si un seuil est défini, seul le montant du panier supérieur au seuil est impacté.
        Si un plafond est défini, le montant de la subvention ne pourra pas dépasser ce montant.
        Si un tag est défini, seuls les produits ayant ce tag seront impactés par la subvention.
        `,
    'grant.description.title2': 'Stratégie 2 : Limite journalière + montant + produits affectés',
    'grant.desc2': `La subvention s’applique suivant les mêmes règles ci-dessus, mais en plus :
    Si la subvention est en %, seuls les produits indiqués comme subventionnables seront affectés.
    Si la subvention est en €, elle se déclenche seulement si son panier contient au moins 1 produit indiqué comme subventionnable.`,
    'grant.amount': 'Montant',
    'grant.default': 'Par défaut',
    'grant.code': 'Code subvention',
    'grant.codeAlreadyUsed': 'Code subvention déjà utilisé',
    'grant.strategy': 'Stratégie',
    'grant.dailyLimit': 'Limite journalière',
    'grant.type': 'Type de montant',
    'grant.tags': 'Appliquer uniquement aux produits avec le tag suivant :',
    'grant.tags.placeholder': 'SUB1, SUB2',
    'grant.labelTicket': 'Label du ticket',
    'grant.select.rate': 'Pourcentage',
    'grant.select.absolute': 'Absolu',
    'grant.select.minimum': 'Limite journalière + montant',
    'grant.select.minimumAndProduct': 'Limite journalière + montant minimum + produits affectés',
    'grant.threshold': 'Seuil de déclenchement',
    'grant.ceiling': 'Plafond de subvention',
    'grant.restaurants': 'Restaurants',
    'grant.action': 'Action',
    'grant.emptyMessage': 'Aucune subvention affiliée à cette enseigne.',
    'grant.tableCard.title': 'Subventions',
    'grant.tableCard.subtitle': 'Créez et gérez les différentes subventions utilisées dans vos restaurants',
    'grant.tableCard.action': '+ Ajouter une nouvelle subvention',
    'grant.settings.button': 'Paramètres',
    'grant.settings.modal.title': 'Paramètres des subventions',
    'grant.settings.modal.subtitle': 'Configurez les règles applicables aux subventions de votre enseigne.',
    'grant.settings.modal.toggle.label': 'Bloquer le paiement en titres-restaurant lorsqu’une subvention est appliquée',
    'grant.settings.modal.toggle.description':
        'Si activée, les moyens de paiement en titres-restaurant (Edenred, Paygreen) seront indisponibles pour les convives dont le panier contient une subvention, sur la commande en ligne (CELV2).',
    'grant.settings.modal.cancel': 'Annuler',
    'grant.settings.modal.save': 'Enregistrer',
    'grant.table.enabled': 'Activer',
    'grant.table.state': "État d'activation",
    'grant.table.services': 'Services activés',
    'grant.table.state.enabled': 'Activé',
    'grant.table.state.customised': 'Activé avec valeurs personnalisées',
    'grant.table.state.disabled': 'Désactivé',
    'grant.table.restaurant': 'Restaurant',
    'grant.table.threshold': 'Déclenchement',
    'grant.table.ceiling': 'Plafond',
    'grant.table.dailyLimit': 'Limite journalière',
    'grant.table.strategy': 'Stratégie',
    'grant.table.action': 'Action',
    'grant.modal.warning': 'Attention',
    'grant.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'grant.search': 'Rechercher une subvention',

    'grant.configuration.title': 'Application particulière de subvention - {name}',
    'grant.configuration.header.title': 'Gérer les services de ce restaurant',
    'grant.configuration.search': 'Rechercher un service',
    'grant.configuration.table.activation': 'Activation',
    'grant.configuration.table.name': 'Nom du service',
    'grant.configuration.table.time': 'Horaires',
    'grant.configuration.table.days': 'Période',
    'grant.configuration.table.amount': 'Montant',
    'grant.configuration.table.threshold': 'Déclenchement',
    'grant.configuration.table.ceiling': 'Plafond',
    'grant.configuration.table.defaultShift': 'Service par défaut',

    'grant.warningShifts.title': 'Confirmation de la modification',
    'grant.warningShifts.shift': '{time} - Montant : {amount} - Différence : {variation}',
    'grant.warningShifts.shift.amount': '\nMontant de la subvention : {amount}',
    'grant.warningShifts.confirm': 'Êtes-vous sûr de vouloir continuer ?',

    // Groups
    'group.tableCard.title': 'Groupes',
    'group.tableCard.action': '+ Créer un nouveau groupe',
    'group.tableCard.subtitle':
        'Définissez les possibilités de regroupement de vos convives par groupe et associez y les différents régimes tarifaires.',
    'group.tableCard.subtitle2': "Définissez ici les différentes possibilités d'organisation de vos convives.",
    'group.emptyMessage': 'Aucun groupe affilié à cette enseigne.',
    'group.name': 'Groupe',
    'group.action': 'Action',
    'group.pricingRules': 'Régimes tarifaires',
    'group.guestsCount': 'Nombre de convive(s)',
    'group.guestsCountLabel': 'convive(s)',
    'group.modal.warning': 'Attention',
    'group.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'group.modal.deleteError': 'Vous ne pouvez pas supprimer ce groupe.',
    'group.modal.deleteErrorReason':
        'Veuillez désaffecter le(s) convive(s) associé(s) afin de finaliser cette suppression.',
    'group.warning.group_name_already_exist.message': 'Le nom du groupe existe déjà.',
    'group.warning.group_name_already_exist.description':
        'Veuillez proposer un nouveau nom de groupe ou associer le(s) régime(s) tarifaire(s) sélectionné(s) au groupe déjà existant.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.message':
        'Un ou plusieurs régimes tarifaires que vous souhaitez désassocier du groupe courant sont affectés à des convives existants.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.description':
        'Veuillez désaffecter ce ou ces régimes tarifaires des convives existants avant de pouvoir les supprimer de la liste des régimes tarifaires disponibles pour le groupe',
    'group.modal.import.title': 'Importer des Groupes, Sections, Sous-sections et Régimes Tarifaires',
    'group.modal.import.firstPart': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'group.modal.import.secondPart':
        'Remplir le fichier modèle avec les informations de vos groupes, sections, sous-sections et régimes tarifaires à ajouter ou modifier',
    'group.modal.import.thirdPart': 'Importer votre nouveau fichier en cliquant sur le bouton ci-dessous',
    'group.modal.import.warning':
        "La suppression d'un groupes, sections, sous-sections et régimes tarifaires se fait uniquement depuis le backoffice Innovorder",
    'group.modal.import.report.title': "Rapport de l'import",
    'group.export.group': 'Groupe',
    'group.export.section': 'Section',
    'group.export.subsection': 'Sous-section',
    'group.export.pricingRule': 'Régime(s) tarifaire(s) associés',
    'group.modal.conflict.error.message': 'Vous ne pouvez pas modifier ce groupe',
    'group.modal.conflict.error.description': 'Veuillez réaffecter le(s) convive(s) avant de modifier ce groupe',
    'group.modal.conflict.export.button': 'Exporter les convives',
    'group.modal.import.report.groups': 'Groupes',
    'group.modal.import.report.sections': 'Sections',
    'group.modal.import.report.subsections': 'Sous-sections',
    'group.modal.import.report.successMessage': '• création: {created}\n • modification: {updated}',
    'group.modal.import.report.errorMessage': '• Ligne {line} - colonne {field}: {message}',
    'group.delete.modal.conflict.error.message': 'Vous ne pouvez pas supprimer ce groupe',
    'group.delete.modal.conflict.error.description':
        'Veuillez réaffecter le(s) convive(s) avant de supprimer ce groupe',
    'group.delete.modal.conflict.export.button': 'Exporter les convives',

    'groups.export.student.customerId': 'Identifiant Client',
    'groups.export.student.email': 'Email',
    'groups.export.student.password': 'Mot de passe',
    'groups.export.student.firstName': 'Prénom',
    'groups.export.student.lastName': 'Nom',
    'groups.export.student.phone': 'Téléphone',
    'groups.export.student.piCode': 'Code pin',
    'groups.export.student.badgeNumber': 'N° badge',
    'groups.export.student.studentNumber': 'N° convive',
    'groups.export.student.group': 'Groupe',
    'groups.export.student.section': 'Section',
    'groups.export.student.subSection': 'Sous-section',
    'groups.export.student.accountType': 'Type de compte',
    'groups.export.student.tariffCode': 'Code tarif',
    'groups.export.student.grantCode': 'Code subvention',
    'groups.export.student.entranceFeeCode': 'Code admission',
    'groups.export.student.pricingRuleCode': 'Régime tarifaire',
    'groups.export.student.ewalletOverdraftAmount': 'Montant découvert personnalisé',
    'groups.export.student.exitDate': "Date d'archive",
    'groups.export.student.accessFrom': "Date d'arrivée",
    'groups.export.student.accessUntil': 'Date de départ',
    'groups.export.student.inactive': 'Inactif',
    'groups.export.student.active': 'Actif',
    'groups.export.student.yes': 'Oui',
    'groups.export.student.no': 'Non',

    // Sections
    'section.tableCard.title': 'Sections',
    'section.tableCard.subtitle':
        'Définissez les possibilités de regroupement de vos convives par section et associez y les différents régimes tarifaires.',
    'section.tableCard.action': '+ Créer une nouvelle section',
    'section.name': 'Section',
    'group.warning.section_name_already_exist.message': 'Le nom de la section existe déjà.',
    'group.warning.section_name_already_exist.description':
        'Veuillez proposer un nouveau nom de section ou associer le(s) régime(s) tarifaire(s) sélectionné(s) à la section déjà existante.',
    'section.modal.conflict.error.message': 'Vous ne pouvez pas modifier cette section',
    'section.modal.conflict.error.description': 'Veuillez réaffecter le(s) convive(s) avant de modifier cette section',
    'section.delete.modal.conflict.error.message': 'Vous ne pouvez pas supprimer cette section',
    'section.delete.modal.conflict.error.description':
        'Veuillez réaffecter le(s) convive(s) avant de supprimer cette section',

    // SubSections
    'subsection.tableCard.title': 'Sous-sections',
    'subsection.tableCard.subtitle':
        'Définissez les possibilités de regroupement de vos convives par sous-section et associez y les différents régimes tarifaires.',
    'subsection.tableCard.action': '+ Créer une nouvelle sous-section',
    'subsection.name': 'Sous-section',
    'group.warning.sub_section_name_already_exist.message': 'Le nom de la sous-section existe déjà.',
    'group.warning.sub_section_name_already_exist.description':
        'Veuillez proposer un nouveau nom de sous-section ou associer le(s) régime(s) tarifaire(s) sélectionné(s) à la sous-section déjà existante.',
    'subsection.modal.conflict.error.message': 'Vous ne pouvez pas modifier cette sous-section',
    'subsection.modal.conflict.error.description':
        'Veuillez réaffecter le(s) convive(s) avant de modifier cette sous-section',
    'subsection.delete.modal.conflict.error.message': 'Vous ne pouvez pas supprimer cette sous-section',
    'subsection.delete.modal.conflict.error.description':
        'Veuillez réaffecter le(s) convive(s) avant de supprimer cette sous-section',

    // options
    'options.main': 'Général',
    'options.educationMode': 'Restauration collective',
    'options.birthdate': "Date d'anniversaire",
    'options.tripAdvisorUsername': "Nom d'utilisateur TripAdvisor",
    'options.advancedSecurityRules': 'Activer le mot de passe 12 caractères',
    'options.optIn': 'Opt-in',
    'options.productionDeclaration': 'Déclaration de production',
    'options.grantsAndEntranceFee': 'Subventions et admissions',
    'options.pinCodeDoubleAuth': "Utiliser un code pin pour sécuriser l'authentification sur la borne",
    'options.charlemagneExport': 'Exporter des données pour Charlemagne',
    'options.handleBadgeForChar': 'Ne gérer que les 4 derniers caractères sur les recherches de badge',
    'options.autoBilling': 'Activer le module de "facturation automatique"',
    'options.linkProductImageBySku':
        "Lier automatiquement les images dont les noms contiennent les SKU des produits (lors de l'import)",
    'options.externalIdsMapping': 'Activer la traduction des ids',
    'options.ewalletAutoReload': 'Activer E-wallet autoreloader (via Stripe)',
    'options.foodCourt': 'CEL v2 - Food Court',
    'options.foodCourtMode': 'Activer le mode food court',
    'options.shuffleRestaurants': `Rendre aléatoire l'ordre d'affichage des restaurants`,
    'options.enableSodexoDictionary': 'Activer le dictionnaire Sodexo',
    'options.enableOrderDetailV2': 'Activer order detail V2',
    'options.usePickupPoints': 'Activer les points de collecte',
    'options.linkProductSkuToExternalMapping': 'Lier automatiquement les SKU des produits à la traduction des ids',
    'options.linkStudentNumberToExternalMapping': 'Lier automatiquement le numéro de convive à la traduction des ids',
    'options.multiRestaurant': 'Borne - Multi Restaurant',
    'options.multiRestaurantMode': 'Activer le mode multi-restaurant',
    'options.multiRestaurantModeMainRestaurant': 'Restaurant Mère',
    'options.multiRestaurantModeMainUser': 'Utilisateur Borne',
    'options.multiRestaurantModeAssignedRestaurants': 'Restaurants assignés',
    'options.enableLinkingMenuToPosAndWeb': 'Permettre l’association du menu avec une caisse et le Web',
    'options.configureSodexoConsumerTransaction': 'Activer les webhooks Sodexo consumerTransactions',
    'options.families': 'Familles',
    'options.families.empty': 'Aucune famille',
    'options.families.new': 'Nouvelle famille',
    'options.families.namePlaceholder': 'Nom',
    'options.families.add': 'Ajouter',
    'options.families.delete': 'Supprimer',
    'options.families.deleteTitle': 'Confirmer la suppression de la famille {name}',
    'options.families.deleteConfirmation': 'Êtes-vous sûr de vouloir supprimer la famille "{name}" ?',

    // Brand Info
    'brandInfo.title': 'Informations',
    'brandInfo.ewalletOverdraft.title': 'Découvert E-wallet',
    'brandInfo.ewalletOverdraft.description':
        "Permettre aux clients d'avoir un solde négatif sur leur e-wallet jusqu'au montant spécifié.",
    'brandInfo.ewalletOverdraft.enable': 'Activer le découvert e-wallet',
    'brandInfo.ewalletOverdraft.amount': 'Montant maximum du découvert',
    'brandInfo.ewalletOverdraft.amountPlaceholder': '0,00',
    'brandInfo.ewalletOverdraft.cannotDisable':
        'Impossible de désactiver le découvert : {count} client(s) ont actuellement le post-paiement activé.',

    // Restaurant
    'restaurant.search': 'Rechercher un restaurant',
    'restaurant.name': 'Nom du restaurant',
    'restaurant.options.main': 'Général',
    'restaurant.options.includeDepositsInTurnover': 'Comptabiliser les consignes dans le chiffre d’affaires',

    // admin banner
    'adminBanner.message': 'Vous êtes connecté en tant que',
    'adminBanner.backToAdmin': 'Repasser en administrateur',

    // auto billing
    'auto.billing.buttons.referential': 'Référentiel',
    'auto.billing.buttons.billing': 'Demande de facturation',
    'auto.billing.request.card.title': 'Demande de facturation',
    'auto.billing.request.card.subtitle':
        'Le module de facturation automatique permet de regrouper l’ensemble des consommations des convives affectées à un tiers afin de calculer (selon les règles paramétrées) le CA et le perçu de chaque tiers.',
    'auto.billing.request.wizard.validate': 'Terminer',
    'auto.billing.request.wizard.title': 'Faire une demande de facturation',
    'auto.billing.request.card.action': 'Faire une demande de facturation',
    'auto.billing.request.popup.confirm.title': 'Vous allez demander une facturation automatique',
    'auto.billing.request.popup.confirm.text': 'Pouvez-vous confirmer cette action ?',
    'auto.billing.request.popup.success.title': 'Votre demande de facturation est validée',
    'auto.billing.request.popup.fail.title': 'Erreur',
    'auto.billing.request.popup.pending.title': 'Traitement en cours...',
    'auto.billing.request.popup.success.cancel': 'Fermer',
    'auto.billing.request.popup.success.text': 'Vous avez affectué votre demande de facturation avec succès',
    'auto.billing.request.popup.fail.text': "Une erreur s'est produite veuillez réessayer plus tard",
    'auto.billing.request.preview.emptyMessage': 'Aucune vente durant la période sélectionnée',
    'auto.billing.request.preview.errorUndefinedReferential': "Aucun référentiel n'est defini pour l'enseigne",
    'auto.billing.request.preview.error': "Une erreur s'est produite veuillez réessayer plus tard",
    'auto.billing.request.preview.code': 'Code',
    'auto.billing.request.preview.label': 'Désignation',
    'auto.billing.request.preview.quantity': 'QTE',
    'auto.billing.request.preview.unitPriceWithTaxExcluded': 'Prix Unitaire H.T.',
    'auto.billing.request.preview.totalPriceWithTaxExcluded': 'Montant H.T.',
    'auto.billing.request.preview.totalTax': 'Montant T.V.A',
    'auto.billing.request.preview.totalPriceWithTaxIncluded': 'Montant T.T.C.',
    'auto.billing.request.preview.cdpf': 'CDPF émetteur',
    'auto.billing.request.preview.clientCode': 'Code client',
    'auto.billing.request.preview.clientLabel': 'Libellé client',
    'auto.billing.request.preview.billingPeriod': 'Période de facturation',
    'auto.billing.request.preview.billingPeriod.from': 'Du',
    'auto.billing.request.preview.billingPeriod.to': 'au',
    'auto.billing.request.preview.invoiceSelector.GROUP': 'Groupe',
    'auto.billing.request.preview.invoiceSelector.ACCOUNT_PAYMENT_TYPE': 'Type de compte',
    'auto.billing.request.preview.invoiceSelector.PRICING_RULE': 'Régime tarifaire',
    'auto.billing.request.preview.total.amountWithTaxIncluded': 'Total TTC',
    'auto.billing.request.preview.total.amountWithTaxExcluded': 'Total montant HT',
    'auto.billing.request.preview.total.tax': 'Total TVA',
    'auto.billing.request.filter.title': 'Filtres',
    'auto.billing.request.filter.entities.title': 'CHOIX DES ENTITÉS DE FACTURATION',
    'auto.billing.request.filter.entities.all': 'Toutes les entités',
    'auto.billing.request.filter.restaurants.title': 'CHOIX DES RESTAURANTS',
    'auto.billing.request.filter.dropDown.errorMessage': 'Vous devez choisir au minimum une option',
    'auto.billing.request.filter.restaurants.all': 'Tous les restaurants',
    'auto.billing.request.filter.pricingRules.title': 'PROFIL TARIFAIRE',
    'auto.billing.request.filter.pricingRules.all': 'Tous les régimes tarifaires',
    'auto.billing.request.filter.pricingRules.noPricingRules': 'Pas de régime tarifaire',
    'auto.billing.request.accountPaymentTypes.title': 'MODE DE GESTION',
    'auto.billing.request.filter.accountPaymentTypes.all': 'Tous les modes gestion',
    'auto.billing.request.accountPaymentTypes.CASH': 'Comptant',
    'auto.billing.request.accountPaymentTypes.PREPAYMENT': 'Pre paiement',
    'auto.billing.request.accountPaymentTypes.POSTPAYMENT': 'Post paiement',
    'auto.billing.request.history.table.emptyMessage': 'Aucune demande de facturation effectuée',
    'auto.billing.request.history.table.date': 'Date de génération',
    'auto.billing.request.history.table.period': 'Période',
    'auto.billing.request.history.table.user': 'Utilisateur',
    'auto.billing.request.history.table.previewButton': 'Preview',
    'auto.billing.request.history.table.downloadButton': 'Télécharger',
    'auto.billing.referential.serviceCodes.card.title': 'Codes prestations',
    'auto.billing.referential.serviceCodes.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.card.title': 'Entités de facturation',
    'auto.billing.referential.billingEntities.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.add': '+ Ajouter une entité',
    'auto.billing.referential.billingEntities.form.create.title': "Création de l'entité de facturation",
    'auto.billing.referential.billingEntities.form.create.subtitle': ' ',
    'auto.billing.referential.billingEntities.costCompute.title': 'Mode de calcul',
    'auto.billing.referential.billingEntities.costCompute.subtitle': ' ',
    'auto.billing.referential.billingEntities.table.label': 'Libéllé',
    'auto.billing.referential.billingEntities.table.code': 'Code',
    'auto.billing.referential.billingEntities.table.groups': 'Groupes associés',
    'auto.billing.referential.billingEntities.table.groupingBy': 'Ventilation',
    'auto.billing.referential.billingEntities.table.emptyMessage':
        "Aucune entitité de facturation n'est définie pour cette enseigne",
    'auto.billing.referential.billingEntities.form.label.title': 'LIBELLÉ',
    'auto.billing.referential.billingEntities.form.code.title': 'CODE',
    'auto.billing.referential.billingEntities.form.code.text': 'CODE',
    'auto.billing.referential.billingEntities.form.groups.text': 'CIBLE',
    'auto.billing.referential.billingEntities.form.groupingBy.title': 'TYPE DE VENTILATION',
    'auto.billing.referential.billingEntities.form.label.subtitle': "Création de l'entité de facturation",
    'auto.billing.referential.billingEntities.form.groupingBy.options.PRICING_RULE': 'Régime tarifaire',
    'auto.billing.referential.billingEntities.form.groupingBy.options.BILLING_ENTITY': 'Sans ventilation',
    'auto.billing.referential.billingEntities.form.groupingBy.options.GROUP': 'Groupe',
    'auto.billing.referential.billingEntities.form.groupingBy.options.ACCOUNT_PAYMENT_TYPE': 'Mode de Gestion',
    'auto.billing.referential.billingEntities.errors.duplicate.code':
        "Le code {code} est déjà associé à l'entité de facturation {entity}",
    'auto.billing.referential.billingEntities.errors.duplicate.group':
        "l'entité de facturation {entity} a dèjà pour groupe(s): {groups}",
    'auto.billing.referential.serviceCodes.perceivedAmountCode.label': 'PERÇU POUR COMPTE',
    'auto.billing.referential.serviceCodes.admissionLevelCostCode.label': "FACTURATION PAR TRANCHE D'ADMISSION",
    'auto.billing.referential.serviceCodes.fixedCostCode.label': 'FACTURATION EN MASSE DE FRAIS FIXE',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.card.title': 'Perçu pour compte',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.code.label': 'Code',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.vat.label': 'TVA',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.add': '+ Ajouter un code',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.emptyMessage': "Aucun code n'est renseigné",
    'auto.billing.referential.accountingCostCompute.constantCost': 'Facturation par masse de frais fixe',
    'auto.billing.referential.accountingCostCompute.partitionedConstantCost': 'Facturation par tranche',
    'auto.billing.referential.accountingCostCompute.summedUpByAdmissionFeesAmount': 'Facturation au couvert',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.constantCost': 'Masse de frais fixe',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.summedUpByAdmissionFeesAmount': 'Par couvert',
    'auto.billing.referential.accountingCostCompute.modal.sliceFrom': 'TRANCHE DE',
    'auto.billing.referential.accountingCostCompute.modal.to': 'À',
    'auto.billing.referential.accountingCostCompute.modal.constantCost': 'MASSE DE FRAIS FIXE',
    'auto.billing.referential.accountingCostCompute.modal.summedUpByAdmissionFeesAmount': 'PAR COUVERT',
    'auto.billing.referential.accountingCostCompute.modal.billingMode': 'MODE DE FACTURATION',
    'auto.billing.referential.accountingCostCompute.modal.title': 'Ajouter une nouvelle tranche',
    'auto.billing.referential.accountingCostCompute.modal.input.maxLowerThanOrEqualToMin':
        'Tranche max doit être supérieur à min',
    'auto.billing.referential.accountingCostCompute.modal.input.intersection':
        'Cette tranche se chevauche avec [{from} - {to}]',
    'auto.billing.referential.accountingCostCompute.modal.input.negative': 'La veleur doit être positive',
    'auto.billing.referential.accountingCostCompute.partitionedCostByGuest': 'XXXX',
    'auto.billing.referential.accountingCostCompute.addSlice': '+ Ajouter une tranche',
    'auto.billing.referential.accountingCostCompute.amount': 'Montant TTC',
    'auto.billing.filters.entity': 'Entité de facturation',
    'auto.billing.referential.accountingGroups.code.text': 'XXXX CODE DU GROUPE',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.range': 'Nombre de couvert',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.mode': 'Mode de calcul',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.value': 'Valeurs',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.emptyMessage':
        'Aucune tranche définie pour ce mode de facturation',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.to': 'à',
    // Routes
    'route.brands': 'Enseignes',
    'route.brandInfo': 'Informations',
    'route.brandInfoV2': 'Informations',
    'route.brandMedias': 'Média',
    'route.configIOPay': 'Configuration Adyen',
    'route.configEdenred': 'Configuration Edenred',
    'route.configPaygreen': 'Configuration Paygreen',
    'route.integrations': 'Intégrations',
    'route.stripeIntegration': 'Stripe',
    'route.grantsAndEntranceFees': 'Subventions et admissions',
    'route.options': 'Options',
    'route.brandHistory': 'Historique',
    'route.groups': 'Hiérarchisation',
    'route.brandChannels': 'Canaux',
    'route.brandMenus': 'Menus',
    'route.brandMenu': 'Informations',
    'route.brandRestaurants': 'Restaurants',
    'route.brandUsers': 'Utilisateurs',
    'route.billing': 'Mon espace facturation',
    'route.home': 'Accueil',
    'route.pricingRule': 'Régime tarifaire',
    'route.logout': 'Déconnexion',
    'route.configUbereats': 'Intégration Uber Eats',
    'route.configDeliveroo': 'Intégration Deliveroo',
    'route.configDeliverect': 'Intégration Deliverect',
    'route.configCrous': 'Intégration Crous',
    'route.createGrant': 'Nouvelle Subvention',
    'route.grant': 'Subventions',
    'route.createEntranceFee': 'Nouvelle admission',
    'route.entranceFee': 'Admission',
    'route.createPricingRule': 'Nouvelle règle tarifaire',
    'route.analytics': "Vue d'ensemble",
    'route.restaurantIntegration': 'Intégration',
    'route.autoBilling': 'Facturation automatique',
    'route.autoBilling.referential': 'Référentiel',
    'route.autoBilling.request': 'Demande de facturation',
    'route.autoBilling.referential.createEntity': "Création d'une entité de facturation",
    'route.autoBilling.referential.editEntity': "Edition d'une entité de facturation",
    'route.orders': 'Commandes',
    'route.orderDetails': 'Détail de commande',
    'route.restaurantInfo': 'Informations',
    'route.restaurantChannels': 'Canaux',
    'route.restaurantUsers': 'Utilisateurs',
    'route.restaurantMenus': 'Menus',
    'route.restaurantMenu': 'Informations',
    'route.restaurantTickets': 'Tickets',
    'route.restaurantMedias': 'Média',
    'route.restaurantIntegrations': 'Intégrations',
    'route.restaurantPayments': 'Moyens de paiement',
    'route.restaurantOptions': 'Options',
    'route.restaurantPricingRevaluation': 'Revalorisation des prix',
    'route.createGroup': 'Nouveau groupe',
    'route.createSection': 'Nouvelle section',
    'route.createSubSection': 'Nouvelle sous-section',
    'route.editGroup': "Édition d'un groupe",
    'route.editSection': "Édition d'une section",
    'route.editSubSection': "Édition d'une sous-section",
    'route.adminTools': 'Outils admin',
    'route.menus': 'Menus',
    'route.menuOperations': 'Opérations sur les menus',
    'route.posLayout': 'Plan de touche POS',
    'route.categories': 'Catégories',
    'route.products': 'Produits',
    'route.steps': 'Étapes',
    'route.tags': 'Tags',
    'route.functions': 'Fonctions',
    'route.brandCustomer': 'Clients',
    'route.brandOrders': 'Commandes',
    'route.crossSelling': 'Cross-selling',
    'route.tableLayout': 'Plans de tables',
    'route.tableLayout.room': 'Salles',
    'route.salesSummary': 'Synthèse Financière',
    'route.tickets': 'Tickets',
    'route.reportStatus': 'Statut rapport',
    'route.pos': 'POS',
    'route.posConfiguration': 'Configuration',
    'route.posDevices': 'Caisses',
    'route.posAccess': 'Rôles et permissions',
    'route.posAccess.users': 'Utilisateurs caisse',
    'route.posAccess.roles': 'Rôles caisse',
    'route.posAccess.groups': 'Groupes caisse',
    'route.accessFlags': 'Autorisations',
    'route.userRestaurants': 'Restaurants associés',
    'route.updateUserPassword': 'Modifier son mot de passe',
    'route.userInfo': 'Info',
    'route.badgeReader': 'Lecteurs de badge',
    'route.posDeviceInformation': 'Informations',
    'route.posDeviceConfiguration': 'Configuration',
    'route.posDeviceAdditionalDevices': 'Périphériques',
    'route.posDeviceArchives': 'Archives fiscales',
    'route.posDeviceFeatures': 'Options ',
    'route.posDevicePreferences': 'Préférences',
    'route.posDeviceCatalogHistory': 'Historique des catalogues',
    'route.listCustomers': 'Clients',
    'route.customerSettings': 'Paramètres',
    'route.customerPricingRules': 'Régimes tarifaires',
    'route.splioLoyaltyIntegration': 'Splio',
    'route.pickupPoints': 'Points de collecte',
    'route.comoLoyaltyIntegration': 'Como',
    'route.zerosixLoyaltyIntegration': 'Zerosix',
    'route.operationZones': "Zone d'opération",
    'route.createBrandWebhook': 'Créer un webhook',
    'route.editBrandWebhook': 'Modifier un webhook',

    // Operation Zones
    'operationZones.page.title': "Zone d'opération",
    'operationZones.page.description':
        "Définissez les territoires où votre enseigne exerce son activité. Une zone principale doit être désignée pour l'entité légale de référence.",
    'operationZones.emptyState': 'Aucune zone sélectionnée',
    'operationZones.emptyState.description':
        "Sélectionnez un ou plusieurs territoires dans la liste ci-dessous pour définir vos zones d'opération.",
    'operationZones.availableTerritories': 'Territoires disponibles',
    'operationZones.selectedCount': '{count} sélectionné(s)',
    'operationZones.solution': 'Solution',
    'operationZones.warning.title': 'Configuration incomplète',
    'operationZones.warning.description':
        "{count, plural, one {{count} zone sélectionnée nécessite d'être configurée pour être opérationnelle.} other {{count} zones sélectionnées nécessitent d'être configurées pour être opérationnelles.}}",
    'operationZones.warning.hint':
        'Veuillez compléter les informations légales et techniques via le bouton "Configurer".',
    'operationZones.immutabilityNotice':
        "La zone d'opération ne peut pas être modifiée après la création du restaurant. <supportLink>Contactez le support</supportLink> si nécessaire.",
    'operationZones.primaryZone': 'ZONE PRINCIPALE',
    'operationZones.setPrimary.disabled': 'Configurez cette zone avant de la définir comme principale',
    'operationZones.cannotRemoveLastZone': "Un restaurant doit avoir au moins une zone d'opération",
    'operationZones.primaryBadge': 'PRINCIPALE',
    'operationZones.secondaryZonesActive':
        '+ {count} {count, plural, one {ZONE SECONDAIRE ACTIVE} other {ZONES SECONDAIRES ACTIVES}}',
    'operationZones.configure': 'Configurer',
    'operationZones.viewVatRates': 'Voir les taux',
    'operationZones.toConfigure': 'À configurer',
    'operationZones.entity': 'Entité',
    'operationZones.vat': 'TVA',
    'operationZones.posConfig': 'Configuration POS',
    'operationZones.notFilled': 'Non renseigné',
    'operationZones.pending': 'En attente',
    'operationZones.initialized': 'Initialisée',
    'operationZones.configured': 'Configurée',
    'operationZones.noPosDevice': 'Créez un POS avant de configurer cette zone',
    'operationZones.configModal.title': 'Configuration : {zoneName}',
    'operationZones.configModal.subtitle': 'Paramètres légaux et fiscaux ({code})',
    'operationZones.configModal.entitySection': "Informations de l'entité",
    'operationZones.configModal.socialReason': 'Raison sociale',
    'operationZones.configModal.address': 'Adresse',
    'operationZones.configModal.postalCode': 'Code postal',
    'operationZones.configModal.city': 'Ville',
    'operationZones.configModal.vatNumber': 'Numéro TVA',
    'operationZones.configModal.siret': 'SIRET',
    'operationZones.configModal.save': 'Enregistrer',
    'operationZones.configModal.socialReason.placeholder': 'Ex: Restaurant SARL',
    'operationZones.configModal.address.placeholder': '123 Rue de la ...',
    'operationZones.configModal.postalCode.placeholder': '75000',
    'operationZones.configModal.city.placeholder': 'Paris',
    'operationZones.configModal.vatNumber.placeholder': 'Ex: FR 12 345678901',
    'operationZones.configModal.siret.placeholder': 'Ex: 522 296...',
    'operationZones.multiProvider': 'Au choix',
    'operationZones.configModal.nifCif': 'NIF / CIF',
    'operationZones.configModal.nifCif.placeholder': 'Ex: B12345678',
    'operationZones.configModal.fiscalRepresentative': 'Représentant fiscal',
    'operationZones.configModal.fiscalRepresentative.placeholder': 'Nom du représentant fiscal',
    'operationZones.configModal.fiscalIdCode': "Code d'identification fiscale",
    'operationZones.configModal.fiscalIdCode.placeholder': 'Ex: RSSMRA85T10A562S',
    'operationZones.configModal.vatNumberBtw': 'Numéro TVA (BTW)',
    'operationZones.configModal.vatNumberBtw.placeholder': 'Ex: BE 0123.456.789',
    'operationZones.configModal.enterpriseNumber': "Numéro d'entreprise",
    'operationZones.configModal.enterpriseNumber.placeholder': 'Ex: 0123.456.789',
    'operationZones.configModal.if': 'IF',
    'operationZones.configModal.if.placeholder': 'Ex: 12345678',
    'operationZones.configModal.ice': 'ICE',
    'operationZones.configModal.ice.placeholder': 'Ex: 001234567000045',
    'operationZones.configModal.selectProvider': 'Sélectionnez le mode de conformité',
    'operationZones.configModal.fiskaltrust': 'Fiskaltrust',
    'operationZones.configModal.fiskaltrustDescription':
        'Middleware de conformité fiscale pour la caisse enregistreuse',
    'operationZones.configModal.noIntegration': "Pas d'intégration",
    'operationZones.configModal.noIntegrationDescription': 'Aucun middleware de fiscalité ne sera configuré',
    'operationZones.configModal.nf525': 'NF525',
    'operationZones.configModal.nf525Description': 'Certification de conformité fiscale française',
    'operationZones.configModal.boiteNoire': 'Boîte Noire',
    'operationZones.configModal.boiteNoireDescription': 'Module de conformité fiscale belge',
    'operationZones.configModal.middlewareSection': 'Configuration Middleware (Fiskaltrust)',
    'operationZones.configModal.cashboxId': 'Cashbox ID',
    'operationZones.configModal.cashboxId.placeholder': 'Ex: a1b2c3d4-...',
    'operationZones.configModal.accessToken': 'Access Token',
    'operationZones.configModal.accessToken.placeholder': 'Ex: AZE123...',
    'operationZones.configModal.back': 'Retour',
    'operationZones.deactivate.title': "Désactiver la zone d'opération",
    'operationZones.deactivate.message':
        "Êtes-vous sûr de vouloir désactiver cette zone d'opération ? Toutes les informations configurées (entité légale, fiscalité, configuration POS) seront perdues.",

    // Admin tools
    'adminTools.confirmModal.description': 'Êtes-vous sur de vouloir déclencher cette action ?',
    'brand.adminTools.editCustomerLoyalties.title': 'Ajouter/retirer de la fidélité IO à un client de cette enseigne',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.emailsOrCards': 'nom@domaine.com ou A1B2C3D4E5',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.loyaltyAmountToAdd': '400 équivaut à 4 euros',
    'brand.adminTools.editCustomerLoyalties.form.emailsOrCards': 'Email ou numéro de la carte de fidélité du client',
    'brand.adminTools.editCustomerLoyalties.form.loyaltyAmountToAdd': 'Montant',
    'brand.adminTools.editCustomerLoyalties.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.editCustomerLoyalties.form.success': 'Le script a bien été exécuté.',
    'brand.adminTools.unarchiveCustomer.title': 'Désarchiver un convive',
    'brand.adminTools.unarchiveCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.unarchiveCustomer.form.customerId': 'CustomerId à desarchiver',
    'brand.adminTools.unarchiveCustomer.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.unarchiveCustomer.form.success': 'Le script a bien été exécuté.',
    'brand.adminTools.deleteTransaction.title': 'Supprimer une transaction',
    'brand.adminTools.deleteTransaction.form.placeholder.transactionId': '1234567',
    'brand.adminTools.deleteTransaction.form.transactionId': 'Transaction à supprimer',
    'brand.adminTools.deleteTransaction.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.deleteTransaction.form.success': 'Le script a bien été exécuté.',
    'brand.adminTools.addUserToRestaurant.title':
        'Assigner un compte restaurant à un autre restaurant de la même enseigne',
    'brand.adminTools.addUserToRestaurant.form.placeholder.email': 'exemple@restaurant.com',
    'brand.adminTools.addUserToRestaurant.form.email': 'Email du compte',
    'brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId': '1111',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': 'RestaurantId du restaurant à assigner',
    'brand.adminTools.addUserToRestaurant.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.addUserToRestaurant.form.success': 'Le script a bien été exécuté.',
    'brand.adminTools.deleteUnassignedImages.title': 'Supprimer les images non utilisées de cette enseigne',
    'brand.adminTools.deleteUnassignedImages.description1':
        'Script pour effacer toutes les images non utilisées (par exemple par des produits/menus qui ont été supprimés depuis)',
    'brand.adminTools.deleteUnassignedImages.description2':
        "Il est conseillé de supprimer tous les menus inutiles de l'enseigne et de ses restaurants avant d'executer ce script, afin que le nettoyage soit efficace.",
    'brand.adminTools.deleteUnassignedImages.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.deleteUnassignedImages.form.success': 'Le script a bien été exécuté.',
    'brand.adminTools.importGeojsonPolygon.title': 'Importer un geoJson comme zone de livraison',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.restaurantId': '1234',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.areaName': 'Creteil',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.geoJsonPolygon':
        '[[4.8395748,50.0926849],[4.8393237,50.0926889],[4.8392677,50.0926748]]',
    'brand.adminTools.importGeojsonPolygon.form.restaurantId': 'RestaurantId',
    'brand.adminTools.importGeojsonPolygon.form.areaName': 'Nom de la zone de livraison à créer',
    'brand.adminTools.importGeojsonPolygon.form.geoJsonPolygon': 'Mettre les coordonnées polygones du geoJson',
    'brand.adminTools.importGeojsonPolygon.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.importGeojsonPolygon.form.success': 'Le script a bien été exécuté.',
    'brand.adminTools.deleteCustomer.title': 'Supprimer un client/convive',
    'brand.adminTools.deleteCustomer.description1':
        'Entrez le customerId que vous voulez supprimer (Vous pouvez entrer plusieurs customerIds en les separant par une virgule, sans espace, par exemple: 1234567,1234568,1234569)',
    'brand.adminTools.deleteCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.deleteCustomer.form.customerId': 'CustomerId à supprimer',
    'brand.adminTools.deleteCustomer.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.deleteCustomer.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.razCustomer.title': `Mise à zéro d'un client/convive`,
    'brand.adminTools.razCustomer.description1':
        'Entrez le customerId dont vous voulez mettre le solde E-Wallet à zéro (Vous pouvez entrer plusieurs customerIds en les séparant par une virgule, sans espace, par exemple: 1234567,1234568,1234569)',
    'brand.adminTools.razCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.razCustomer.form.customerId': 'CustomerId(s) à mettre à zéro (séparés par une virgule)',
    'brand.adminTools.razCustomer.form.placeholder.brandId': '414',
    'brand.adminTools.razCustomer.form.brandId':
        'BrandId à mettre à zéro (si vous entrez un brandId, tous les clients post-paiement de cette enseigne seront mis à zéro, le champ customerId(s) au dessus sera ignoré)',
    'brand.adminTools.razCustomer.form.placeholder.date': '01/02/2024',
    'brand.adminTools.razCustomer.form.date': `Date d'application de la RAZ (l'heure est 5h du matin), laissez vide si la RAZ doit être faite maintenant`,
    'brand.adminTools.razCustomer.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.razCustomer.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.copySchedules.title': `Copie des horaires de collecte ou CEL d'un restaurant vers un/des autre(s)`,
    'brand.adminTools.copySchedules.form.placeholder.scheduleType': 'pickup ou cel',
    'brand.adminTools.copySchedules.form.placeholder.idSource': '900',
    'brand.adminTools.copySchedules.form.placeholder.idsDestination': '901',
    'brand.adminTools.copySchedules.form.scheduleType': `Type de l'horaire à copier (entrez pickup ou cel)`,
    'brand.adminTools.copySchedules.form.idSource': 'RestaurantId source',
    'brand.adminTools.copySchedules.form.idsDestination':
        'RestaurantId(s) destination (Vous pouvez entrer plusieurs restaurantIds en les separant par une virgule, sans espace, par exemple: 901,902,903)',
    'brand.adminTools.copySchedules.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.copySchedules.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.changeOrderDateInReport.title': `Editer la date d'une commande dans les rapports (Cela changera aussi la date de la transaction)`,
    'brand.adminTools.changeOrderDateInReport.form.orderPosId':
        'Numero de commande (orderId), possibilité de séparer par une virgule',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.orderPosId': '1234567,1234568,1234569,...',
    'brand.adminTools.changeOrderDateInReport.form.day': 'Jour',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.day': 'exemple : 14',
    'brand.adminTools.changeOrderDateInReport.form.month': 'Mois',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.month': 'exemple : 7',
    'brand.adminTools.changeOrderDateInReport.form.year': 'Année',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.year': 'exemple : 2025',
    'brand.adminTools.changeOrderDateInReport.form.hour': 'Heure',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.hour': 'exemple : 10',
    'brand.adminTools.changeOrderDateInReport.form.minutes': 'Minutes',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.minutes': 'exemple : 35',
    'brand.adminTools.changeOrderDateInReport.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.changeOrderDateInReport.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.editPasswordExpiresAt.title': 'Forcer une enseigne/un convive à changer son mot de passe',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.shouldResetPassword': 'force ou cancel',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.brandId': '900',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.customerId': ' ',
    'brand.adminTools.editPasswordExpiresAt.form.shouldResetPassword':
        'Forcer à changer le mot de passe (force) ou Annuler le changement de mot de passe (cancel)',
    'brand.adminTools.editPasswordExpiresAt.form.brandId': 'Enseigne ciblée',
    'brand.adminTools.editPasswordExpiresAt.form.customerId': `Convive(s) ciblé(s) Vous pouvez entrer plusieurs customerIds en les separant par une virgule, sans espace, par exemple: 123456,234567,345678). Laissez vide pour cibler toute l'enseigne`,
    'brand.adminTools.editPasswordExpiresAt.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.editPasswordExpiresAt.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.editProductSkuFromProductId.title':
        'Editer le SKU des plusieurs produits depuis un fichier Excel',
    'brand.adminTools.editProductSkuFromProductId.description': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'brand.adminTools.editProductSkuFromProductId.form.error':
        'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.editProductSkuFromProductId.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.importProductInMenu.title': 'Importer des produits dans un menu déjà existant',
    'brand.adminTools.importProductInMenu.description': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'brand.adminTools.importProductInMenu.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.importProductInMenu.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.importProductFromSku.title': 'Editer et importer des produits basés sur leur SKU',
    'brand.adminTools.importProductFromSku.description1': `Utilisez ce {metabaseLink} pour avoir la liste des produits de votre menu, vous pouvez éditer ou ajouter de nouveaux produits (SKU non obliagoire sur les nouveaux produits).`,
    'brand.adminTools.importProductFromSku.description1bis': `Ne pas éditer le SKU des produits existants, c'est l'identifiant unique du produit. Ne changez pas le nom des colonnes`,
    'brand.adminTools.importProductFromSku.description2': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'brand.adminTools.importProductFromSku.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.importProductFromSku.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdSource': 'menuId du menu source',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdSource': 'MenuId du menu source',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdDestination': 'menuId du menu destination',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdDestination': 'MenuId du menu destination',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterCategory': '(facultatif)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterCategory': 'Filtre Catégorie',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterTag': '(facultatif)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterTag': 'Filtre Tag',
    'brand.adminTools.copyProductFromMenuIdToMenuId.title': `Copier des produits d'un menu à un autre`,
    'brand.adminTools.copyProductFromMenuIdToMenuId.description1': `Entrez le menuId du menu source et le menuId du menu destination. Vous pouvez également filtrer les produits par catégorie et/ou tag pour ne copier que certains produits.`,
    'brand.adminTools.copyProductFromMenuIdToMenuId.description2':
        'Notez que les références externes et les étapes ne seront pas copiées',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description3':
        'Et les images ne seront copiées que si le menu Destination est sur le même Restaurant que le menu Source, ou si le menu Source est au niveau Enseigne et le menu Destination au niveau Restaurant dans la même Enseigne',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.error':
        'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.importBackofficeUsers.title': 'Importer des utilisateurs backoffice',
    'brand.adminTools.importBackofficeUsers.description': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'brand.adminTools.importBackofficeUsers.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.importBackofficeUsers.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.editProductInfoFromProductId.title': 'Editer des produits depuis un fichier Excel',
    'brand.adminTools.editProductInfoFromProductId.description1': `Utilisez ce {metabaseLink} pour avoir la liste des produits de votre menu, remplissez les colonnes dédiées à l'édition et uploadez le fichier. (Ne changez pas le nom des colonnes)`,
    'brand.adminTools.editProductInfoFromProductId.description2': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'brand.adminTools.editProductInfoFromProductId.form.error':
        'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.editProductInfoFromProductId.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.editStepInfoFromStepId.title': 'Editer des étapes depuis un fichier Excel',
    'brand.adminTools.editStepInfoFromStepId.description0':
        'Ce script permet de modifier les noms, les références et les labels des étapes en masse, pas la liste des produits.',
    'brand.adminTools.editStepInfoFromStepId.description1': `Utilisez ce {metabaseLink} pour avoir la liste des étapes de votre menu, remplissez les colonnes dédiées à l'édition et uploadez le fichier. (Ne changez pas le nom des colonnes)`,
    'brand.adminTools.editStepInfoFromStepId.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.editStepInfoFromStepId.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.editProductPriceInAdminTools.title':
        'Editer le prix des produits (hors et dans les étapes) depuis un fichier Excel',
    'brand.adminTools.editProductPriceInAdminTools.description1': `Utilisez ce {metabaseLink} pour avoir la liste des produits de votre menu, remplissez la colonne Nouveau Prix et uploadez le fichier. (Ne changez pas le nom des colonnes)`,
    'brand.adminTools.editProductPriceInAdminTools.description2': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'brand.adminTools.editProductPriceInAdminTools.form.error':
        'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.editProductPriceInAdminTools.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.editProductTagFromProductId.title':
        'Ajouter un ou des Tag(s) à plusieurs produits depuis un fichier Excel',
    'brand.adminTools.editProductTagFromProductId.description': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'brand.adminTools.editProductTagFromProductId.form.error':
        'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.editProductTagFromProductId.form.success': 'Le script a bien été exécuté.',

    'brand.adminTools.makeEwalletTransaction.title': 'Faire des transaction E-Wallet depuis un fichier Excel',
    'brand.adminTools.makeEwalletTransaction.description': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'brand.adminTools.makeEwalletTransaction.form.error': 'Une erreur est survenue pendant le lancement du script.',
    'brand.adminTools.makeEwalletTransaction.form.success': 'Le script a bien été exécuté.',
    'brand.adminTools.bulkUploadDualScreenImage.title':
        "Upload image double écran sur toutes les caisses d'une enseigne",
    'brand.adminTools.bulkUploadDualScreenImage.description':
        "Uploadez une image (PNG ou JPG) et entrez le brandId. L'image sera appliquée sur toutes les caisses de l'enseigne.",
    'brand.adminTools.bulkUploadDualScreenImage.brandIdLabel': 'Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdPlaceholder': 'Entrez le Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.form.success': "L'image a été uploadée sur toutes les caisses.",
    'brand.adminTools.transformGuestFile.title':
        'Transformer votre base convive récupéré depuis le nouveau site en format Innovorder',
    'brand.adminTools.transformGuestFile.fileFormat': 'Format de fichier original',
    'brand.adminTools.transformGuestFile.form.success': 'Le fichier a été bien transformé',
    'brand.adminTools.transformGuestFile.form.url': 'cliquez ici pour télécharger le fichier',
    'brand.adminTools.transformGuestFile.fileFormat.JES': 'JES',
    'brand.adminTools.transformGuestFile.fileFormat.CSI': 'CSI',
    'brand.adminTools.transformGuestFile.fileFormat.X-GIL': 'x-gil',
    'brand.adminTools.transformGuestFile.fileFormat.PI-ELECTRONICS': 'Pi Electronique',
    'brand.adminTools.generateSalesReport.title': 'Remontée des ventes IO dans SI Sodexo',
    'brand.adminTools.generateSalesReport.description':
        'Synchroniser les ventes IO dans SI Sodexo pour un restaurant spécifique (si vous utilisez une période, les ventes seront synchronisées pour la période sélectionnée)',
    'brand.adminTools.generateSalesReport.form.checkbox': 'Utiliser une période',
    'brand.adminTools.generateSalesReport.form.restaurant': 'Sélectionner un restaurant',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.title':
        "Lier les SKU des produits aux mappings d'IDs externes",
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.description':
        'Crée des mappings entre les productId internes et les SKU des produits pour un menu spécifique',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.restaurant': 'Restaurant',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.menu': 'Menu',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.success': 'Le script a bien été exécuté.',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.error':
        'Une erreur est survenue pendant le lancement du script.',

    // Spotlight
    'spotlight.search.placeholder': 'Que voulez-vous faire ?',
    'spotlight.section.suggestion': 'Suggestion',
    'spotlight.section.history': 'Historique',
    'spotlight.context.brand': 'Enseigne',
    'spotlight.context.restaurant': 'Restaurant',
    'spotlight.error.noHistory': 'Vous n’avez pas encore d’url éligible faisant partie de votre d’historique',

    // Orders
    'orderList.title': 'Commandes',
    'orderList.subtitle': 'Retrouver les commandes de vos clients et vos amis proches',
    'orderList.filters.allRestaurants': 'Tous les restaurants',
    'orderList.filters.restaurantHeader': 'Mes restaurants',
    'orderList.filters.restaurantPlaceholder': 'Rechercher un restaurant',
    'orderList.filters.dateRange.lastXdays': '{days} derniers jours',
    'orderList.filters.dateRange.custom': 'Personnalisé',
    'orderList.generation_history': 'Historique des générations',
    'orderList.export': 'Export',
    'orderList.generate': 'Générer',
    'orderList.export.title': 'Exporter',
    'orderList.export.selectOneDay': 'Séléctionner une journée',
    'orderList.export.selectPeriod': 'Séléctionner une période',
    'orderList.export.format': 'Choissisez un format d’exportation',
    'orderList.export.file.xlsx': 'Excel',
    'orderList.export.file.csv': 'CSV',
    'orderList.export.file.pdf': 'PDF',
    'orderList.export.dateRage.errorMessage': 'Vous ne pouvez pas sélectionner plus de 31 jours',
    'orderList.export.presetDate.currentWeek': 'Semaine en cours',
    'orderList.export.presetDate.currentMonth': 'Mois en cours',
    'orderList.export.presetDate.lastMonth': 'Mois dernier',
    'orderList.export.presetDate.chooseDate': 'Veuillez sélectionner une période',
    'orderList.export.includeOrderStates': 'Inclure les différents états des commandes',
    'order.field.ticketNumber': 'N° Ticket',
    'order.field.status': 'Statut',
    'order.field.restaurant': 'Restaurant',
    'order.field.channel': 'Canal',
    'order.field.customerName': 'Nom & prénom',
    'order.field.customerNameMassCatering': 'Nom & prénom convive',
    'order.field.badgeNumber': 'N° Badge',
    'order.field.phone': 'Numéro de téléphone',
    'order.field.pricingRule': 'Régime tarifaire',
    'order.field.pricingRuleInOrder': 'Régime tarifaire tombé',
    'order.field.company': 'Société',
    'order.field.orderId': 'N° Commande',
    'order.field.consumptionMode': 'Mode de consommation',
    'order.field.orderDate': 'Date Commande',
    'order.field.expectedDate': 'Date Livraison',
    'order.field.ticketDate': 'Date Ticket',
    'order.field.totalWithVat': 'Total TTC',
    'order.field.turnoverWithVat': 'CA TTC',
    'order.field.paymentMethod': 'Mode de règlement',
    'order.field.paymentStatus': 'Statut de paiement',
    'order.field.paymentAmount': 'Montant du paiement',
    'order.status.PAID': 'Payée',
    'order.status.CANCELLED': 'Annulée',
    'order.status.VALIDATED': 'Validée',
    'order.status.PAID_CANCELLED': 'Payée (annulée)',
    'order.status.CONTRA_ENTRY': 'Contre-écriture',
    'order.status.INCOHERENT': 'Commande incohérente',
    'order.channel.': 'Inconnu',
    'order.channel.1': 'Borne',
    'order.channel.2': 'CEL',
    'order.channel.5': 'Caisse',
    'order.channel.8': 'DA',
    'order.channel.9': 'Uber Eats',
    'order.channel.10': 'Deliveroo',
    'order.channel.11': 'Just Eat',
    'order.consumptionMode.1': 'Livraison',
    'order.consumptionMode.2': 'A emporter',
    'order.consumptionMode.3': 'Sur place',
    'order.consumptionMode.4': 'Drive',
    'order.webPaymentStatus.PAYMENT_OK': 'Payé',
    'order.webPaymentStatus.PAYMENT_PENDING': 'Non payé',
    'order.webPaymentStatus.PAYMENT_REFUSED': 'Paiement rejeté',
    'order.webPaymentStatus.PAYMENT_REFUNDED': 'Remboursé',
    'order.paymentMethod.AlloResto': 'AlloResto',
    'order.paymentMethod.AmericanExpress': 'American Express',
    'order.paymentMethod.Cash': 'Espèces',
    'order.paymentMethod.Change': 'Rendu',
    'order.paymentMethod.Check': 'Chèque',
    'order.paymentMethod.CreditCard': 'CB',
    'order.paymentMethod.CreditNote': 'Avoir',
    'order.paymentMethod.CreditNoteIssued': 'Avoir émis',
    'order.paymentMethod.Deliveroo': 'Deliveroo',
    'order.paymentMethod.ELuncheonVoucher': 'E-Ticket Restaurant',
    'order.paymentMethod.EWallet': 'E-Wallet',
    'order.paymentMethod.ExternalPayment': 'Paiement Externe',
    'order.paymentMethod.Foodora': 'Foodora',
    'order.paymentMethod.Ingenico': 'Ingenico',
    'order.paymentMethod.LuncheonVoucher': 'Chèque Déjeuner',
    'order.paymentMethod.Lydia': 'Lydia',
    'order.paymentMethod.Nepting': 'Nepting',
    'order.paymentMethod.OnlineCreditCard': 'Carte bancaire en ligne',
    'order.paymentMethod.Paygreen': 'Paygreen',
    'order.paymentMethod.RestoFlash': 'Resto Flash',
    'order.paymentMethod.Stripe': 'Stripe',
    'order.paymentMethod.Transfer': 'Virement',
    'order.paymentMethod.UberEats': 'Uber Eats',
    'order.paymentMethod.Unknown': 'Autre',
    'order.paymentMethod.Unknown2': 'Autre 2',
    'order.paymentMethod.Edenred': 'Edenred',
    'orderDetail.error.incoherent': 'Contacter le support pour régularisation de la commande',
    'orderDetail.title.1': 'Borne',
    'orderDetail.title.2': 'Commande en ligne',
    'orderDetail.title.5': 'Caisse',
    'orderDetail.title.8': 'Distribution Automatique',
    'orderDetail.title.9': 'Uber Eats',
    'orderDetail.title.10': 'Deliveroo',
    'orderDetail.title.11': 'Just Eat',
    'orderDetail.title.contraEntry': 'Commande Contre-écriture',
    'orderDetail.status.PAID': 'Encaissement',
    'orderDetail.status.VALIDATED': 'Addition',
    'orderDetail.status.CANCELLED': 'Annulée',
    'orderDetail.tabStatus.PAID': 'Vente payée',
    'orderDetail.tabStatus.VALIDATED': 'Panier validé',
    'orderDetail.tabStatus.CANCELLED': 'Annulation',
    'orderDetail.paymentStatus.PAID': 'Payée',
    'orderDetail.paymentStatus.CANCELLED': 'Annulée',
    'orderDetail.paymentStatus.REFUNDED': 'Remboursée',
    'orderDetail.shift.default': 'Service par défaut',
    'orderDetail.header.guestNumber': 'Nombre de couverts:',
    'orderDetail.header.currency': 'Devise:',
    'orderDetail.header.orderedAt': 'Commandé à',
    'orderDetail.header.deliverAt': 'Livraison prévue à',
    'orderDetail.header.deliverAtRange': 'Prévu pour le créneau :',
    'orderDetail.header.status': 'Statut',
    'orderDetail.header.payment': 'Paiement',
    'orderDetail.header.table': 'Table',
    'orderDetail.kpi.date': 'Le {date, date}',
    'orderDetail.kpi.time': '{date, date, ::HHmm}',
    'orderDetail.kpi.timeRange': '{start, date, ::HHmm} à {end, date, ::HHmm}',
    'orderDetail.ticketInfo': 'Détails de la commande',
    'orderDetail.comment': 'Commentaire',
    'orderDetail.userName': 'Informations clients',
    'orderDetail.taxInfo': 'Détails TVA',
    'orderDetail.paymentInfo': 'Moyen de paiements',
    'orderDetail.customerInfo': 'Informations client',
    'orderDetail.deliveryInfo': 'Livraison',
    'orderDetail.loyaltyInfo': 'Fidélité',
    'orderDetail.posInfo': 'Informations Caisse',
    'orderDetail.transactionInfo': 'Détails Transaction',
    'orderDetail.orderPhotos': 'Photos associées à la commande',
    'orderDetail.customer.name': 'Nom et Prénom',
    'orderDetail.customer.email': 'Email',
    'orderDetail.customer.phone': 'Numéro de téléphone',
    'orderDetail.customer.badgeNumber': 'Numéro de badge',
    'orderDetail.customer.pricingRule': 'Régime tarifaire',
    'orderDetail.customer.pricingRuleAssigned': 'Régime tarifaire attribué',
    'orderDetail.customer.group': 'Groupe',
    'orderDetail.customer.section': 'Section',
    'orderDetail.customer.subSection': 'Sous-section',
    'orderDetail.customer.balanceInformation.ewalletBalanceBeforeOrder': 'Ancien solde E-Wallet',
    'orderDetail.customer.balanceInformation.ewalletBalanceAfterOrder': 'Nouveau solde E-Wallet',
    'orderDetail.Pos.restaurant': 'Restaurant',
    'orderDetail.Pos.seller': 'Opérateur',
    'orderDetail.Pos.deviceName': 'Nom de la caisse',
    'orderDetail.Pos.deviceId': 'ID POS',
    'orderDetail.action.text': 'Actions commande',
    'orderDetail.action.cancel': 'Annuler',
    'orderDetail.action.refund': 'Rembourser',
    'orderDetail.action.cancelWithContraEntry': 'Annuler la commande (contre-écriture)',
    'orderDetail.cancel.title.reason': 'Annuler la commande',
    'orderDetail.cancel.title.manualPaymentMethod': 'Moyen de paiement du remboursement',
    'orderDetail.cancel.text1': 'En cas de besoin, vous pouvez annuler la commande d’un client.',
    'orderDetail.cancel.text2': 'Vous devez choisir un motif d’annulation ci-dessous.',
    'orderDetail.cancel.text3': 'Si le motif ne se trouve pas dans la liste, cliquez sur « Autre ».',
    'orderDetail.cancel.text4': 'Le motif que vous selectionnez sera envoyé par mail au client.',
    'orderDetail.cancel.text5': 'Les quantités de produits déduites seront remises en stock.',
    'orderDetail.cancel.text6': 'Vous pouvez choisir le moyen de paiement à associer au remboursement.',
    'orderDetail.cancel.text7':
        '⚠️ Il est nécessaire de bien rembourser en physique le client pour éviter les écarts comptables.',
    'orderDetail.cancel.reason.description.label': 'Champ libre (optionnel)',
    'orderDetail.cancel.reason.placeholder': "Choisir votre motif d'annulation",
    'orderDetail.cancel.reason.description.placeholder': '250 caractères maximum',
    'orderDetail.cancel.manualPaymentMethod.placeholder': 'Choisir votre moyen de paiement',
    'orderDetail.cancel.reason.CANNOT_FULFILL_ORDER': 'Ne peut pas compléter la commande',
    'orderDetail.cancel.reason.ORDERING_MISTAKE': 'Erreur de commande',
    'orderDetail.cancel.reason.UNSATISFIED_CUSTOMER': 'Client insatisfait (les quantités ne sont pas remises en stock)',
    'orderDetail.cancel.reason.CUSTOMER_NO_SHOW': "Le client n'est pas venu",
    'orderDetail.cancel.reason.CUSTOMER_LEAVES': 'Le client est parti',
    'orderDetail.cancel.reason.LEARNING_MODE': 'Formation',
    'orderDetail.cancel.reason.TECHNICAL': 'Erreur technique',
    'orderDetail.cancel.reason.OTHER': 'Autre...',
    'orderDetail.cancel.manualPaymentMethod.Cash': 'Espèces',
    'orderDetail.cancel.manualPaymentMethod.CreditCard': 'CB',
    'orderDetail.cancel.confirm': 'Annuler la commande',
    'orderDetail.cancel.validate': "Valider l'annulation",
    'orderDetail.ticket.itemSum': 'Total articles',
    'orderDetail.ticket.grantSum': 'Total subventions',
    'orderDetail.ticket.entranceFeeSum': 'Total admissions',
    'orderDetail.ticket.pricingRule': 'Régime tarifaire : ',
    'orderDetail.ticket.discountSum': 'Total remises',
    'orderDetail.ticket.tvaSum': 'Total TVA',
    'orderDetail.ticket.finalPrice': 'TOTAL',
    'orderDetail.ticket.discount': 'Code promo :',
    'orderDetail.tax.taxrate': 'Taux de TVA',
    'orderDetail.tax.totalExclTax': 'HT',
    'orderDetail.tax.totalTax': 'TVA',
    'orderDetail.tax.totalInclTax': 'TTC',
    'orderDetail.transaction.transactionIds': 'Identifiant de la transaction',
    'orderDetail.payment.quantity': 'Quantité',
    'orderDetail.payment.price': 'Prix',
    'orderDetail.delivery.address': 'Adresse',
    'orderDetail.delivery.apartmentNumber': 'Numéro d’appartement',
    'orderDetail.delivery.digicode': 'Digicode',
    'orderDetail.delivery.phoneNumber': 'Numéro de téléphone',
    'orderDetail.delivery.additionalInfo': 'Informations complémentaires',
    'orderDetail.linkedOrder.title.origin': 'Lien avec la commande contre-écriture',
    'orderDetail.linkedOrder.title.contra_entry': 'Lien avec la commande annulée',
    'orderDetail.linkedOrder.date.origin': 'Date de la commande contre-écriture',
    'orderDetail.linkedOrder.date.contra_entry': 'Date de la commande annulée',
    'orderDetail.contraEntryInfo.title': 'Informations contre-écriture',
    'orderDetail.contraEntryInfo.validator': 'Validateur',
    'orderDetail.contraEntryInfo.cancellationReasonDescription': 'Champ libre',

    // Payments
    'route.ioPayTransactions': 'Transactions',
    'route.ioPayReports': 'Rapports',
    'route.ioPayTransfers': 'Versements',
    'route.ioPayConfiguration': 'Configuration',
    'route.ioPayTransferDetail': 'Détail du versement',
    'route.ioPayTransactionDetail': 'Détail de la transaction',
    'ioPay.title': 'Adyen',

    'transactions.title': 'Transactions',
    'transactions.detail.title': 'Fiche de transaction',
    'transactions.subtitle': 'Retrouver les transactions de vos clients',
    'transaction.field.id': 'Id',
    'transaction.field.type': 'Type',
    'transaction.field.brand': 'Enseigne',
    'transaction.field.customerEmail': 'Email',
    'transaction.field.date': 'Date',
    'transaction.field.paymentMethod': 'Moyen de paiement',
    'transaction.field.paymentStatus': 'Mode de paiement',
    'transaction.field.paymentAmount': 'Montant du paiement',
    'transaction.field.paymentAmount.tooltip': 'Montant payé par le client',
    'transaction.field.reversalAmount': 'Montant reversé par Innovorder',
    'transaction.field.reversalAmount.tooltip':
        'Montant reversé en prélevant la commission de paiement uniquement (le montant peut être négatif si les fonds ne passent pas par Innovorder et sont directement reversés sur votre compte bancaire)',
    'transaction.field.amount': 'Montant de la transaction',
    'transaction.field.amount.tooltip': 'Somme des montants reversés par Innovorder moins les remboursements',
    'transaction.field.fee': 'Commission',
    'transaction.field.channel': 'Canal',
    'transaction.field.transfer': 'Versement',
    'transaction.field.currency': 'Devise',
    'transaction.field.status': 'Statut',
    'transaction.field.ip': 'IP',
    'transaction.field.referer': 'Referer',
    'transaction.field.userAgent': 'User Agent',
    'transaction.field.customerCompleteName': 'Nom et prénom',
    'transaction.field.email': 'Email',
    'transaction.field.customerId': 'ID Client',
    'transaction.field.badgeNumber': 'N° badge',
    'transaction.field.lastUpdate': 'Date de mise à jour',
    'transaction.field.source': 'Source',
    'transaction.field.orderId': 'Numéro de commande',
    'transaction.field.error': 'Erreur',
    'transaction.field.restaurant': 'Restaurant',
    'transaction.field.paymentMethodType.WEB': 'CB en ligne',
    'transaction.field.paymentMethodType.PROXIMITY': 'CB',
    'transaction.field.paymentMethod.MEAL_VOUCHER': 'TR',
    'transaction.field.paymentMethod.BANK_CARD': 'CB',
    'transaction.status.PENDING': 'En cours',
    'transaction.status.PENDING_3DS': '3DS en cours',
    'transaction.status.DONE': 'Succès',
    'transaction.status.FAILED': 'Refus',
    'transaction.status.ERROR': 'Erreur',
    'transaction.type.CAPTURE': 'Paiement',
    'transaction.type.REFUND': 'Remboursement',
    'transaction.channel.WEB': 'Web',
    'transaction.channel.PROXIMITY': 'Proximité',
    'transaction.source.WEBORDERING': 'Commande en ligne',
    'transaction.source.EWALLET': 'Recharge Ewallet',
    'transaction.source.KIOSK': 'Borne',
    'transaction.source.NOTIFICATION': 'Notification',

    'transaction.detail.card.main': 'Détails de la transaction',
    'transaction.detail.card.finance': 'Données financières',
    'transaction.detail.card.web': 'Informations sur les données web',
    'transaction.detail.card.customer': 'Informations client',
    'transaction.detail.card.order': 'Commande associée',
    'transaction.detail.card.paymentMethod': 'Moyens de paiement',

    'transfers.title': 'Versements',
    'transfers.subtitle': 'Versements sur votre compte',

    'configuration.iopay.title': 'Configuration Adyen',
    'configuration.iopay.subtitle':
        'Ici, vous retrouverez toutes les entités légales que vous avez créées pour votre entreprise. Nous avons rassemblé pour vous une vue d’ensemble claire et concise de vos restaurants et e-wallet afin de faciliter leurs configurations.',
    'configuration.error.unaccessible': 'Introuvable ou permissions insuffisantes',

    'transfer.field.id': 'Id',
    'transfer.field.ref': 'Référence',
    'transfer.field.configurationName': 'Marchand',
    'transfer.field.amount': 'Montant du versement',
    'transfer.field.transactionCount': 'Nombre de transactions',
    'transfer.field.status': 'Statut',
    'transfer.field.executedAt': "Date d'exécution",
    'transfer.status.PENDING': 'En cours',
    'transfer.status.SUCCESS': 'Confirmé',
    'transfer.status.SENT_OUT': 'Envoyé',
    'transfer.status.FAILED': 'Échoué',
    'transfer.kpi.date': '{date, date} {date, time, ::HHmm}',
    'transfer.detail.title': 'Détails du versement',
    'transfer.transactions.title': 'Transactions du versement',

    'legalEntity.field.entity': 'Entité légale',
    'legalEntity.field.siret': 'SIRET',
    'legalEntity.field.city': 'Ville',
    'legalEntity.field.status': 'Statut',
    'legalEntity.field.associatedRestaurants': 'Restaurants associés',
    'legalEntity.field.actions': 'Actions',

    'legalEntity.create.title': 'Créer une entité légale',

    'legalEntity.status.1': 'Erreur KYC',
    'legalEntity.status.2': 'À compléter',
    'legalEntity.status.3': 'Traitement en cours',
    'legalEntity.status.4': 'OK',

    'legalEntity.action.addRestaurant': 'Ajouter un restaurant',
    'legalEntity.action.addEwallet': 'Ajouter un e-wallet',
    'legalEntity.action.completeKyc': 'Compléter le KYC',
    'legalEntity.action.updateKyc': 'Mettre à jour le KYC',

    'legalEntity.wizard.step1.title': "Création d'une nouvelle entité légale",
    'legalEntity.wizard.step1.legalName': 'Nom légal de la société',
    'legalEntity.wizard.step1.legalName.placeholder':
        'Veuillez saisir le nom légal de la société comme renseigné exactement sur le SIRET',
    'legalEntity.wizard.step1.legalName.tooltip': 'Nom légal de la société comme renseigné exactement sur le SIRET',
    'legalEntity.wizard.step1.organizationType': "Type d'organisation",
    'legalEntity.wizard.step1.organizationType.placeholder': "Veuillez sélectionner votre type d'organisation",
    'legalEntity.wizard.step1.siret': 'SIRET',
    'legalEntity.wizard.step1.siret.placeholder': 'Veuillez saisir votre SIRET',
    'legalEntity.wizard.step1.siret.tooltip': 'SIRET de la société',
    'legalEntity.wizard.step1.addressStreet': "Adresse de l'entité légale",
    'legalEntity.wizard.step1.addressStreet.placeholder': "Veuillez saisir l'adresse de l'entité légale",
    'legalEntity.wizard.step1.addressStreet2': "Complément d'adresse (optionnel)",
    'legalEntity.wizard.step1.addressStreet2.placeholder': "Veuillez saisir le complément d'adresse si nécessaire",
    'legalEntity.wizard.step1.addressZipcode': 'Code postal',
    'legalEntity.wizard.step1.addressZipcode.placeholder': 'Veuillez saisir votre code postal',
    'legalEntity.wizard.step1.addressCity': 'Ville',
    'legalEntity.wizard.step1.addressCity.placeholder': 'Veuillez saisir votre ville',
    'legalEntity.wizard.step1.industryCode': 'Code Industrie',
    'legalEntity.wizard.step1.contactEmail': 'Email de contact',
    'legalEntity.wizard.step1.contactEmail.placeholder':
        "Veuillez saisir l'adresse e-mail associée à cette entité légale",
    'legalEntity.wizard.step1.iban': 'IBAN',
    'legalEntity.wizard.step1.iban.placeholder': "Veuillez saisir l'IBAN de l'entité légale",
    'legalEntity.wizard.step1.iban.tooltip': "IBAN de l'entité légale",

    'legalEntity.wizard.step2.title': "Ajout d'un nouveau restaurant",
    'legalEntity.wizard.step2.titleMassCatering': "Ajout d'un nouveau restaurant ou e-wallet",
    'legalEntity.wizard.step2.chooseRestaurant': 'Sélectionner un restaurant',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': 'Sélectionner un restaurant ou e-wallet',
    'legalEntity.wizard.step2.completeFieldsTitle': 'Champs à compléter',
    'legalEntity.wizard.step2.conecsTitle': 'Identifiants CONECS',
    'legalEntity.wizard.step2.conecsTitleOptional': '(optionnel)',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        'Renseigner les identifiants CONECS (ID) pour pouvoir activer le moyen de paiement CONECS sur ce restaurant pour les paiements en proximité',
    'legalEntity.wizard.step2.ewallet': 'E-wallet',
    'legalEntity.wizard.step2.selectRestaurant': 'Restaurant',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': 'Restaurant ou e-wallet',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': 'Veuillez sélectionner un restaurant',
    'legalEntity.wizard.step2.phoneNumber': 'Numéro de téléphone',
    'legalEntity.wizard.step2.phoneNumber.placeholder':
        'Veuillez saisir le numéro de téléphone à associer à ce restaurant',
    'legalEntity.wizard.step2.shopperStatement': 'Titre sur le relevé bancaire',
    'legalEntity.wizard.step2.shopperStatement.placeholder':
        'Veuillez saisir le titre qui apparaîtera sur le relevé bancaire',
    'legalEntity.wizard.step2.shopperStatement.tooltip': 'Libellé présent sur le relevé bancaire du client final',
    'legalEntity.wizard.step2.restaurantAddressStreet': 'Adresse du restaurant',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder': "Veuillez saisir l'adresse du restaurant",
    'legalEntity.wizard.step2.restaurantAddressStreet2': "Complément d'adresse (optionnel)",
    'legalEntity.wizard.step2.restaurantAddressStreet2.placeholder':
        "Veuillez saisir le complément d'adresse si nécessaire",
    'legalEntity.wizard.step2.restaurantAddressZipcode': 'Code postal du restaurant',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder': 'Veuillez saisir le code postal du restaurant',
    'legalEntity.wizard.step2.restaurantAddressCity': 'Ville',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': 'Veuillez saisir la ville du restaurant',
    'legalEntity.wizard.step2.restaurantIban': 'IBAN',
    'legalEntity.wizard.step2.restaurantIban.placeholder': "Veuillez saisir l'IBAN pour le transfert de fonds",
    'legalEntity.wizard.step2.restaurantIban.tooltip':
        'Renseigner les identifiants CONECS (ID) pour pouvoir activer le moyen de paiement CONECS sur ce restaurant pour les paiements en proximité',
    'legalEntity.wizard.step2.conecsId': 'CONECS MID',
    'legalEntity.wizard.step2.conecsId.placeholder':
        'Veuillez saisir le MID CONECS présent sur votre carte de domiciliation',
    'legalEntity.wizard.step2.conecsAssociatedSiret': 'SIRET associé au contrat CONECS',
    'legalEntity.wizard.step2.conecsAssociatedSiret.placeholder': 'Veuillez saisir le SIRET associé au contrat CONECS',

    'legalEntity.organizationType.1': 'Société privée',
    'legalEntity.organizationType.2': 'Société publique',
    'legalEntity.organizationType.3': 'Partenariat constitué',
    'legalEntity.organizationType.4': 'Organisme à but non lucratif ou association caritative',
    'legalEntity.organizationType.5': 'Organisation gouvernementale',
    'legalEntity.organizationType.6': 'Association constituée en personne morale',

    'legalEntity.industryCode.specialFoodServices': 'Services alimentaires spécialisés',
    'legalEntity.industryCode.fullServiceRestaurants': 'Restaurants à service complet',
    'legalEntity.industryCode.limitedServiceRestaurants': 'Restaurants à service limité (restauration rapide)',
    'legalEntity.industryCode.cafeteriasGrillBuffets': 'Cafétérias, buffets-grill et buffets',
    'legalEntity.industryCode.snacksNonalcoholicBeverages': 'Snacks et bar de boissons non alcoolisées',
    'legalEntity.industryCode.bakeries': 'Boulangeries',

    // BILLING PAGE
    'billing.title': 'Mon espace facturation',
    'billing.subtitle': 'Bienvenue, cet espace a été créé pour simplifier la gestion des factures.',
    'billing.description':
        "Vous y trouverez les factures organisées chronologiquement par service de paiement, désormais il est facile de consulter des paiements récents, télécharger des factures et suivre l'historique des factures en un clic.",
    'billing.information.edit': 'Modifier les informations de facturation',
    'billing.noIssuedInvoices': 'Pas de factures émises',
    'billing.table.creationDate': 'Date de création',
    'billing.table.amount': 'Montant',
    'billing.table.status': 'Statut',
    'billing.table.service': 'Service',
    'billing.table.invoiceNumber': 'N° de facture',
    'billing.table.invoiceName': 'Nom de la facture',
    'billing.table.dueDate': "Date d'échéance",
    'billing.table.downloadPDF': 'Télécharger le PDF',

    'billing.editConfiguration.selectEntityStep.title': 'Entités légales',
    'billing.editConfiguration.selectEntityStep.subtitle':
        'Sélectionner une entité légale où modifier les informations de facturation',
    'billing.editConfiguration.selectEntityStep.legalEntity': 'Entités légales',
    'billing.editConfiguration.selectEntityStep.legalEntity.placeHolder': 'Veuillez sélectionner parmi la liste',
    'billing.editConfiguration.selectEntityStep.noLabel': 'Entité légale sans nom',

    'billing.editConfiguration.configureBillingStep.title': 'Informations de facturation',
    'billing.editConfiguration.configureBillingStep.beneficiaryName': 'Nom du bénéficiaire',
    'billing.editConfiguration.configureBillingStep.beneficiaryEmail': 'Adresse e-mail associé à la facture',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress': 'Adresse du bénéficiaire',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress2': 'Informations complémentaires',
    'billing.editConfiguration.configureBillingStep.beneficiaryZipCode': 'Code postal',
    'billing.editConfiguration.configureBillingStep.beneficiaryCity': 'Ville',
    'billing.editConfiguration.configureBillingStep.recipients': 'Destinataires de la facture',
    'billing.editConfiguration.configureBillingStep.recipients.placeholder': 'Addresses email des destinataires',
    'billing.editConfiguration.configureBillingStep.recipients.createLabel':
        'Ajouter l\'adresse email "{email}" aux destinataires',
    'billing.editConfiguration.configureBillingStep.genericErrorMessage':
        'Une erreur est survenue lors de la création ou modification des informations de configuration',

    'billing.invoices.download': 'Télécharger',

    'billing.invoices.status.1': 'À payer',
    'billing.invoices.status.2': 'Payée',

    'billing.invoices.psp.4': 'Stripe',

    'billing.invoices.name.4': 'Facture Stripe unifiée',

    'reports.title': 'Rapports Adyen',
    'reports.subtitle':
        'Consultez les transactions virées sur votre compte bancaire, avec le détail par transaction pour chaque virement. Ce rapport vous permet d’assurer une fiabilisation comptable des transactions E-wallet avec Adyen.',
    'reports.text': 'Générez un/des type(s) de rapport(s)',
    'reports.choosePeriod': 'Choisissez une période',
    'reports.chooseReport': 'Sélectionnez un ou plusieurs type(s) de rapport(s)',
    'reports.outgoingTransfers': 'Versements',
    'reports.reportType': 'TYPE(S) DE RAPPORT(S)',
    'reports.error.missingDates': 'Merci de choisir deux dates',
    'reports.error.missingReportType': 'Merci de choisir un rapport',
    'reports.error.missingBrand': "Pas d'enseigne liée à l'utilisateur actuel",

    // PRICING REVALUATION
    'pricingRevaluation.tableCard.title': 'Revalorisation des prix',
    'pricingRevaluation.tableCard.subtitle':
        "Indiquez le taux de revalorisation souhaité, s'il faut l'appliquer aux options, aux suppléments puis selectionnez les menus à revaloriser et cliquez sur le boutton valider.",
    'pricingRevaluation.input.placeholder': 'Taux de la revalorisation',

    // PAYMENT METHODES
    'consumptionMode.MODE_DELIVERY': 'Livraison',
    'consumptionMode.MODE_TAKE_AWAY': 'À emporter',
    'consumptionMode.MODE_SIT_IN': 'Sur place',
    'consumptionMode.MODE_DRIVE': 'Drive',
    'paymentMethods.tableCard.title': 'Gérez et configurez',
    'paymentMethods.tableCard.subtitle': 'vos moyens de paiement',
    'paymentMethods.tab.pos': 'Caisse(s)',
    'paymentMethods.tab.web': 'Commande en ligne',
    'paymentMethods.tab.kiosk': 'Borne(s)',
    'paymentMethods.tab.kiosk.integration.title': 'Paiements Immédiats',
    'paymentMethods.tab.kiosk.integration.desc1':
        'Le paiement par CB sur les bornes nécessite que le restaurant possède un compte Ingenico.',
    'paymentMethods.tab.kiosk.integration.desc2':
        'D’autres moyens de paiement immédiats sont disponibles si vous activez l’authentification sur les bornes. ',
    'paymentMethods.tab.kiosk.payment.title': 'Paiements à la collecte',
    'paymentMethods.tab.kiosk.payment.desc':
        'Indiquez aux utilisateurs les moyens de paiement acceptés par le restaurant au comptoir.',
    'paymentMethods.tab.kiosk.payment': 'Paiements',
    'paymentMethods.tab.kiosk.payment.accepted': 'acceptés',
    'paymentMethods.tab.kiosk.payment.refused': 'refusés',
    'paymentMethods.consumptionMode': 'Sélectionner les modes de consommation',
    'paymentMethods.externalId': 'Code externe',
    'configure.ingenico': 'Configurer Ingenico',
    'configure.nepting': 'Configurer Nepting',
    'configure.stripe': 'Configurer Stripe',
    'configure.edenred': 'Configurer Edenred',
    'configure.iopay': 'Configurer Adyen',
    'configure.paygreen': 'Configurer Paygreen',
    'configure.ewallet': 'Configurer E-Wallet',
    'configure.yavin': 'Configurer IOPay',
    'configure.yavin.neptingConfigured': 'Impossible de configurer IOPay, Nepting étant utilisé.',
    'configure.nepting.yavinConfigured': 'Impossible de configurer Nepting, IOPay étant utilisé.',
    'configure.stripe.iopayConfigured': 'Impossible de configurer Stripe, Adyen étant utilisé.',
    'configure.iopay.stripeConfigured': 'Impossible de configurer Adyen, Stripe étant utilisé.',

    // CUSTOMER FORM
    'customer.form.modalDescription': 'Veuillez remplir les informations obligatoires *',
    'customer.form.firstName': 'Prénom *',
    'customer.form.lastName': 'Nom *',
    'customer.form.badgeNumber': 'N° BADGE {index} *',
    'customer.form.badgeType': 'Type de badge',
    'customer.form.badge.default': 'Définir comme principal',
    'customer.form.badgeType.placeholder': 'Veillez renseigner le type de badge',
    'customer.form.addBadge': 'Ajouter un badge',
    'customer.form.email': 'Adresse mail *',
    'customer.form.phoneNumber': 'N° téléphone (Facultatif)',
    'customer.form.arrivalDate': "Date d'arrivée (Facultatif)",
    'customer.form.departureDate': 'Date de départ (Facultatif)',
    'customer.form.password': 'Mot de passe *',
    'customer.form.confirmPassword': 'Confirmez votre mot de passe *',
    'customer.form.clientInfoSection': 'Informations générales du convive',
    'customer.form.pricingRuleSection': 'Configuration des règles tarifaires',
    'customer.form.accountPaymentTypeLabel': 'Type de compte client *',
    'customer.form.accountPaymentTypePlaceHolder': 'Veuillez sélectionner un type de compte client',
    'customer.form.guestGroupIdLabel': 'Groupe *',
    'customer.form.guestGroupIdPlaceHolder': 'Veuillez sélectionner un groupe',
    'customer.form.pricingRuleCodeLabel': 'Régime tarifaire Code *',
    'customer.form.pricingRuleCodePlaceHolder': 'Veuillez sélectionner un régime tarifaire',
    'customer.form.tariffCode': 'CODE TARIF (FACULTATIF)',
    'customer.form.studentNumber': 'N° CONVIVE (FACULTATIF)',
    'customer.form.pricingRuleInfo': "Votre code de régime tarifaire n'apparait pas dans la liste? Veuillez le créer ",
    'customer.form.groupInfo': 'Pour définir vos groupes, allez sur la page Enseigne > Hiérarchisation ',
    'customer.form.sectionInfo': 'Pour définir vos sections, allez sur la page Enseigne > Hiérarchisation ',
    'customer.form.subSectionInfo': 'Pour définir vos sous-sections, allez sur la page Enseigne > Hiérarchisation ',
    'customer.form.here': 'ici',
    'customer.form.section': 'SECTION (FACULTATIF)',
    'customer.form.subSection': 'SOUS-SECTION (FACULTATIF)',

    // Customer form selectOptions
    'customer.form.selectOptions.cash': 'Comptant',
    'customer.form.selectOptions.prepayment': 'Pré-paiement',
    'customer.form.selectOptions.postpayment_bankdebit': 'Post-paiement: retrait sur salaire',
    'customer.form.selectOptions.postpayment_guest': 'Post-paiement: invités',

    // BRAND CUSTOMERS LIST
    'brand.customers.action.import': 'Importer',
    'brand.customers.action.export': 'Exporter',
    'brand.customers.page.title': 'Clients',
    'brand.customers.page.description': 'Vous trouverez ici la liste complète des clients inscrits à votre enseigne.',

    // IMPORT CUSTOMERS MODAL
    'customer.modal.import.title': 'Importer des clients',
    'customer.modal.import.firstPart': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'customer.modal.import.secondPart': 'Remplissez le fichier avec les données de vos clients',
    'customer.modal.import.thirdPart': 'Téléversez le fichier pour importer vos clients',
    'customer.modal.import.report.title': "Rapport d'import",
    'customer.modal.import.report.result': 'Résultat',
    'customer.modal.import.report.success': 'Succès',
    'customer.modal.import.report.error': 'Erreur',
    'customer.modal.import.report.message': '{created} créés, {updated} mis à jour, {unchanged} inchangés',
    'customer.modal.import.warning':
        "Attention ! Les colonnes 'Code tarif', 'Code subvention', 'Code admission' et 'Code régime tarifaire' sont dépréciées et seront ignorées à l'import. Veuillez utiliser le tableau des régimes tarifaires pour configurer ces informations.",
    'customer.modal.import.addNew.title': 'Ajouter de nouveaux clients',
    'customer.modal.import.addNew.step1': 'Téléchargez le {link} sur votre ordinateur',
    'customer.modal.import.addNew.step1.link': 'fichier modèle',
    'customer.modal.import.addNew.step2': 'Remplissez le fichier avec les données de vos nouveaux clients',
    'customer.modal.import.addNew.step3': 'Téléversez le fichier rempli ci-dessous',
    'customer.modal.import.update.title': 'Mettre à jour des clients existants',
    'customer.modal.import.update.step1': 'Téléchargez {link} sur votre ordinateur',
    'customer.modal.import.update.step1.link': 'la base clients actuelle',
    'customer.modal.import.update.step1.loading': 'Chargement...',
    'customer.modal.import.update.step2': 'Modifiez les données des clients que vous souhaitez mettre à jour',
    'customer.modal.import.update.step3': 'Téléversez le fichier modifié ci-dessous',
    'customer.modal.import.update.warning':
        "Note: L'identifiant client doit correspondre à un client existant pour que la mise à jour soit effectuée.",
    'customer.modal.import.options.title': "Options d'import",
    'customer.modal.import.options.multiBadge': 'Import multi-badge',
    'customer.modal.import.options.autoImportGuestHierarchy':
        'Import automatique de la hiérarchie (groupes, sections, sous-sections)',
    'customer.modal.import.error.noResponse': "L'import a échoué - aucune réponse du serveur",
    'customer.modal.import.error.invalidResponse': 'Réponse invalide du serveur',
    'customer.modal.import.error.fileTooLarge': 'Le fichier est trop volumineux (max 20 Mo)',
    'customer.modal.import.loading.reading': 'Lecture du fichier en cours...',
    'customer.modal.import.loading.importing': 'Import en cours...',
    'customer.modal.import.result.lineError': 'Ligne {lineNumber}{nameDisplay} : {error}',
    'customer.modal.import.result.fieldError': "Les champs ({fields}) n'ont pas été modifiés (ligne {line})",
    'customer.modal.import.result.genericError': 'Une erreur est survenue',
    'customer.modal.import.result.created': 'Clients créés : {count}',
    'customer.modal.import.result.updated': 'Clients mis à jour : {count}',
    'customer.modal.import.result.unchanged': 'Clients non modifiés/non créés : {count}',
    'customer.modal.import.result.errors': 'Erreurs',
    'customer.modal.import.result.warnings': 'Avertissements',
    'customer.modal.import.result.otherWarning.PRICING_RULE':
        "Certaines règles tarifaires n'existent pas sur le système : ",
    'customer.modal.import.result.otherWarning.ENTRANCE_FEE': "Certaines admissions n'existent pas sur le système : ",
    'customer.modal.import.result.otherWarning.EMPTY_GUEST_GROUP': 'Certains convives ont un groupe vide (lignes : ',
    'customer.modal.import.result.otherWarning.UNEXISTING_GUEST_GROUP':
        "Certains groupes de convives n'existent pas (lignes : ",
    'customer.modal.import.result.otherWarning.UNAUTHORIZED_PRICING_RULE':
        'Certaines règles tarifaires ne sont pas autorisées pour le groupe (lignes : ',
    'customer.modal.import.result.restrictedFieldsInfo':
        'Les champs "Mot de passe", "Code pin" et "Solde" ne peuvent être mis à jour que si le client n\'a pas encore effectué de transaction.',

    // CREATE CUSTOMER
    'customer.create.modalTitle': 'Créer un nouveau convive',

    // UPDATE A CUSTOMER
    'customer.update.modalTitle': 'Modification du convive',

    // CUSTOMER INFO TABS
    'customer.tab.info': 'Informations',
    'customer.tab.ewallet': 'E-Wallet',
    'customer.tab.student': 'Restauration Collective',
    'customer.tab.orders': 'Historique des commandes',

    // CUSTOMER ROUTES
    'route.customerPricingPolicy': 'Politique tarifaire',

    // CUSTOMER PRICING POLICY
    'customer.pricingPolicy.defaultTitle': 'Politique par défaut',
    'customer.pricingPolicy.defaultDescription':
        'La politique tarifaire par défaut sera appliquée à tout client créant son compte via le module de commande web.',
    'customer.pricingPolicy.customTitle': 'Politique personnalisée',
    'customer.pricingPolicy.entranceFee': "Frais d'admission",
    'customer.pricingPolicy.pricingPolicy': 'Régime tarifaire',
    'customer.pricingPolicy.group': 'Groupe',
    'customer.pricingPolicy.groupPlaceholder': 'MON GROUPE',
    'customer.pricingPolicy.domainName': 'Nom de domaine',
    'customer.pricingPolicy.delete': 'Supprimer',
    'customer.pricingPolicy.noEntranceFee': 'Aucune admission',
    'customer.pricingPolicy.noPricingRule': 'Aucune règle tarifaire',
    'customer.pricingPolicy.noGroup': 'Aucun groupe',
    'customer.pricingPolicy.enableWhitelisting': 'Restreindre inscription aux domaines déclarés',
    'customer.pricingPolicy.enableWhitelistingInfo':
        "En activant cette option, l'inscription en ligne n'est autorisée que pour les domaines déclarés",
    'customer.pricingPolicy.save': 'Enregistrer',

    // CUSTOMER INFO STUDENT TAB
    'customer.student.info.title': 'Informations',
    'customer.student.info.desctiption': 'Les informations relatives au mode Restauration Collective.',
    'customer.student.info.account.type': 'Type de badge',
    'customer.student.info.group': 'Groupe',
    'customer.student.info.section': 'Section',
    'customer.student.info.sub.section': 'Sous-section',
    'customer.student.info.badge.number': 'N° Badge',
    'customer.student.info.pricing.code': 'Code tarif',
    'customer.student.info.student.number': 'N° Convive',
    'customer.student.pricing.rules.title': 'Règles tarifaires',
    'customer.student.pricing.rules.desctiption':
        'Vous pouvez attribuer à chaque client des règles tarifaires spécifiques. Un client peut avoir un code subvention et / ou admission OU un code régime tarifaire (un ensemble de frais d’admission et / ou de subventions).',
    'customer.student.pricing.rules.deprecated':
        '⚠️ Les champs code admission et code subvention sont maintenant dépréciés, au profit du champ Code Régime tarifaire (qui regroupe admissions et subventions). {moreInfo}',
    'customer.student.pricing.rules.more_info': "Plus d'informations",
    'customer.student.pricing.rules.grant.code': 'Code subvention',
    'customer.student.pricing.rules.entrance.fee.code': 'Code admission',
    'customer.student.pricing.rules.code': 'Code régime tarifaire',
    'customer.student.overdraft.title': 'Découvert E-Wallet autorisé',
    'customer.student.overdraft.desctiption':
        "Vous pouvez personnaliser le découvert maximum autorisé d'un client pour l'utilisation de son E-wallet.",
    'customer.student.overdraft.price.label': 'Découvert E-Wallet autorisé',
    'customer.student.overdraft.disabled': 'Le découvert E-wallet par défaut est affecté à ce client.',
    'customer.student.badge.title': 'Blocage du badge principal du convive',
    'customer.student.badge.description': 'Vous pouvez temporairement bloquer le fonctionnement du badge principal.',
    'customer.student.badge.table.default': 'Principal',
    'customer.student.badge.table.number': 'Numéro de badge',
    'customer.student.badge.table.type': 'Type',
    'customer.student.badge.table.status': 'Etat',
    'customer.student.badge.table.action': 'Action',
    'customer.student.badge.table.status.active': '✓ Activé',
    'customer.student.badge.table.status.blocked': '✕ Bloqué',
    'customer.student.add.badge': '+ Ajouter un badge',
    'customer.student.badge.form.add': 'Ajouter un badge',
    'customer.student.badge.form.update': 'Editer un badge',
    'customer.student.badge.form.default': 'Définir comme principal',
    'customer.ordersList.title': 'Commandes',
    'customer.ordersList.subtitle': 'Retrouver les commandes de votre client',
    'customer.ordersList.downloadTickets': 'Télécharger les tickets',
    'customer.ordersList.exportStarted': 'Export des tickets en cours. Veuillez patienter...',
    'customer.ordersList.exportSuccess': 'Tickets exportés avec succès !',
    'customer.ordersList.exportFailed': "L'export des tickets a échoué. Veuillez réessayer.",
    'customer.ordersList.exportNoTicketsForDates': 'Aucun ticket pour les dates sélectionnées.',
    'customer.ordersList.downloadChoice.all': 'Tous les tickets',
    'customer.ordersList.downloadChoice.selectedRange': 'Uniquement les dates sélectionnées',
    'order.field.downloadTicket': 'Télécharger',

    'pricingRevaluation.options.exceeding': 'Appliquer aux dépassements',
    'pricingRevaluation.options.options': 'Appliquer aux options',
    'pricingRevaluation.options.updateInPlace': 'Menu frigo connecté/scan plateau',
    'pricingRevaluation.options.updateInPlace.tooltip':
        "Si la checkbox est cochée, la revalorisation s'appliquera directement sur le menu original, afin de conserver les id (une copie du menu sans revalorisation sera créée). \nSi la checkbox est décochée, la revalorisation sera appliquée sur une copie du menu (nouveaux ids) et le menu original ne sera pas changé.",
    'pricingRevaluation.table.menu.name': 'Nom du menu',
    'pricingRevaluation.table.menu.isActive': 'Menu actif',
    'pricingRevaluation.table.menu.channels': 'Canaux',
    'pricingRevaluation.table.menu.selected': 'Selectionné',
    'pricingRevaluation.table.emptyMessage': 'Aucun menus trouvé pour ce restaurant',
    'pricingRevaluation.table.search': 'Rechercher des menus',

    // POS LAYOUT
    'pos_layout.name': 'Plan de touche POS',
    'pos_layout.page.title': 'Plan de touche POS',
    'pos_layout.page.description': 'Organiser votre plan de touche puis déployer le sur le ou les POS associés.',
    'pos_layout.sort': 'Réorganiser',
    'pos_layout.sort.random': 'Aléatoire',
    'pos_layout.sort.by_name': 'Par nom',
    'pos_layout.sort.by_price': 'Par prix',
    'pos_layout.tabletSize': 'Taille de la tablette',
    'pos_layout.inches': 'Pouces',
    'pos_layout.publishDescription':
        'Êtes-vous sûr de vouloir sauvegarder et publier le menu et le plan de touche sur le(s) POS associé(s) ?',
    'pos_layout.assignPos': 'Associer des POS',
    'pos_layout.modal.warning': 'Attention',
    'pos_layout.modal.publish.description':
        'Les catégories suivantes du plan de touche ne possèdent aucun produit associé : \n• {categories} \nSouhaitez-vous confirmer la publication de ce plan de touche ?',
    'pos_layout.modal.save.description':
        'Les catégories suivantes du plan de touche ne possèdent aucun produit associé : \n• {categories} \nSouhaitez-vous confirmer la sauvegarde de ce plan de touches ?',
    'pos_layout.customPrice': 'Prix libre',
    'pos_layout.functions.create.title': 'Ajouter une touche fonction',
    'pos_layout.functions.edit.title': 'Modifier la touche fonction',
    'pos_layout.functions.type': 'Type de touche',
    'pos_layout.functions.type.placeholder': 'Sélectionner un type',
    'pos_layout.functions.type.webview': 'Link Web / URL',
    'pos_layout.functions.name': 'Nom de la touche',
    'pos_layout.functions.url': 'Lien Web/URL cible',
    'pos_layout.functions.submit': 'Enregistrer',
    'pos_layout.functions.verifyLink': 'Vérifier le lien',
    'pos_layout.functions.widthPercent': 'Largeur',
    'pos_layout.functions.heightPercent': 'Hauteur',

    // POS DEVICE
    'pos_device.role.independent': 'Indépendante',
    'pos_device.role.master': 'Principale',
    'pos_device.role.slave': 'Dépendante',
    'pos_device.role.independent.plural': 'Indépendantes',
    'pos_device.role.master.plural': 'Principales',
    'pos_device.role.slave.plural': 'Dépendantes',

    // ACTIONS
    'action.action': 'Action',
    'action.edit': 'Éditer',
    'action.duplicate': 'Dupliquer',
    'action.copy': 'Copier',
    'action.export': 'Exporter',
    'action.publish': 'Publier',
    'action.delete': 'Supprimer',
    'action.hide': 'Masquer',

    // CUSTOMERS
    'customers.page.title': 'Clients',
    'customers.page.description': 'Consultez vos clients',
    'customers.id': 'ID',
    'customers.name': 'Client',
    'customers.email': 'Email',
    'customers.phone': 'Numéro de téléphone',
    'customers.totalSpentAmount': 'Total dépensé',
    'customers.orderCount': 'Nombre de commandes',
    'customers.averageCart': 'Panier moyen',
    'customers.lastOrder': 'Dernière commande',
    'customers.frequency': 'Fréquence',
    'customers.status': 'Statut',
    'customers.ewalletBalance': 'Solde E-Wallet',
    'customers.archivedAt': 'Archivé le',
    'customers.disabledAt': 'Désactivé le',
    'customers.showArchivedCustomers': 'Afficher les clients archivés',
    'customers.showDisabledCustomers': 'Afficher les clients désactivés',
    'customers.options': 'Options',
    'customers.domainNames': 'Noms de domaines',
    'customers.selectDomainNames': 'Sélectionner des noms de domaines',
    'customers.groups': 'Groupes',
    'customers.selectGroups': 'Sélectionner des groupes',

    // MENU
    'menu.name': 'Nom du menu',
    'menu.categories': 'Catégories',
    'menu.products': 'Produits',
    'menu.functions': 'Fonctions',
    'menu.page.title': 'Menus',
    'menu.page.description': 'Créez et gérez vos menus',
    'menu.table.associatedChannels': 'Canaux associés',
    'menu.action.newMenu': '+ Nouveau menu',
    'menu.action.manualImportCrous': 'Forcer Import Crous',
    'menu.action.seeOperations': 'Voir les opérations',
    'menu.action.changeColor': 'Changer la couleur',
    'menu.action.editProduct': 'Modifier le produit',
    'menu.action.editCategory': 'Modifier la catégorie',
    'menu.action.editFunction': 'Modifier la fonction',
    'menu.action.import': 'Importer un menu',
    'menu.action.noImport': 'Je ne souhaite pas importer de fichier',
    'menu.modal.manualImportCrous.title': 'Import manuel du catalogue CROUS',
    'menu.modal.manualImportCrous.description':
        'Etes-vous sûr de vouloir lancer un import manuel du catalogue du CROUS pour ce restaurant?',
    'menu.action.aiMenuScan': 'IA Scan (beta)',
    'menu.modal.aiMenuScan.title': 'Numériser votre nouveau menu (beta)',
    'menu.modal.aiMenuScan.description.part1': 'Importer votre nouveau menu au format PDF ou image',
    'menu.modal.aiMenuScan.description.part2': 'Cliquer sur générer le menu Excel',
    'menu.modal.aiMenuScan.description.part3':
        'Télécharger automatiquement le fichier Excel du nouveau menu avec les informations disponibles',
    'menu.modal.aiMenuScan.action.cancel': 'Annuler',
    'menu.modal.aiMenuScan.action.generate': 'Générer le menu excel',
    'menu.modal.bannersDeactivated':
        '{count, plural, one {# bannière promotionnelle a été désactivée} other {# bannières promotionnelles ont été désactivées}}',
    'menu.modal.create.importMenu': 'Importer un menu',
    'menu.modal.create.createMenu': 'Créer un menu',
    'menu.modal.error.wrongName': 'Renseignez un nom valide',
    'menu.modal.create.import.excel.tab': 'Excel',
    'menu.modal.create.import.json.tab': 'JSON',
    'menu.modal.create.import.pos.tab': 'Caisse',
    'menu.modal.create.import.excel.title': 'Ajouter un nouveau menu',
    'menu.modal.create.import.excel.description.firstPart': 'Télécharger le {fileTemplate} sur votre ordinateur',
    'menu.modal.create.import.excel.description.secondPart':
        'Remplir le fichier modèle avec les informations de vos produits composant le nouveau menu',
    'menu.modal.create.import.excel.description.thirdPart':
        'Importer votre nouveau fichier en cliquant sur le bouton ci-dessous',
    'menu.modal.create.import.pos.title': 'Importer un menu existant',
    'menu.modal.create.import.pos.description.firstPart':
        'Choisissez une caisse innovorder dont vous souhaitez importer le menu',
    'menu.modal.create.import.json.title': 'Importer un menu existant',
    'menu.modal.create.import.json.description.firstPart': 'Vérifiez que votre fichier est bien au format JSON',
    'menu.modal.create.import.json.description.secondPart':
        'Importer votre nouveau fichier en cliquant sur le bouton ci-dessous',
    'menu.modal.duplicate.title': 'Dupliquer un menu',
    'menu.modal.delete.title': 'Supprimer un menu',
    'menu.modal.delete.description': 'Êtes-vous sûr de vouloir supprimer le menu : "{menuName}"\xa0?',
    'menu.modal.copy.title': 'Copier un menu',
    'menu.modal.publish.title': 'Publier le menu',
    'menu.modal.publish.autoPublish': 'Recharger les bornes après validation',
    'menu.modal.publish.devicePublish': 'Publier les menus sur les POS suivants :',
    'menu.modal.publish.deliverooPublish': 'Publier les menus sur les marques Deliveroo suivantes :',
    'menu.modal.publish.ubereatsPublish': 'Publier les menus sur les marques UberEats suivantes :',
    'menu.modal.publish.duplicateBarCode':
        '\n- Le code barre {barCode} est dupliqué pour les produits suivants : {products}',
    'menu.modal.error.name': 'Entrez un nom dans le champ dédié',
    'menu.modal.error.channels': 'Il faut désactiver l’option de synchronisation avec les caisses associées',
    'menu.modal.menu.name': 'Nom du menu',
    'menu.modal.message.defaultIncompatibleDisclaimer':
        'Vous ne pouvez associer que des caisses maitres ou indépendantes avec une version 7.0 minimum',
    'menu.modal.message.versionIncompatibleDisclaimer':
        'Vous ne pouvez associer que des caisses avec une version {values} minimum',
    'menu.modal.message.roleIncompatibleDisclaimer': 'Vous ne pouvez pas associer des caisses {values}',
    'menu.modal.channels.shouldSyncPos': 'Synchronisation avec les caisses',
    'menu.modal.channels.isSyncFromPosEnabled':
        'Mettre à jour le menu lors de modifications depuis les caisses associées',
    'menu.modal.channels.selectActive': 'Activer le menu sur les canaux suivants',
    'menu.modal.channels.associatedChannels': 'Canaux associés',
    'menu.modal.channels.pos.selectActive': 'Sélectionner les caisses à associer au menu',
    'menu.modal.channels.deliveroo.selectActive': 'Sélectionner les marques Deliveroo à associer au menu',
    'menu.modal.channels.ubereats.selectActive': 'Sélectionner les marques UberEats à associer au menu',
    'menu.modal.channels.pos.notFound': "Aucune caisse n'a été trouvée.",
    'menu.modal.channels.associatePos': 'Associer des caisses',
    'menu.modal.channels.associateDeliveroo': 'Associer les marques Deliveroo',
    'menu.modal.channels.associateUberEats': 'Associer les marques UberEats',
    'menu.modal.channels.editMenu': 'Édition du menu',
    'menu.modal.channels.createMenu': 'Création du menu',
    'menu.modal.channels.selectPos': 'Sélection des caisses',
    'menu.modal.channels.selectDeliveroo': 'Sélection des marques Deliveroo',
    'menu.modal.channels.selectUberEats': 'Sélection des marques UberEats',
    'menu.modal.externalId': 'Code externe',
    'menu.modal.warn.shift.title': 'Opération dangereuse',
    'menu.modal.warn.shift.text': `L'édition d'un menu pendant un service peut perturber l'expérience du client sur les bornes associées.`,
    'menu.modal.warn.shift.button': 'OK',

    'menu.importPOS.cancel': 'Pas maintenant',
    'menu.importPOS.title': 'Import des menus caisses manquants sur le backoffice',
    'menu.importPOS.step1.title': 'Nouveau: Ajouter les menus de vos caisses ici en un clic !',
    'menu.importPOS.step1.bullet.1': 'Une gestion plus simple et plus approfondie du plan de touche et des menus',
    'menu.importPOS.step1.bullet.2':
        "La possibilité de préparer son plan de touche en avance et de l'activer en un clic",
    'menu.importPOS.step1.bullet.3':
        "La possibilité d'utiliser le même menu pour la caisse, la borne et la commande en ligne",
    'menu.importPOS.step1.info':
        "Seules les caisses d'une version supérieure à 7 et de catégorie indépendante ou master peuvent avoir leur menu sur le back-office",
    'menu.importPOS.step2.pos': 'Caisses importées sur le back-office',
    'menu.importPOS.step2.switch': 'Mettre à jour le menu lors de futures modifications depuis la caisse associée',
    'menu.importPOS.step3.title': "C'est tout bon !",
    'menu.importPOS.step3.subtitle': 'Vous pouvez désormais gérer vos caisses directement depuis le back-office !',
    'menu.importPOS.step3.link': 'Accéder à la documentation',
    'menu.importPOS.step3.info1': 'Cliquez sur le menu de votre choix pour le consulter et le modifier',
    'menu.importPOS.step3.info2':
        'Vous pouvez dupliquer un menu pour préparer votre prochaine carte ou modifier pour chaque menu les caisses et autres modes de consommation associés',
    'menu.importPOS.step3.info3':
        "Tant que vous ne publiez pas un menu, il restera inchangé sur les caisses associées.\n<strong>Vous devez donc effectuer l'action de publier pour que les modifications apportées au menu sur le back-office soient mises à jours sur les caisses.</strong>\nCela peut se faire dans les options de chaque menu sur la page des menus ou depuis la page du plan de touche.",

    'menuoperation.page.title': 'Opérations sur les menus',
    'menuoperation.page.description': 'Retrouvez les opérations sur les menus pour votre restaurant',
    'menuoperation.type': 'Type',
    'menuoperation.type.update': 'Mise à jour',
    'menuoperation.type.publish': 'Publication',
    'menuoperation.type.propagation': 'Propagation',
    'menuoperation.message.from': 'Depuis',
    'menuoperation.message.from.brandMenu': 'Depuis menu enseigne:',
    'menuoperation.message.to': 'Vers',
    'menuoperation.errorModal.title': 'Rapport de la publication',
    'menuoperation.errorModal.message': "La publication n'a pas pu aboutir.",
    'menuoperation.errorModal.checklist.intro': 'Veuillez vérifier les points suivants avant de valider à nouveau :',
    'menuoperation.errorModal.checklist.requiredFields': 'Tous les champs obligatoires du produit sont complétés',
    'menuoperation.errorModal.checklist.requiredMenuImage': 'Le menu possède une image',
    'menuoperation.errorModal.checklist.noSubCategories': 'Le menu ne possède pas de sous-catégories',
    'menuoperation.errorModal.checklist.imageFormats':
        'Les images respectent les formats requis (entre 320x320px et 6000x6000px)',
    'menuoperation.errorModal.checklist.syncSettings': 'Les paramètres de synchronisation sont correctement configurés',
    'menuoperation.errorModal.checklist.stepDepthLimit':
        "La limite de profondeur des étapes n'est pas dépassée (2 niveaux max pour Deliveroo).",
    'menuoperation.actions': 'Actions',
    'menuoperation.action.download': 'Menu précédent',
    'menuoperation.action.download.before': 'Menu initial',
    'menuoperation.action.download.after': 'Menu final',
    'menuoperation.download.error.title': 'Échec du téléchargement',
    'menuoperation.download.error': 'Impossible de télécharger le menu archivé. Veuillez réessayer plus tard.',

    // Menu tags
    'menu.tags.title': 'Tags',
    'menu.tags.table.name': 'Nom',
    'menu.tags.create.link': 'Créer un nouveau tag',
    'menu.tags.create.error.alreadyTaken': 'Ce tag existe déjà',
    'menu.tags.edit.title': 'Éditer un tag',
    'menu.tags.create.title': 'Créer un tag',
    'menu.tags.form.color.label': 'Couleur',
    'menu.tags.delete.confirm': 'Êtes-vous sûr de vouloir supprimer {count} tag(s) ?',

    // Menu functions
    'menu.functions.title': 'Fonctions',
    'menu.functions.subtitle': 'Ajoutez, modifiez et assignez des fonctions à votre plan de touches',
    'menu.functions.table.name': 'Nom',
    'menu.functions.table.type': 'Type',
    'menu.functions.table.status': 'Status',
    'menu.functions.table.action': 'Action',
    'menu.functions.status.active': 'Active',
    'menu.functions.status.inactive': 'Inactive',
    'menu.functions.noData': 'Aucune fonction créée',
    'menu.functions.delete.confirm': 'Êtes-vous sûr de vouloir supprimer {count} fonction(s) ?',

    // Menu steps
    'menu.steps.title': 'Étapes',
    'menu.steps.add.title': 'Nouvelle Étape',
    'menu.steps.duplicate': 'Dupliquer',
    'menu.steps.convert': 'Convertir',
    'menu.steps.delete.confirm': 'Êtes-vous sûr de vouloir supprimer {count} étape(s) ?',
    'menu.steps.convert.toCustomization.confirm':
        'Suite à la conversion, il sera nécessaire de paramétrer les détails et options de votre étape de personnalisation, souhaitez vous continuer ?',
    'menu.steps.convert.toCrossSelling.confirm':
        'En convertissant l’étape, les informations sur les choix minimum / maximum et les options activées ne seront pas conservées, voulez-vous continuer ?',
    'menu.steps.bulkConvertError':
        'Afin de pouvoir convertir de manière groupée, il faut que toutes les étapes soient du même type (vente additionnelle ou personnalisation)',
    'menu.steps.column.name': 'Nom',
    'menu.steps.column.choices': 'Choix possibles',
    'menu.steps.column.min': 'Min',
    'menu.steps.column.max': 'Max',
    'menu.steps.column.stepRef': 'Référence',
    'menu.steps.column.parentsProducts': 'Nombre de produits parents',
    'menu.steps.edit.title': 'Éditer une étape',
    'menu.steps.editCustomization.title': 'Éditer une étape de personnalisation',
    'menu.steps.editCrossSelling.title': 'Éditer une étape de vente additionnelle',
    'menu.steps.createCustomization.title': 'Créer une personnalisation',
    'menu.steps.createCrossSelling.title': 'Créer une vente additionnelle',
    'menu.steps.convert.title': 'Attention',
    'menu.steps.column.type': 'Type',
    'menu.steps.typeName.1': 'Personnalisation',
    'menu.steps.typeName.2': 'Vente additionnelle',
    'menu.steps.form.ticketLabel': 'Label du ticket',
    'menu.steps.form.minChoice': 'Choix minimum',
    'menu.steps.form.maxChoice': 'Choix maximum',
    'menu.steps.form.stepRef': 'Référence',
    'menu.steps.form.maxChoice.error.greaterThanMin': 'Doit être supérieur au minimum',
    'menu.steps.form.isDescriptionDisplayEnabled': 'Afficher les descriptions',
    'menu.steps.form.options': 'Options',
    'menu.steps.form.isExcessAllowed': 'Dépassement',
    'menu.steps.form.isGroupEnabled': 'Regroupement',
    'menu.steps.form.isImageDisplayEnabled': 'Afficher les images',
    'menu.steps.form.isQuantitySelectionEnabled': 'Quantité',
    'menu.steps.form.isWeightStrategyEnabled': 'Utiliser les poids',
    'menu.steps.form.stepProduct': 'Liste des choix',
    'menu.steps.form.stepProduct.add': 'Ajouter un choix',
    'menu.steps.form.stepProduct.orderByName': 'Trier par nom',
    'menu.steps.form.stepProduct.orderByPrice': 'Trier par prix',
    'menu.steps.form.stepProduct.setForAllOption': 'Propager les valeurs',
    'menu.steps.form.stepProduct.name': 'Nom',
    'menu.steps.form.stepProduct.price': 'Prix',
    'menu.steps.form.stepProduct.excessPrice': 'Prix en dépassement',
    'menu.steps.form.stepProduct.weight': 'Poids unitaire',
    'menu.steps.form.stepProduct.group': 'Groupe',
    'menu.steps.form.stepProduct.maxQuantity': 'Quantité maximum',
    'menu.steps.form.stepProduct.posIsSelectedByDefault': 'Sélectionné par défaut (POS)',
    'menu.steps.form.stepProduct.posMinProductQuantity': 'Quantité minimum (POS)',
    'menu.steps.form.stepProduct.posDefaultProductQuantity': 'Quantité par défaut (POS)',
    'menu.steps.form.stepProduct.displayPOSFields': 'Afficher les attributs POS',
    'menu.steps.form.stepProduct.import': 'Importer',
    'menu.steps.form.stepProduct.importWithPrice': 'Importer avec le prix',
    'menu.steps.form.stepProduct.importWithoutPrice': 'Importer sans le prix',
    'menu.steps.propagate.title': 'Propager des étapes',

    // Menu categories
    'menu.categories.title': 'Catégories',
    'menu.categories.subtitle': 'Éditer les catégories de votre menu',
    'menu.categories.addCategory': 'Créer une catégorie',
    'menu.categories.noData': 'Aucune catégorie dans le menu.',
    'menu.categories.addProduct': 'Ajouter un produit',
    'menu.categories.createProduct': 'Créer un produit',
    'menu.categories.deleteCategory': 'Supprimer',
    'menu.categories.removeProduct': 'Retirer',
    'menu.categories.deleteCategory.confirm':
        'Êtes-vous sûr de vouloir supprimer cette catégorie ?\nElle ne sera plus disponible et ses enfants (produits et sous catégories) deviendront orphelins.',
    'menu.categories.create.title': 'Créer une catégorie',
    'menu.categories.edit.title': 'Éditer une catégorie',
    'menu.categories.products': '{productCount, plural, =0 {aucun produit} one {# produit} other {# produits}}',
    'menu.categories.create.error.alreadyTaken': 'Cette catégorie existe déjà',

    // Menu products
    'menu.products.title': 'Produits',
    'menu.products.table.image': 'Image',
    'menu.products.table.name': 'Nom',
    'menu.products.table.categories': 'Catégories',
    'menu.products.table.price': 'Prix',
    'menu.products.table.vat': 'TVA',
    'menu.products.table.sku': 'SKU',
    'menu.products.table.tags': 'Tags',
    'menu.products.reload.kiosk': 'Recharger',
    'menu.products.create.link': 'Créer un produit',
    'menu.products.massEdit': 'Édition groupée',
    'menu.products.duplicate': 'Dupliquer',
    'menu.products.copy': 'Propager',
    'menu.products.copy.title': 'Propager les produits',
    'menu.products.copy.form.restaurants.title': 'Je sélectionne mes restaurants cibles',
    'menu.products.copy.form.restaurants.label': 'Destinations',
    'menu.products.copy.form.restaurants.tooltip':
        "Choisissez les restaurants de l'enseigne qui recevront la propagation du produit et/ou de ses étapes.",
    'menu.products.copy.form.restaurants.tooltip.title': 'Je sélectionne mes restaurants cibles',
    'menu.products.copy.form.restaurants.tooltip.example':
        "Depuis le menu de l'enseigne, vous décidez de propager le dessert Brownie uniquement vers les restaurants A et B → seuls ces restaurants auront ce nouveau produit.",
    'menu.products.copy.form.updateIgnoreAttributes.title':
        'Lors de la propagation, je ne souhaite pas écraser les propriétés suivantes sur :',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip':
        "Lors de la propagation d'un produit de l'enseigne vers un restaurant où il existe déjà (unitairement ou via une étape), vous pouvez choisir de conserver certaines propriétés de ce produit unitaire : tag, catégorie parent, image, prix, TVA, nom et description.",
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.title':
        "Conserver certaines propriétés lors de la propagation d'un produit déjà existant",
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.example':
        'Le produit unitaire Cookie existe déjà dans le restaurant avec une image personnalisée et un prix spécifique → si vous cochez "Image" et "Prix", ces valeurs seront conservées, même après propagation depuis l\'enseigne.\n\n👉 Pour les nouveaux produits, toutes les propriétés de l\'enseigne sont bien propagées automatiquement.',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.products':
        'Produits déjà présents dans les menus restaurants cibles',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.steps':
        'Etapes déjà présentes dans les menus restaurants cibles',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.title':
        "Conserver certaines propriétés lors de la propagation d'une étape déjà existante",
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.description':
        "Lors de la propagation d'une étape de l'enseigne vers un restaurant où elle existe déjà, vous pouvez choisir de conserver certaines propriétés de cette étape : prix du produit dans l'étape, quantité maximum par produit (si l'option Quantité est activée) et prix en dépassement.",
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.example':
        'Dans le restaurant, l\'étape Choisir un dessert a un Cookie à 2 € avec une quantité max de 3.\nL\'enseigne propage dans l\'étape un Cookie à 1 € avec une quantité max de 1.\n→ Si vous conservez "Prix produit" et "Quantité max", le restaurant garde bien Cookie à 2 € et quantité max de 3.\n\n👉 Pour les nouvelles étapes, toutes les propriétés de l\'enseigne sont bien propagées automatiquement.',
    'menu.products.copy.form.updateIgnoreAttributes.placeholder':
        'Lors de la propagation, je ne souhaite pas écraser les propriétés suivantes',
    'menu.products.copy.form.attribute.price': 'Prix',
    'menu.products.copy.form.attribute.vat': 'TVA',
    'menu.products.copy.form.attribute.name': 'Nom',
    'menu.products.copy.form.attribute.description': 'Description',
    'menu.products.copy.form.attribute.categories': 'Catégories parentes',
    'menu.products.copy.form.attribute.tags': 'Tags',
    'menu.products.copy.form.attribute.imageId': 'Image',
    'menu.products.copy.form.attribute.exceedPrice': 'Prix en dépassement',
    'menu.products.copy.form.attribute.maxProductQuantity': 'Quantité maximum',
    'menu.products.copy.form.publishAfterCopy.title': 'Lors de la propagation, je souhaite :',
    'menu.products.copy.form.publishAfterCopy.tooltip': 'Publier automatiquement les menus sur les caisses associées',
    'menu.products.copy.form.publishAfterCopy.tooltip.title': 'Publication automatique',
    'menu.products.copy.form.publishAfterCopy.tooltip.example':
        'Si activé, les menus seront automatiquement publiés sur toutes les caisses associées aux restaurants cibles.',
    'menu.products.copy.form.publishAfterCopy': 'Publier automatiquement les menus sur les caisses associées',
    'menu.products.copy.form.publishAfterCopy.disclaimer':
        '⚠️ Attention, il est nécessaire de rajouter sur le plan de touche les nouveaux produits propagés',
    'menu.products.copy.form.strategy.title':
        'Stratégie de propagation pour les étapes déjà existantes sur les menus cibles',
    'menu.products.copy.form.strategy.tooltip':
        'Les étapes déjà présentes dans le restaurant sont remplacées par celles paramétrées sur le menu enseigne (produits et prix compris).',
    'menu.products.copy.form.strategy.tooltip.title': 'Stratégie : Mettre à jour les étapes existantes',
    'menu.products.copy.form.strategy.tooltip.example':
        'Restaurant A a l\'étape "Choisir un dessert" avec Pain perdu, Fruits, Cookie (2€).\nEnseigne la propage avec Cookie (1€), Brownie (2€) → Restaurant A aura désormais Cookie (1€), Brownie (2€).\n\n👉 Le produit unitaire Cookie est mis à jour, le produit unitaire Brownie est créé et le produit Pain perdu est retiré de l\'étape.',
    'menu.products.copy.form.strategy.replace':
        'Mettre à jour les étapes existantes du menu(s) restaurant(s) par celles propagées du menu enseigne',
    'menu.products.copy.form.strategy.replace.tooltip.title': 'Stratégie : Mettre à jour les étapes existantes',
    'menu.products.copy.form.strategy.replace.tooltip.description':
        'Les étapes déjà présentes dans le restaurant sont remplacées par celles paramétrées sur le menu enseigne (produits et prix compris).',
    'menu.products.copy.form.strategy.replace.tooltip.example':
        'Restaurant A a l\'étape "Choisir un dessert" avec Pain perdu, Fruits, Cookie (2€).\nEnseigne la propage avec Cookie (1€), Brownie (2€) → Restaurant A aura désormais Cookie (1€), Brownie (2€).\n\n👉 Le produit unitaire Cookie est mis à jour, le produit unitaire Brownie est créé et le produit Pain perdu est retiré de l\'étape.',
    'menu.products.copy.form.strategy.update_and_keep_existing':
        "Mettre à jour les étapes existantes du menu(s) restaurant(s) et conserver les produits existants non présents dans l'étape du menu enseigne",
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.title':
        'Stratégie : Mettre à jour et conserver les produits existants',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.description':
        "Les étapes du restaurant sont mises à jour avec celles de l'enseigne, mais les produits déjà présents et absents du menu enseigne sont gardés.",
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.example':
        'Restaurant A a l\'étape "Choisir un dessert" avec Pain perdu (1€), Fruits (2€), Cookie (2€).\nEnseigne la propage avec Cookie (1€), Brownie (2€) → Restaurant A aura Pain perdu (1€), Fruits (2€), Cookie (1€), Brownie (2€).\n\n👉 Le produit unitaire Cookie est mis à jour, le produit unitaire Brownie est créé et le produit Pain perdu est conservé dans l\'étape.',
    'menu.products.copy.form.strategy.keep_existing':
        'Ne pas modifier les étapes déjà existantes dans les menus cibles',
    'menu.products.copy.form.strategy.keep_existing.tooltip.title': 'Stratégie : Ne pas modifier les étapes existantes',
    'menu.products.copy.form.strategy.keep_existing.tooltip.description':
        'Les étapes déjà présentes dans le restaurant ne sont pas modifiées lors de la propagation.',
    'menu.products.copy.form.strategy.keep_existing.tooltip.example':
        'Restaurant A a l\'étape "Choisir un dessert" avec Pain perdu (1€), Fruits (2€), Cookie (2€).\nEnseigne la propage avec Cookie (1€), Brownie (2€) → Restaurant A conserve Pain perdu (1€), Fruits (2€), Cookie (2€).\n\n👉 Le produit unitaire Cookie est mis à jour et le produit unitaire Brownie est créé.',
    'menu.products.copy.form.channel.title': 'Je sélectionne mes canaux cibles',
    'menu.products.copy.form.channel.tooltip':
        'Choisissez les canaux (ex : Caisse, Commande En Ligne (CEL), Borne) sur lesquels la propagation du produit et/ou de ses étapes sera appliquée.',
    'menu.products.copy.form.channel.tooltip.title': 'Je sélectionne mes canaux cibles',
    'menu.products.copy.form.channel.tooltip.example':
        'Vous propagez le dessert Brownie mais ne choisissez que Borne → le produit sera visible uniquement sur les menus bornes des restaurants sélectionnés.',
    'menu.products.copy.form.channel.web': 'Commande en ligne ou à table',
    'menu.products.copy.form.channel.kiosk': 'Borne',
    'menu.products.copy.form.channel.pos': 'Caisses',
    'menu.products.copy.form.channel.marketplace': 'Marketplace (UberEats/Deliveroo)',
    'menu.products.copy.form.channel.null': 'Non associé',
    'menu.products.copy.form.other.strategies.title': 'Création des nouveaux produits',
    'menu.products.copy.form.other.strategies.tooltip':
        'Lors de la propagation de nouveaux produits, l\'enseigne propage dans l\'étape un Cookie à 2 € avec une quantité max de 3. Si vous conservez "Prix produit" et "Quantité max", le restaurant garde bien Cookie à 2 € et quantité max de 3. → Si vous conservez "Prix produit" et "Quantité max", le restaurant garde bien Cookie à 2 € et quantité max de 3.',
    'menu.products.copy.form.other.strategies.tooltip.title': 'Création des nouveaux produits',
    'menu.products.copy.form.other.strategies.tooltip.example':
        'Lors de la propagation de nouveaux produits, l\'enseigne propage dans l\'étape un Cookie à 2 € avec une quantité max de 3. Si vous conservez "Prix produit" et "Quantité max", le restaurant garde bien Cookie à 2 € et quantité max de 3.\n→ Si vous conservez "Prix produit" et "Quantité max", le restaurant garde bien Cookie à 2 € et quantité max de 3.',
    'menu.products.copy.form.other.strategies.tags': 'Créer à la volée les tags manquants des produits',
    'menu.products.copy.form.other.strategies.categories': 'Créer à la volée les catégories manquantes produits',
    'menu.products.copy.form.posMenus.title': 'Menus actifs de la Caisse',
    'menu.products.copy.form.posMenus.description':
        'Ce tableau affiche uniquement les restaurants où plusieurs menus caisses sont actifs. Si un seul menu caisse est actif, la propagation se fait par défaut sur ce menu.',
    'menu.products.copy.form.posMenus.tooltip':
        'Sélectionnez les menus Caisse sur lesquels vous souhaitez propager les produits pour chaque restaurant.',
    'menu.products.copy.form.posMenus.tooltip.title': 'Sélection des menus Caisse',
    'menu.products.copy.form.posMenus.tooltip.example':
        'Si un restaurant a plusieurs menus Caisse, vous pouvez choisir de propager sur un ou plusieurs menus spécifiques.',
    'menu.products.copy.form.posMenus.column.restaurant': 'Nom du restaurant',
    'menu.products.copy.form.posMenus.column.menus': 'Menu(s) actif(s)',
    'menu.products.copy.form.posMenus.empty': 'Aucun menu Caisse disponible pour les restaurants sélectionnés',
    'menu.products.copy.form.posMenus.placeholder': 'Sélectionner les menus...',
    'menu.products.copy.form.posMenus.warning':
        "⚠️ Attention, par défaut, tous les menus actifs d'un restaurant sont sélectionnés pour la propagation des produits.",
    'menu.products.copy.form.marketplaceMenus.title': 'Menus actifs des Marketplaces',
    'menu.products.copy.form.marketplaceMenus.description':
        'Ce tableau affiche uniquement les restaurants où plusieurs menus marketplace sont actifs. Si un seul menu marketplace est actif, la propagation se fait par défaut sur ce menu.',
    'menu.products.copy.form.marketplaceMenus.tooltip':
        'Sélectionnez les menus marketplace sur lesquels vous souhaitez propager les produits pour chaque restaurant.',
    'menu.products.copy.form.marketplaceMenus.tooltip.title': 'Sélection des menus Marketplace',
    'menu.products.copy.form.marketplaceMenus.tooltip.example':
        'Si un restaurant a plusieurs menus marketplace, vous pouvez choisir de propager sur un ou plusieurs menus spécifiques.',
    'menu.products.copy.form.marketplaceMenus.column.restaurant': 'Nom du restaurant',
    'menu.products.copy.form.marketplaceMenus.column.menus': 'Menu(s) actif(s)',
    'menu.products.copy.form.marketplaceMenus.empty':
        'Aucun menu marketplace disponible pour les restaurants sélectionnés',
    'menu.products.copy.form.marketplaceMenus.placeholder': 'Sélectionner les menus...',
    'menu.products.copy.form.marketplaceMenus.warning':
        "⚠️ Attention, par défaut, tous les menus actifs d'un restaurant sont sélectionnés pour la propagation des produits.",
    'menu.products.copy.form.publishAfterCopy.marketplace.title': 'Lors de la propagation, je souhaite :',
    'menu.products.copy.form.publishAfterCopy.marketplace':
        'Publier automatiquement les menus sur les marketplaces associées',
    'menu.products.copy.form.publishAfterCopy.marketplace.disclaimer':
        'Les menus seront publiés sur les marketplaces associées aux restaurants.',
    'menu.products.copy.form.disclaimer':
        '⚠️ Attention ce(s) produit(s) seront copiés sur tous les restaurants sélectionnés, dans tous leurs menus. Avant d’enregistrer, vérifiez leur nom, description, image, TVA, prix.',
    'menu.copy.validate.title': 'Vérification des produits / étapes à propager',
    'menu.copy.validate.success': 'Tous les produits /étapes à propager ont bien un SKU / référence étape de configuré',
    'menu.copy.validate.warning': 'SKU non renseigné dans la fiche produit du menu enseigne',
    'menu.copy.validate.error': 'SKU en doublon ou référence étape non renseignée dans le menu enseigne',
    'menu.copy.validate.step.missing.identifier.detail': 'Référence étape non renseignée sur l’étape',
    'menu.copy.validate.product.missing.identifier.detail': 'SKU non renseigné sur le produit',
    'menu.copy.validate.step.duplicate.identifier.detail':
        'Conflit sur le référence <b>{identifier}</b> entre les étapes',
    'menu.copy.validate.product.duplicate.identifier.detail':
        'Conflit sur le SKU <b>{identifier}</b> entre les produits',
    'menu.products.overwrite': 'Cocher la case à gauche pour éditer les champs',
    'menu.products.overwriteRelations': "Cocher la case à gauche pour tout remplacer au lieu d'ajouter des éléments",
    'menu.products.error.alreadyTaken': 'Ce produit existe déjà',
    'menu.products.error.billingCodeRequired': 'La facturation automatique nécessite de remplir ce champ',
    'menu.products.add.title': 'Ajouter un produit',
    'menu.products.edit.title': 'Éditer un produit',
    'menu.products.propagate.title': 'Propager des produits',
    'menu.products.create.title': 'Créer un produit',
    'menu.products.delete.confirm': 'Êtes-vous sûr de vouloir supprimer {count} produit(s) ?',
    'menu.products.form.price': 'Prix TTC',
    'menu.product.form.pricePerkg': 'Prix TTC / kg',
    'menu.products.form.priceType': 'Type de prix',
    'menu.products.form.priceType.placeholder': 'Type de prix',
    'menu.products.form.priceType.fixed': 'Prix fixe',
    'menu.products.form.priceType.customizablePrice': 'Produit à prix libre',
    'menu.products.form.priceType.customizablePriceAndLabel': 'Produit à prix et label libre',
    'menu.products.form.measurementUnit': 'Mesuré par',
    'menu.products.form.measurementUnit.placeholder': 'Mesuré par',
    'menu.products.form.measurementUnit.unit': 'Unité',
    'menu.products.form.measurementUnit.kg': 'kg',
    'menu.products.form.kg.channelRestriction': 'Les produits en kg ne sont pas disponibles sur le canal Borne.',
    'menu.products.form.availability': 'Disponibilité par canal',
    'menu.products.form.webAvailability': 'Web',
    'menu.products.form.kioskAvailability': 'Borne',
    'menu.products.form.servingCount': 'Nombre de couverts',
    'menu.products.form.barCode': 'Code barre',
    'menu.products.form.ticketLabel': 'Libellé de production',
    'menu.products.form.ticketLabel.checkbox': 'Avoir un libellé de production différent du nom du produit',
    'menu.products.form.noVat': 'Produit non soumis à la TVA',
    'menu.products.form.vat': 'TVA par défaut',
    'product.vatGroup': 'Groupe TVA',
    'product.vatGroup.withHint': 'Groupe TVA (sur place / à emporter / livraison)',
    'product.selectVatGroup': 'Sélectionner un groupe TVA',
    'product.vatGroup.noOperationZone': "Aucune zone d'opération configurée pour ce restaurant",
    'product.vatGroup.eatIn': 'Sur place',
    'product.vatGroup.takeAway': 'À emporter',
    'product.vatGroup.delivery': 'Livraison',
    'product.vatGroup.hint':
        'Pour changer la TVA par mode de consommation, veuillez modifier désormais le champ « Groupe TVA (sur place / à emporter / livraison) »',
    'menu.products.form.image.placeholder': 'Image',
    'menu.products.form.externalId': 'Code externe',
    'menu.products.form.sku': 'sku',
    'menu.products.form.sku.placeholder': 'Choisir un SKU',
    'menu.products.form.sku.noOption': "Un nouvel SKU ne peut être créé qu'au niveau de l'enseigne",
    'menu.products.form.createSku': 'Créer le SKU "{value}"',
    'menu.products.form.replaceSkuAll':
        'Remplacer le SKU "{currentSku}" par "{value}" (sur tous les produits ayant le même SKU)',
    'menu.products.form.replaceSkuThisProduct':
        'Remplacer le SKU "{currentSku}" par "{value}" (uniquement sur ce produit)',
    'menu.products.form.createTag': 'Créer le tag "{value}"',
    'menu.products.form.billingCode': 'Code facture',
    'menu.products.form.purchasePrice': 'Prix contrat',
    'menu.products.form.description': 'Description',
    'menu.products.form.description.tooLong': 'La description ne doit pas dépasser 1500 caractères',
    'menu.products.form.additionalInformation': 'Informations supplémentaires',
    'menu.products.form.section.options': 'Options',
    'menu.products.form.section.quantity': 'Gestion des stocks',
    'menu.products.form.section.externalData': 'Données externes',
    'menu.products.form.currentQuantitySwitch': 'Activer la gestion de stock pour le produit',
    'menu.products.form.defaultQuantitySwitch': 'Réinitialisation journalière du stock',
    'menu.products.form.currentQuantityInput': 'Quantité dans le stock',
    'menu.products.form.defaultQuantityInput': 'Quantité en début de journée',
    'menu.products.form.defaultQuantityHint':
        'Chaque jour entre 4h et 5h du matin, la quantité sera remise à celle par défaut',
    'menu.products.form.isEligibleLuncheon': 'Éligible aux tickets restaurant',
    'menu.products.form.isFinalProduct': 'Produit final',
    'menu.products.form.subsidizable': 'Produit subventionnable',
    'menu.products.form.admissible': 'Produit admissionnable',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants': 'Admission/Subvention multipliée à chaque ajout panier',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants.tooltip':
        'En activant cette option, les admissions (et subventions) seront multipliées dans la commande si le produit est ajouté plusieurs fois au panier ou si un autre produit portant la même option est ajouté au panier. La multiplication se fait dans la limite journalière et dans la limite du plafond définies dans le régime tarifaire.',
    'menu.products.form.excludedFromUrssaf': 'Ne pas compter dans le minimum urssaf',
    'menu.products.form.section.pos': 'Attributs spécifiques aux caisses',
    'menu.products.form.minQuantity': 'Quantité minimum',
    'menu.products.form.alwaysAskForCustomization': 'Toujours demander les étapes',
    'menu.products.form.discountable': 'Autoriser les remises sur le produit',
    'menu.products.form.isDeposit': 'Produit de type consigne',
    'menu.products.form.posPrice': 'Montant de la consigne',
    'menu.products.form.vatSitIn': 'TVA sur place',
    'menu.products.form.vatDelivery': 'TVA livraison',
    'menu.products.form.vatTakeAway': 'TVA à emporter',
    'menu.products.form.section.kitchenOptions': "Options de l'écran de cuisine",
    'menu.products.form.isMenu': 'Est un menu',
    'menu.products.form.is_customization': 'Est une customisation',
    'menu.products.form.isProducible': 'Afficher dans le résumé',
    'menu.products.form.no_kitchen': "Ne pas afficher dans l'écran de cuisine",
    'menu.products.form.section.consumptionMode': 'Disponibilité du produit en fonction du mode de consommation',
    'menu.products.form.consumptionModeType.mode_sit_in': 'Sur place',
    'menu.products.form.consumptionModeType.mode_delivery': 'En livraison',
    'menu.products.form.consumptionModeType.mode_take_away': 'À emporter',
    'menu.products.form.consumptionModeType.mode_drive': 'Drive',
    'menu.products.form.tags': 'Tags',
    'menu.products.form.tags.placeholder': 'Rechercher le ou les tags à associer',
    'menu.products.form.steps': 'Étapes',
    'menu.products.form.steps.page': 'Page {pageNumber}',
    'menu.products.form.steps.addToNewPage': 'Ajouter à une nouvelle page',
    'menu.products.form.steps.addEachToNewPage': 'Ajouter chaque étape à une nouvelle page',
    'menu.products.form.steps.addToPage': "Page à laquelle ajouter l'étape",
    'menu.products.form.steps.addEmptyPage': 'Ajouter une page',
    'menu.products.form.categories': 'Catégories parentes',
    'menu.products.form.productType': 'Type',
    'menu.products.form.productType.placeholder': 'Type de produit',
    'menu.products.form.productType.product': 'Produit',
    'menu.products.form.productType.deposit': 'Consigne',
    'menu.products.form.categories.placeholder': 'Rechercher le ou les catégories parentes',
    'menu.products.form.externalReference': 'Référence externe',
    'menu.products.form.externalReference.placeholder': 'Nom de la référence',
    'menu.products.form.externalReference.name': 'Nom',
    'menu.products.form.externalReference.value': 'Valeur',

    'menu.products.form.machineCode': 'Code machine Nayax du produit',
    'menu.products.form.steps.add': 'Ajouter une étape',
    'menu.products.form.steps.addPage': "Glisser l'étape ici pour créer une nouvelle page",
    'menu.products.form.steps.column.name': 'Nom',
    'menu.products.form.steps.column.type': 'Type',
    'menu.products.form.steps.column.choices': 'Choix possibles',
    'menu.products.form.steps.column.position': 'Page',
    'menu.products.form.steps.column.subPosition': 'Position',
    'menu.products.form.steps.column.min': 'Min',
    'menu.products.form.steps.column.max': 'Max',
    'menu.products.form.steps.column.parentsProducts': 'Nombre de produits parents',
    'menu.products.form.steps.cross-selling.add': 'Ajouter une vente additionnelle',
    'menu.products.form.steps.customization.add': 'Ajouter une personnalisation',
    'menu.products.form.steps.type.cross-selling': 'Vente additionnelle',
    'menu.products.form.steps.type.customization': 'Personnalisation',

    // Report Generations History
    'reportGenerationsHistory.title': 'Historique des générations',
    'reportGenerationsHistory.subtitle': "Vous trouverez ici l'historique de vos générations d'exports.",
    'reportGenerationsHistory.tableCard.title': 'Exports',
    'reportGenerationsHistory.tableCard.subtitle': 'Liste des exports',
    'reportGenerationsHistory.tableCard.actionLabel': 'Actualiser la page',
    'reportGenerationsHistory.emptyMessage': 'Votre historique de génération est vide',
    'reportGenerationsHistory.tableHeader.createdAt': 'Date',
    'reportGenerationsHistory.tableHeader.fileName': 'Nom du fichier',
    'reportGenerationsHistory.tableHeader.reportType': 'État',
    'reportGenerationsHistory.tableHeader.status': 'Avancement',
    'reportGenerationsHistory.tableHeader.action': 'Télécharger',
    'reportGenerationsHistory.tableRow.reportType.pre_invoicing': 'Pré-facturation',
    'reportGenerationsHistory.tableRow.reportType.orders': 'Commandes',
    'reportGenerationsHistory.tableRow.reportType.badge_balance': 'Mouvements des badges',
    'reportGenerationsHistory.tableRow.reportType.sales_summary': 'Synthèse financière',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary':
        'Synthèse financière par mode de gestion',
    'reportGenerationsHistory.tableRow.reportType.ewallet_stats_by_users': 'Solde des badges par client',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary_exclude_tax':
        'Synthèse financière par mode de gestion HT',
    'reportGenerationsHistory.tableRow.reportType.ewallet': 'E-wallet',
    'reportGenerationsHistory.tableRow.reportType.accounting': 'Comptable',
    'reportGenerationsHistory.tableRow.reportType.monthly_sales_report': 'Rapport des ventes mensuels',
    'reportGenerationsHistory.tableRow.generationStatus.succeed': 'Terminé',
    'reportGenerationsHistory.tableRow.generationStatus.in_progress': 'En cours',
    'reportGenerationsHistory.tableRow.generationStatus.failed': 'Echec',
    'reportGenerationsHistory.tableRow.action.download': 'Télécharger',

    // Reports
    'report.emptyMessage': 'Pas de résultat',
    'report.title.monthly_sales_report': 'Rapport des ventes mensuels',
    'report.selectDateRangeButton.text': 'Du {startDate} au {endDate}',
    'report.calendarModal.dateRage.errorMessage': 'Vous ne pouvez pas sélectionner plus de {maxRangeInDays} jours',
    'report.calendarModal.title': 'Choisissez une période',
    'report.calendarModal.submit': 'Valider',
    'report.filtersButton.text': 'Filtres',
    'report.filtersModal.title': 'Choisissez les filtres',
    'report.filtersModal.submit': 'Filtrer',
    'report.filtersModal.form.restaurantLabel': 'Restaurants',
    'report.filtersModal.form.devicesLabel': 'Caisses',
    'report.filtersModal.form.sourcesLabel': 'Canaux de commande',
    'report.filtersModal.form.tagsLabel': 'Tags',
    'report.filtersModal.form.consumptionModesLabel': 'Modes de consommation',
    'report.filtersModal.form.sellersLabel': 'Vendeurs',
    'report.filtersModal.form.vatsLabel': 'Tva',
    'report.filtersModal.form.categoriesLabel': 'Catégories',
    'report.filtersModal.form.loyaltyLabel': 'Afficher uniquement les commandes payées avec la fidelité',
    'report.filtersModal.form.only_parentsLabel': 'Afficher les catégories parentes',
    'report.filtersModal.saveAs.placeholder': 'Enregistrer sous ...',
    'report.filtersModal.saveAs.save': 'Enregistrer et Appliquer',
    'report.exportButton.text': 'Exporter',
    'report.exportResultModal.title': 'Export CSV',
    'report.exportResultModal.resultSuccess': "La génération de l'export est en cours",
    'report.exportResultModal.stayInPage': 'Rester sur cette page',
    'report.exportResultModal.redirectToGenerationHistory': 'Voir les exports en cours',
    'report.exportResultModal.resultFail': 'A problem has occurred, please try again in a few moments',
    'report.savedFiltersDropdown.placeholder': 'Filtres enregistrés',
    'report.savedFiltersDropdown.deleteModal.title': 'Attention',
    'report.savedFiltersDropdown.deleteModal.description': 'Êtes-vous sûr de vouloir supprimer ?',

    // Sales Summary
    'salesSummary.tableCard.title': 'Générer un nouvel export',
    'salesSummary.tableCard.subtitle': 'Sélectionnez vos critères et vos filtres, cliquez sur "Générer".',
    'salesSummary.form.choosePeriod': 'Choisissez une période',
    'salesSummary.form.reportType': 'Format du rapport',
    'salesSummary.form.reportType.collectiveCateringSalesSummary': 'Synthèse financière par mode de gestion',
    'salesSummary.form.reportType.collectiveCateringSalesSummaryExclTax': 'Synthèse financière par mode de gestion HT',
    'salesSummary.form.reportType.salesSummary': 'Synthèse financière',
    'salesSummary.form.restaurants': 'Restaurants',
    'salesSummary.form.groups': 'Groupes',
    'salesSummary.form.pricingRules': 'Régime tarifaire',
    'salesSummary.form.accountedOrders': 'Commandes comptabilisées',
    'salesSummary.form.accountedOrders.all': 'Commandes + Contre-écritures',
    'salesSummary.form.accountedOrders.ordersOnly': 'Commandes',
    'salesSummary.form.accountedOrders.contraEntriesOnly': 'Contre-écritures',
    'salesSummary.exportResultModal.title': "Génération de l'Export",

    // Shifts
    'shift.default': 'Par défaut',
    'shift.allDays': 'Tous les jours',
    'shift.period': 'Du {start} au {end}',
    'shift.days.MON': 'Lundi',
    'shift.days.TUE': 'Mardi',
    'shift.days.WED': 'Mercredi',
    'shift.days.THU': 'Jeudi',
    'shift.days.FRI': 'Vendredi',
    'shift.days.SAT': 'Samedi',
    'shift.days.SUN': 'Dimanche',
    'shift.amount.required': 'Le montant est obligatoire',
    'shift.amount.positive': 'Le montant doit être positif',
    'shift.threshold.positive': 'Le seuil doit être positif',
    'shift.ceiling.required': 'obligatoire pour une subvention en pourcentage',
    'shift.vat.required': 'La TVA est obligatoire',
    'shift.vat.positive': 'La TVA doit être positive',

    // Brand's History
    'brandHistory.tableCard.title': 'Historique',
    'brandHistory.tableCard.subtitle': 'Cherchez les actions faites sur la brand',
    'brandHistory.emptyMessage': "Pas d'historique trouvé",
    'brandHistory.searchPlaceholder': "Rechercher dans l'historique",

    'brandHistory.entityType': "Type d'entité",
    'brandHistory.entityType.GRANT': 'Subvention',
    'brandHistory.entityType.ENTRANCE_FEE': 'Admission',
    'brandHistory.entityType.PRICING_RULE': 'Régime tarifaire',
    'brandHistory.entityType.PRODUCT': 'Produit',
    'brandHistory.entityType.STEP': 'Étape',
    'brandHistory.entityType.CATEGORY': 'Catégorie',
    'brandHistory.entityType.MENU': 'Menu',
    'brandHistory.entityType.MODULE': 'Module',
    'brandHistory.entityType.CUSTOMER': 'Client',
    'brandHistory.entityType.CUSTOMERS_IMPORT': 'Import clients',
    'brandHistory.entityType.CUSTOMERS_UPDATE': 'Modification clients',
    'brandHistory.entityType.USER': 'Utilisateur',
    'brandHistory.entityType.CHANNEL': 'Canal',
    'brandHistory.entityType.CONSUMPTION_MODE': 'Mode de consommation',
    'brandHistory.entityType.ORDER': 'Commande',
    'brandHistory.entityType.BRAND': 'Enseigne',
    'brandHistory.entityType.RESTAURANT': 'Restaurant',

    'brandHistory.entityName': "Nom de l'entité",
    'brandHistory.restaurant': 'Restaurant',
    'brandHistory.user': 'Utilisateur',
    'brandHistory.action': 'Action',
    'brandHistory.eventDate': 'Date',

    'brandHistory.action.create': 'Création',
    'brandHistory.action.open': 'Ouverture',
    'brandHistory.action.activate': 'Activation',
    'brandHistory.action.duplicate': 'Duplication',
    'brandHistory.action.delete': 'Suppression',
    'brandHistory.action.close': 'Fermeture',
    'brandHistory.action.deactivate': 'Désactivation',
    'brandHistory.action.cancel': 'Annulation',
    'brandHistory.action.update': 'Modification',
    'brandHistory.action.import': 'Importation',
    'brandHistory.action.unknown': 'Inconnu',

    'brandHistory.modal.title': 'Rapport des actions réalisées',
    'brandHistory.modal.actions': 'Rapport des actions',
    'brandHistory.modal.logs': 'Rapport des journaux',
    'brandHistory.modal.informations': 'Informations associées',
    'brandHistory.modal.entityName': "Nom de l'entité",
    'brandHistory.modal.user': 'Utilisateur : ',
    'brandHistory.modal.date': 'Date du changement : ',
    'brandHistory.modal.close': 'Fermer',
    'brandHistory.modal.empty': 'On ne trouve rien ici 😰',

    // Cross-selling
    'crossSelling.name': 'Nom de la page de cross-selling',
    'crossSelling.page.title': 'Cross-selling',
    'crossSelling.page.description': 'Créez et gérez vos pages de cross-selling',
    'crossSelling.action.newCrossSelling': '+ Nouvelle page de cross-selling',
    'crossSelling.modal.duplicate.title': 'Dupliquer une page de cross-selling',
    'crossSelling.modal.create.title': 'Créer votre page de cross-selling',
    'crossSelling.modal.delete.title': 'Supprimer une page de cross-selling',
    'crossSelling.modal.delete.description': 'Êtes-vous sûr de vouloir supprimer la page : "{crossSellingName}"\xa0?',
    'crossSelling.modal.error.name': 'Entrez un nom dans le champ dédié',
    'crossSelling.modal.menu.name': 'Nom de la page de cross-selling',
    'crossSelling.page.create.title': 'Créer une page de Cross-selling',
    'crossSelling.page.update.title': 'Modifier la page de Cross-selling "{crossSellingName}"',
    'crossSelling.page.create.description': 'Configuration de la page de Cross-Selling',
    'crossSelling.page.update.description': 'Configuration de la page de Cross-Selling',
    'crossSelling.products.image': 'Image',
    'crossSelling.products.name': 'Nom',
    'crossSelling.products.price': 'Prix',
    'crossSelling.products.vat': 'TVA',
    'crossSelling.products.tags': 'Tags',
    'crossSelling.products.sku': 'SKU',
    'crossSelling.products.menuName': 'Menu',
    'crossSelling.products.menuState': 'État du menu',
    'crossSelling.products.restaurantName': 'Restaurant',
    'crossSelling.products.add': 'Ajouter des produits',
    'crossSelling.products.menuState.enabled': 'Activé',
    'crossSelling.products.menuState.disabled': 'Désactivé',

    // Table Layout
    'tableLayout.name': 'Nom du plan de table',
    'tableLayout.page.title': 'Plans de tables',
    'tableLayout.page.description': 'Créez et gérez vos plans de tables',
    'tableLayout.table.associatedPos': 'Caisses associées',
    'tableLayout.action.newTableLayout': '+ Nouveau plan de table',
    'tableLayout.modal.create.title': 'Créer un plan de table',
    'tableLayout.modal.edit.title': 'Modifier le plan de table "{tableLayoutName}"',
    'tableLayout.modal.delete.title': 'Supprimer un plan de table',
    'tableLayout.modal.delete.description':
        'Êtes-vous sûr de vouloir supprimer le plan de table : "{tableLayoutName}"\xa0?',
    'tableLayout.modal.publish.title': 'Publier un plan de table',
    'tableLayout.modal.publish.description':
        'Êtes-vous sûr de vouloir publier le plan de table : "{tableLayoutName}"\xa0?',
    'tableLayout.modal.error.name': 'Entrez un nom dans le champ dédié',

    // Room
    'room.name': 'Nom de la salle',
    'room.page.title': 'Salles',
    'room.page.description': 'Créez et gérez vos salles',
    'room.action.newRoom': '+ Nouvelle salle',
    'room.action.publish': 'Publier le plan de tables',
    'room.modal.create.title': 'Créer une salle',
    'room.modal.edit.title': 'Modifier la salle "{roomName}"',
    'room.modal.view.title': 'Salle "{roomName}"',
    'room.modal.single': 'Ajouter une table',
    'room.modal.single.placeholder': 'Table principale',
    'room.modal.multiple': 'Ajouter plusieurs tables',
    'room.modal.multiple.placeholder1': '1',
    'room.modal.multiple.placeholder2': '10',
    'room.modal.layout': 'Organiser les tables',
    'room.modal.delete.title': 'Supprimer une salle',
    'room.modal.delete.description': 'Êtes-vous sûr de vouloir supprimer la salle : "{roomName}"\xa0?',
    'room.modal.error.name': 'Entrez un nom dans le champ dédié',
    'room.modal.error.new_table_name': 'Entrez un nom ou numéro de table',
    'room.modal.error.fill_start_and_end':
        'Entrez une valeur de début et une valeur de fin (supérieure à celle du début)',
    'room.modal.error.max_count_table': 'Vous ne pouvez pas avoir plus de {maxCount} tables par salle.',

    // POS config
    'pos.configuration': 'Configuration',
    'pos.devices': 'Caisses',
    'pos.access': 'Rôles et permissions',
    'pos.access.users': 'Utilisateurs',
    'pos.access.roles': 'Rôles',
    'pos.access.groups': 'Groupes',
    'pos.users.page.title': 'Opérateurs de caisse',
    'pos.roles.page.title': 'Rôles et permissions de caisse',
    'pos.groups.page.title': 'Groupes d`accès de caisse',
    'pos.users.page.description':
        'Les opérateurs de caisse permettent de définir les utilisateurs qui peuvent interagir avec la caisse.',
    'pos.roles.page.description':
        'Les rôles de caisse permettent de définir des groupes de permission pour les utilisateurs de la caisse.',
    'pos.groups.page.description':
        'Les groupes d’accès gèrent les utilisateurs et leur association aux caisses du restaurant',
    'pos.users.action.newUser': 'Créer un nouvel opérateur',
    'posUser.name.form.label': "Nom d'operateur",
    'posUser.name.form.placeholder': "Nom d'operateur caisse",
    'posUser.pinCode.form.label': "Code pin d'operateur",
    'posUser.pinCode.form.placeholder': "Code pin d'operateur caisse",
    'posUser.role.form.label': "Rôle d'operateur",
    'posGroup.name.form.label': 'Nom du groupe',
    'posGroup.name.form.placeholder': "Saisir le nom du groupe d'accès",
    'posGroup.users.form.label': 'Opérateurs',
    'posGroup.users.form.placeholder': 'Séléctionner les opérateurs associés',
    'posGroup.devices.form.label': 'Caisses',
    'posGroup.devices.form.placeholder': 'Séléctionner les caisses associées',
    'posUser.create.form.title': 'Créer un nouvel operateur caisse',
    'posGroup.create.form.title': 'Créer un nouveau groupe d`accès',
    'posGroup.edit.form.title': 'Modifier le groupe d`accès',
    'posUser.edit.form.title': "Éditer l'operateur caisse: ",
    'posUser.form.description': 'Indiquez les informations de votre opérateur de caisse.',
    'posGroup.form.description': 'Indiquez les informations de votre groupe d`accès de caisse.',
    'posUser.form.creation': "Création d'un operateur caisse",
    'posUser.form.edit': "Édition d'un operateur caisse",
    'posUser.form.update': "Édition d'un operateur caisse",

    'posRole.form.title': 'Rôle de caisse',
    'posRole.form.description': 'Vous pouvez mettre à jour les permissions de votre rôle de caisse depuis cette page',
    'posRole.form.creation': "Création d'un rôle de caisse",
    'posRole.form.update': "Édition d'un rôle de caisse",
    'posGroup.form.creation': "Création d'un groupe d'accès",
    'posGroup.form.update': "Édition d'un groupe d'accès",
    'posRole.form.rolePermissions': 'Permissions pour le rôle',
    'posRole.form.name.title': 'Nom du rôle',
    'posRole.form.name.placeholder': 'Rôle',
    'pos.groups.action.create': 'Créer un nouveau groupe',
    'permissions.permissions': 'Permissions',
    'assiciated.devices': 'Caisses associées',
    'assiciated.operators': 'Opérateurs associées',

    // Default POS roles
    'posRole.Operator': 'Opérateur',
    'posRole.Manager': 'Manager',
    'posRole.Owner': 'Gérant',
    'posRole.Auditor': 'Auditeur',
    'posRole.Treasurer': 'Trésorier',
    'posRole.Support': 'Support',
    'posRole.Trainer': 'Formateur',
    'posRole.InCharge': 'Responsable',
    'posRole.OperatorSupervisor': 'Encadrant opérateur',
    'posRole.AssistantOperator': 'Assistant opérateur',
    'posRole.AssistantToTheRegionalManager': 'Assistant manager',
    'posRole.CustomOperator1': 'Opérateur custom 1',
    'posRole.CustomOperator2': 'Opérateur custom 2',
    'posRole.CustomOperator3': 'Opérateur custom 3',

    'channels.page.title': 'Liste des canaux',
    'channels.page.description':
        'Les canaux de commande vous permettent de proposer des fonctionnalités telles que la commande en ligne, la commande via borne en point de vente, ou la gestion de la fidélité.',
    'channels.installed': 'Application installée',
    'channels.button.configure': 'Configurer',
    'channels.button.disable': 'Désactiver',
    'channels.button.enable': 'Activer',

    'channels.kiosk.name': 'Borne',
    'channels.kiosk.description': 'Réinventez l’expérience en point de ventes de la meilleure manière.',

    'channels.web.name': 'Commande en ligne',
    'channels.web.description': 'Un nouveau point de vente depuis votre propre site.',

    'channels.reception.name': 'Réception',
    'channels.reception.description': 'Une interface dédiée pour vos commandes web et bornes.',

    'channels.pos.name': 'POS',
    'channels.pos.description': 'Votre système d’encaissement simple et intégré à votre environnement.',

    'channels.kds.name': 'Kitchen display',
    'channels.kds.description': 'Dynamiser encore plus votre cuisine avec une organisation parfaite.',

    'channels.loyalty.name': 'Fidélité',
    'channels.loyalty.description': 'Fidéliser, faites revenir vos clients en point de vente.',

    'channels.ewallet_kiosk.name': 'Borne de rechargement E-Wallet',
    'channels.ewallet_kiosk.description': 'Le nouveau canal pour recharger son E-wallet très rapidement.',

    'channels.vending_machine.name': 'Distributeur automatique',
    'channels.vending_machine.description':
        'Proposez un paiement e-wallet sur vos machines à café et distributeurs de boissons.',

    'accessFlags.CAN_ACCESS_BRAND_HISTORY': "Peut accéder à la page historique de l'enseigne",
    'accessFlags.CAN_ACCESS_CUSTOMERS_SECTION': 'Peut accéder à la page Clients',
    'accessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION': 'Peut accéder à l’onglet Subventions et admissions',
    'accessFlags.CAN_ACCESS_IO_PAY': 'Peut accéder aux module Paiement',
    'accessFlags.CAN_ARCHIVE_CUSTOMERS': 'Peut archiver les clients',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT': 'Peut créer des commandes avec un montant négatif',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE':
        'Peut créer des commandes qui feront passer le solde du convive en négatif',
    'accessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET': "Peut créditer le e-wallet d'un convive en post-paiement",
    'accessFlags.CAN_EDIT_AREAS': 'Peut editer les zones de livraison',
    'accessFlags.CAN_EDIT_AUTO_BILLING_REFERENTIAL': 'Facturation automatique: peut modifier le référentiel',
    'accessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS': 'Peut éditer les identifiants des clients',
    'accessFlags.CAN_EXPORT_CUSTOMERS_CSV': 'Peut exporter les données clients et créditer/débiter les E-wallets',
    'accessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE':
        'Peut forcer les nouveaux clients à éditer leurs identifiants fournis par défaut',
    'accessFlags.CAN_MANAGE_BO_USERS': 'Peut gérer les utilisateurs du backoffice',
    'accessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT': "Peut gérer le découvert autorisé au niveau de l'enseigne",
    'accessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT': 'Peut gérer le découvert autorisé au niveau du client',
    'accessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME':
        'Peut uniquement éditer le prix et le nom des produits et étapes associées',
    'accessFlags.CAN_SYNC_SALES': 'Peut synchroniser les ventes',
    'accessFlags.CAN_EDIT_TABLE_LAYOUT': 'Peut modifier les plans de tables',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE': 'Peut créer des commandes avec un prix personnalisé',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS':
        'Peut créer des commandes avec un prix personnalisé pour tous les produits',
    'accessFlags.MENU_CATEGORY_CREATE_OR_DELETE': 'Peut créer ou supprimer des catégories',
    'accessFlags.MENU_CATEGORY_EDIT': 'Peut éditer des catégories',
    'accessFlags.MENU_CREATE_OR_DELETE': 'Peut créer ou supprimer des menus',
    'accessFlags.MENU_EDIT': 'Peut éditer des menus',
    'accessFlags.MENU_PRODUCT_CREATE_OR_DELETE': 'Peut créer ou supprimer des produits',
    'accessFlags.MENU_PRODUCT_EDIT': 'Peut éditer des produits',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY': 'Restreindre l’édition au prix du produit',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY': 'Bloquer uniquement l’édition du prix d’un produit',
    'accessFlags.MENU_STEP_CREATE_OR_DELETE': 'Peut créer ou supprimer des étapes',
    'accessFlags.MENU_STEP_EDIT': 'Peut éditer des étapes',
    'accessFlags.MENU_TAG_CREATE_OR_DELETE': 'Peut créer ou supprimer des tags',
    'accessFlags.MENU_TAG_EDIT': 'Peut éditer des tags',
    'accessFlags.CAN_CHANGE_OWN_PASSWORD': 'Peut modifier son mot de passe',
    'accessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY': 'Peut annuler une commande (contre-écriture)',
    'accessFlags.CAN_CREATE_SKU': 'Peut créer des SKU',

    'accessFlagsGroups.customers': 'Gestion des Clients',
    'accessFlagsGroups.financial': 'Gestion Financière / E-Wallet',
    'accessFlagsGroups.orders': 'Gestion des Commandes',
    'accessFlagsGroups.catalog': 'Gestion du Catalogue',
    'accessFlagsGroups.subsidies': 'Subventions & Admissions',
    'accessFlagsGroups.configuration': 'Configuration Restaurant',
    'accessFlagsGroups.administration': 'Administration & Compte',
    'accessFlagsGroups.others': 'Autres Permissions',

    'accessFlagsSubsections.categories': 'Catégories',
    'accessFlagsSubsections.menus': 'Menus',
    'accessFlagsSubsections.products': 'Produits',
    'accessFlagsSubsections.steps': 'Étapes',
    'accessFlagsSubsections.tags': 'Tags',

    'accessFlagsControl.expandAll': 'Tout déplier',
    'accessFlagsControl.collapseAll': 'Tout replier',
    'accessFlagsControl.permission': 'permission',
    'accessFlagsControl.permissions': 'permissions',

    'userRestaurants.noRestaurants': 'Aucun restaurant disponible',

    'brandUsers.email': 'Email',
    'brandUsers.lastConnection': 'Dernière connexion',
    'brandUsers.login': 'Connexion',
    'brandUsers.loginAs': 'Se connecter en tant que',
    'brandUsers.loginAsBrandGroup': 'Compte multi-enseigne (non-connectable)',
    'brandUsers.newUser': '+ Nouvel utilisateur',
    'brandRestaurants.newRestaurant': '+ Nouveau restaurant',
    'brandRestaurants.create.restaurantInfo': 'Informations du restaurant',
    'brandRestaurants.create.restaurantName': 'Nom du restaurant',
    'brandRestaurants.create.phone': 'Numéro de téléphone',
    'brandRestaurants.create.address': 'Adresse',
    'brandRestaurants.create.locale': 'Langue',
    'brandRestaurants.create.currency': 'Devise',
    'brandRestaurants.create.operationZone': "Zone d'opération",
    'brandRestaurants.create.operationZone.skip': 'Passer - configurer plus tard',
    'brandRestaurants.create.operationZoneConfigure': "Configuration de la zone d'opération",
    'brandRestaurants.create.operationZone.selectProvider': 'Sélectionnez le mode de conformité',
    'brandRestaurants.create.operationZone.currencyMismatch':
        "Cette zone utilise une devise différente de celle de l'enseigne. Une nouvelle enseigne est nécessaire pour opérer dans cette devise.",
    'brandRestaurants.create.manager': 'Gérant',
    'brandRestaurants.create.selectExistingUser': 'Sélectionner un utilisateur existant',
    'brandRestaurants.create.createNewUser': 'Créer un nouvel utilisateur',
    'brandRestaurants.create.skipManager': 'Passer cette étape',
    'brandRestaurants.create.letUserChoosePassword': "Laisser l'utilisateur choisir son mot de passe",
    'brandRestaurants.create.done.title': "C'est terminé !",
    'brandRestaurants.create.done.message': 'Vous êtes prêt à configurer {name}',
    'brandRestaurants.create.done.configure': 'Configurer',
    'user.create.title': 'Créez un nouvel utilisateur',
    'user.create.firstName': 'Prénom',
    'user.create.lastName': 'Nom',
    'user.create.phone': 'Numéro de téléphone',
    'user.create.email': 'Email',
    'user.create.password': 'Mot de passe',
    'user.create.confirmPassword': 'Confirmez le mot de passe',
    'user.create.letUserChoosePassword': "Laisser l'utilisateur choisir son mot de passe",
    'user.create.error.phone.length': 'Le numéro de téléphone doit contenir 10 chiffres.',
    'user.create.error.phone.valid': 'Ce numéro est invalide',
    'user.create.error.password.min': 'Mot de passe invalide (minimum 12 caractères)',
    'user.create.error.passwordConfirm.sameAsPassword': 'Les deux mots de passe doivent être indentiques',

    'brands.restaurantscount': 'Nombre de restaurants',
    'brands.favorite': 'Favori',
    'brands.create': '+ Nouvelle enseigne',
    'brands.form.title': 'Créer une nouvelle enseigne',
    'brands.form.brandInfo': "Informations de l'enseigne",
    'brands.form.brandInfo.title': "Nom de l'enseigne",
    'brands.form.selectUser': 'Sélectionnez un responsable enseigne',
    'brands.form.selectUser.title': "Créer un responsable d'enseigne",
    'brands.form.canals': "Sélectionnez les canaux de commande de l'enseigne",
    'brands.form.canals.title': 'Gérer les canaux',
    'brands.form.brandName': 'Nom',
    'brands.form.region': 'Région et langue',
    'brands.form.currency': 'Devise',
    'brands.form.firstName': 'Prénom *',
    'brands.form.lastName': 'Nom *',
    'brands.form.phoneNumber': 'Numéro de téléphone *',
    'brands.form.email': 'Email *',
    'brands.form.password': 'Mot de passe *',
    'brands.form.confirmPassword': 'Confirmez le mot de passe *',
    'brands.form.error.phone.valid': 'Ce numéro est invalide',
    'brands.form.error.password.min': 'Mot de passe invalide (minimum 12 caractères)',
    'brands.form.error.passwordConfirm.sameAsPassword': 'Les deux mots de passe doivent être identiques',

    // Pos permissions
    'posPermissions.accessPermissions': 'Permissions d`accès',
    'posPermissions.otherPermissions': 'Autres permissions',
    'posPermissions.ACCESS_CATALOG_SCREEN': 'Catalogue',
    'posPermissions.ACCESS_CUSTOMERS_SCREEN': 'Clients',
    'posPermissions.ACCESS_CUSTOMISATION_SCREEN': 'Options',
    'posPermissions.ACCESS_E_WALLET_SCREEN': 'E-Wallet',
    'posPermissions.ACCESS_MANAGE_CASH_FLOAT_SCREEN': 'Fonds de caisse',
    'posPermissions.ACCESS_MANAGE_DISCOUNT_SCREEN': 'Promotions',
    'posPermissions.ACCESS_MANAGE_RUNNER_SCREEN': 'Livreurs',
    'posPermissions.ACCESS_MANAGE_TABLES_SCREEN': 'Plan de table',
    'posPermissions.ACCESS_NEW_ORDER_SCREEN': 'Nouvelle commande',
    'posPermissions.ACCESS_ORDERS_FOLLOW_UP_SCREEN': 'Suivi de commande',
    'posPermissions.ACCESS_PARAMETER_SCREEN': 'Paramètres',
    'posPermissions.ACCESS_PRINTER_SCREEN': 'Imprimantes',
    'posPermissions.ACCESS_RAZ_SCREEN': 'Rapports',
    'posPermissions.ACCESS_TICKET_SCREEN': 'Tickets',
    'posPermissions.ACCESS_USER_SCREEN': 'Utilisateurs',
    'posPermissions.APPLY_DISCOUNT': 'Appliquer une promotion',
    'posPermissions.CANCEL_ORDER': 'Annuler la commande',
    'posPermissions.CANCEL_VALIDATED_ORDER_ITEM': 'Annuler un produit validé d’une commande',
    'posPermissions.CREATE_GROUP': 'Créer un groupe',
    'posPermissions.CREATE_PRODUCT': 'Créer un produit',
    'posPermissions.DELETE_DEFAULT_PRINTER': 'Supprimer l’imprimante par défaut',
    'posPermissions.DISCONNECT': 'Déconnecter une caisse',
    'posPermissions.ENTER_DISCOUNT_WHEN_PLACING_AN_ORDER': 'Saisir une réduction lors d’une prise de commande',
    'posPermissions.EXPORT_ARCHIVE': 'Exporter les archives',
    'posPermissions.FORCE_ORDER_SHIFT': "Forcer le service d'une commande",
    'posPermissions.GENERATE_ARCHIVE': 'Générer les archives fiscales',
    'posPermissions.JUSTIFY_ORDERS': 'Justifier les commandes',
    'posPermissions.LINK_A_BADGE': 'Associer un badge',
    'posPermissions.MODIFY_FEATURE_OPTIONS': 'Modifier les options',
    'posPermissions.MODIFY_FUNCTION_FROM_GRID': 'Modifier une fonction par un appui long',
    'posPermissions.MODIFY_GROUP_FROM_GRID': 'Modifier un groupe par un appui long',
    'posPermissions.MODIFY_ORDER_ITEM_PRICE': 'Modifier le prix d’un produit dans le panier',
    'posPermissions.MODIFY_PASSWORD': 'Modifier le mot de passe',
    'posPermissions.MODIFY_PRODUCT_FROM_GRID': 'Afficher la fiche produit',
    'posPermissions.MODIFY_SKU_BILLING_CODE_PURCHASE_PRICE':
        'Modifier code produit, facturation et prix de facturation',
    'posPermissions.MODIFY_PRODUCT_PRICE': 'Modifier le prix dans la fiche produit',
    'posPermissions.MODIFY_PRODUCT_OTHER_INFO': 'Modifier les autres propriétés dans la fiche produit',
    'posPermissions.MODIFY_TICKET': 'Modifier le ticket',
    'posPermissions.MODIFY_TICKET_GROUPS': 'Modifier les groupes des tickets',
    'posPermissions.MODIFY_TICKET_ORDER_PLACES': 'Modifier le type de commande des tickets',
    'posPermissions.MODIFY_TICKET_ORDER_STATUS': 'Modifier le statut de commande des tickets',
    'posPermissions.MODIFY_TICKET_QUANTITY': 'Modifier les quantités des tickets',
    'posPermissions.MODIFY_VALIDATED_ORDER_ITEM': 'Modifier un produit validé d’une commande',
    'posPermissions.OFFER_PRODUCT_FOR_FREE': 'Offrir un produit',
    'posPermissions.OPEN_CASH_DRAWER': 'Ouvrir le tiroir caisse',
    'posPermissions.PRINT_VALID_TICKET': 'Imprimer les tickets validés',
    'posPermissions.REFUND_CLIENT': 'Rembourser un client',
    'posPermissions.REMOVE_PRODUCT_FROM_CATALOG': 'Supprimer un produit du catalogue',
    'posPermissions.REOPEN_ORDER': 'Ré-ouvrir une commande',
    'posPermissions.SEARCH_CLIENT': 'Rechercher un client manuellement',
    'posPermissions.SHOW_APPLY_PRICING_RULE_BUTTON': 'Afficher le bouton Repas Forcé sur l‘écran de nouveau passage',
    'posPermissions.SYNC_ARCHIVE': 'Synchroniser les archives',
    'posPermissions.VIEW_AUDIT_TRAIL': 'Voir la piste d’audit',
    'posPermissions.VIEW_FEATURE_OPTIONS': 'Voir les options',
    'posPermissions.VIEW_ORDER_AUDIT': 'Voir les audits de commandes',
    'posPermissions.VIEW_REVENUE_IN_FOLLOW_UP': 'Afficher le CA dans les rapports',
    'posPermissions.VIEW_TICKET_AUDIT': 'Voir les audits de tickets',
    'posPermissions.VIEW_TICKET_TEMPLATE': 'Voir les templates de tickets',
    'posPermissions.MODIFY_TICKET_PRINTER': `Modifier l'imprimante des tickets`,
    'posPermissions.VALIDATE_EPT_PAYMENT_OPERATIONS': 'Valider les opérations TPE',

    'multiBrand.user': 'Utilisateur',

    // badge reader
    'badgeReader.empty': 'Aucun lecteur de badge configuré',
    'badgeReader.notConfigured':
        'Il semble que vous n’ayez pas de lecteur de badge configuré. Veuillez vous rendre dans notre',
    'badgeReader.help': 'rubrique d’aide.',
    'badgeReader.create': 'Créer un lecteur de badge',
    'badgeReader.table.title': 'Lecteurs de badge',
    'badgeReader.table.name': 'Nom du lecteur',
    'badgeReader.table.deviceUuid': 'UUID du lecteur',
    'badgeReader.table.driver': 'Technologie du lecteur',
    'badgeReader.table.driverConfigs': 'Variables de la technologie',
    'badgeReader.table.readingConditions': 'Règles de lectures',
    'badgeReader.table.keyboardLayout': 'Keyboard layout',
    'badgeReader.driverConfigs':
        'Baudrate = <b>{baudRate}</b> {br}Bits = <b>{dataBits}</b> {br}Parity = <b>{parity}</b> {br}Stop Bits = <b>{stopBits}</b>',
    'badgeReader.readingCondition.number': 'Condition #{index}:',
    'badgeReader.readingCondition.stringLength': '• Si longueur = {stringLength} caractère(s)',
    'badgeReader.readingCondition.convertBefore.none': '• On ne fait pas de conversion',
    'badgeReader.readingCondition.convertBefore.hex-dec': '• On convertit en décimales = {stringLength}',
    'badgeReader.readingCondition.convertBefore.hex-ascii': '• On convertit en ASCII = {stringLength}',
    'badgeReader.readingCondition.convertBefore.dec-hex': '• On convertit en hexadécimal = {stringLength}',
    'badgeReader.readingCondition.convertBefore.remove-zero': '• On supprime les zéros',
    'badgeReader.readingCondition.convertBefore.hex-inverter': '• On inverse les caractères',
    'badgeReader.readingCondition.convertBefore.prefix':
        '• On préfixe avec caractère {prefix} jusqu’à {substrLength} caractères',
    'badgeReader.readingCondition.substrPositionStart': '• On lit à partir de {substrPositionStart} caractère(s)',
    'badgeReader.readingCondition.substrLength': '• On lit {substrLength} caractère(s)',
    'badgeReader.readingCondition.convertAfter.none': '• On ne convertit pas ces {substrLength} caractère(s)',
    'badgeReader.readingCondition.convertAfter.hex-dec': '• On convertit ces décimales caractères en {convertAfter}',
    'badgeReader.readingCondition.convertAfter.dec-hex': '• On convertit ces hexadécimal caractères en {convertAfter}',
    'badgeReader.readingCondition.convertAfter.hex-ascii': '• On convertit ces caractères ASCII en {convertAfter}',
    'badgeReader.readingCondition.convertAfter.remove-zero': '• On supprime les zéros',
    'badgeReader.readingCondition.convertAfter.hex-inverter': '• On inverse ces {substrLength} caractères',
    'badgeReader.delete.confirmation': 'Êtes-vous sûr de vouloir supprimer ?',
    'badgeReader.delete.warning': 'Attention',
    'badgeReader.cancel.confirmation': 'Êtes-vous sûr de vouloir annuler la configuration ?',
    'badgeReader.cancel.warning': 'Attention',
    // badge reader drivers
    'badgeReader.driver.keyboard': 'Sortie clavier',
    'badgeReader.driver.serial': 'Protocole série (RS232)',
    'badgeReader.driver.toqla': 'Toqla',
    // badge reader keyboard layouts
    'badgeReader.keyboardLayout.QWERTY': 'QWERTY',
    'badgeReader.keyboardLayout.AZERTY': 'AZERTY',
    // badge reader drivers
    'badgeReader.convertion.none': 'pas de conversion',
    'badgeReader.convertion.hex-dec': 'hexadécimal vers décimales',
    'badgeReader.convertion.hex-ascii': 'hexadécimal vers ASCII',
    'badgeReader.convertion.dec-hex': 'décimales vers hexadécimal',
    // badge reader steps
    'badgeReader.step.information': 'Création de lecteur',
    'badgeReader.step.driverConfigs': 'Variables de technologie',
    'badgeReader.step.readingCondition': 'Règles de lecture ',
    // badge reader From
    'badgeReader.form.name': 'Nom du lecteur',
    'badgeReader.form.deviceId': 'Identifiant USB du lecteur',
    'badgeReader.form.deviceUuid': 'UUID du lecteur',
    'badgeReader.form.driver': 'Technologie du lecteur',
    'badgeReader.form.driverConfigBaudRate': 'Baudrate',
    'badgeReader.form.driverConfigDataBits': 'Bits',
    'badgeReader.form.driverConfigParity': 'Parity',
    'badgeReader.form.driverConfigStopBits': 'Stop Bits',
    'badgeReader.form.keyboardLayout': 'Disposition du clavier',
    'badgeReader.form.readingCondition.order': 'Condition n°',
    'badgeReader.form.readingCondition.stringLength': 'Longueur',
    'badgeReader.form.readingCondition.convertBefore': 'Conversion avant ?',
    'badgeReader.form.readingCondition.substrPositionStart': 'Départ / Préfixe',
    'badgeReader.form.readingCondition.substrLength': 'Longueur',
    'badgeReader.form.readingCondition.convertAfter': 'Conversion après ?',
    'badgeReader.step.readingCondition.add': 'Ajouter +',
    // badge reader Form drivers
    'badgeReader.form.convertion.none': 'Désactivé',
    'badgeReader.form.convertion.hex-dec': 'Hex > Dec',
    'badgeReader.form.convertion.dec-hex': 'Dec > Hex',
    'badgeReader.form.convertion.remove-zero': 'Supprimer les zéros',
    'badgeReader.form.convertion.qwerty-azerty': 'Qwerty > Azerty',
    'badgeReader.form.convertion.hex-inverter': 'Hexadecimal inversé bit à bit',
    'badgeReader.form.convertion.prefix': 'Préfixe',
    'badgeReader.form.convertion.hex-ascii': 'Hex > ASCII',

    // POS device
    'posDevice.catalogHistory.title': 'Historique des catalogues',
    'posDevice.catalogHistory.table.hash': 'Hash',
    'posDevice.catalogHistory.table.date': 'Date de création',
    'posDevice.catalogHistory.table.actions': 'Actions',
    'posDevice.catalogHistory.button.download': 'Télécharger',

    // Update password
    'passwordUpdate.title': 'Mise à jour du mot de passe',
    'passwordUpdate.currentPassword': 'Ancien mot de passe',
    'passwordUpdate.newPassword': 'Nouveau mot de passe',
    'passwordUpdate.confirmPassword': 'Confirmer le nouveau mot de passe',
    'passwordUpdate.update': 'Sauvegarder',
    'passwordUpdate.passwordMismatch': 'Le nouveau mot de passe et la confirmation ne correspondent pas.',
    'passwordUpdate.passwordMinLength': 'Le mot de passe doit contenir au moins 12 caractères.',
    'passwordUpdate.success': 'Mot de passe mis à jour avec succès',

    // Notification
    'notification.guestHierarchy.title': 'Nouveau',
    'notification.guestHierarchy.content': 'Le paramétrage de la hiérarchie des comptes évolue.',
    'notification.guestHierarchy.link': 'Cliquez pour en savoir plus',

    // Guest hierarchy Training
    'guestHierarchyTraining.page1.title': 'Bienvenue sur l’encadrement des parcours clients',
    'guestHierarchyTraining.page1.content':
        "L’encadrement des parcours clients permet un paramétrage strict des comptes convives dans le Back-Office (BO). Il repose sur une hiérarchie en <b>Groupe → Section → Sous-section</b> et l'assignation de <b>régimes tarifaires</b> à ces éléments. Cette structuration garantit une gestion optimisée et cohérente.",
    'guestHierarchyTraining.page2.title': 'Accéder à la Hiérarchisation',
    'guestHierarchyTraining.page2.content':
        'Ouvrez le nouvel onglet <b>Hiérarchisation</b>. Cet espace permet de <b>créer, modifier</b> les groupes, sections et sous-sections.',
    'guestHierarchyTraining.page3.title': 'Créer ou modifier un Groupe',
    'guestHierarchyTraining.page3.content':
        '• Accédez à <b>Hiérarchisation > Groupes.</b> {br}• Cliquez sur <b>"Créer un groupe"</b> ou modifiez un existant. {br}• Un groupe possède un <b>libellé unique</b> (1) {br}• Définissez les <b>régimes tarifaires autorisés</b> pour les convives rattachés à ce groupe (2)',
    'guestHierarchyTraining.page4.title': 'Créer ou modifier une Section',
    'guestHierarchyTraining.page4.content':
        '• Accédez à <b>Hiérarchisation > Sections.</b> {br}• Cliquez sur <b>"Créer une section"</b> ou modifiez une existante. {br}• Assignez une section à un <b>groupe existant</b>. (1) {br}• Un libellé unique est requis. (2) {br} • Définissez les <b>régimes tarifaires autorisés</b> pour les convives rattachés à cette section (3)',
    'guestHierarchyTraining.page5.title': 'Créer ou modifier une Sous-section',
    'guestHierarchyTraining.page5.content':
        '• Accédez à <b>Hiérarchisation > Sous-sections.</b> {br}• Cliquez sur <b>"Créer une sous-section"</b> ou modifiez une existante. {br}• Assignez une sous-section à une <b>section existante</b>. (1 et 2) {br}• Un libellé unique est requis. (3) {br} • Définissez les <b>régimes tarifaires autorisés</b> pour les convives rattachés à cette sous-section (4)',

    // Guest hierarchy info
    'guestHierarchyInfo.title': 'Création de convives',
    'guestHierarchyInfo.content':
        "Lors de la création d'un convive, les régimes tarifaires proposés sont automatiquement filtrés en fonction du groupe, de la section ou de la sous-section sélectionné.",

    // Loyalty
    'loyalty.features.title': 'Fonctionnalités activées',
    'loyalty.features.MultiRewardSelection': 'Sélection multiple de récompenses',
    'loyalty.features.Promocode': 'Codes promotionnels',
    'loyalty.features.Deals': 'Deals',
    'loyalty.features.PointPayment': 'Paiement par points',

    // Splio
    'splio.title': 'Intégration - Fidélité Splio',
    'splio.integrationEnabled': 'Intégration activée depuis {date}',
    'splio.description':
        'Renseigner la clé API dans le champ suivant pour associer votre programme Splio avec votre restaurant et vos produits Innovorder.\nCette clé API est à récupérer depuis votre interface Splio.',
    'splio.apiKey.placeholder': 'Saisissez votre clé API Splio',
    'splio.apiKey': 'Clé API Splio',
    'splio.programId': 'Programme de fidélité',
    'splio.allowCustomerRewardUsage': "Autoriser l'utilisation des récompenses par les client",
    'splio.formLink': "Liens vers le formulaire de d'inscription",
    'splio.optIn': 'OptIn associé à la newsletter de marketing',
    'splio.memberIdentifier': 'Identifiant pour la création de compte',
    'splio.useCasualTone': 'Activer le tutoiement',
    'splio.authenticationMethods': "Méthodes d'authentification fidélité autorisées",
    'splio.registerMethods': "Méthodes d'inscription fidélité autorisées",
    'splio.methods.email': 'E-mail',
    'splio.methods.phone': 'Téléphone',
    'splio.methods.externalId': 'Identifiant fidélité',
    'splio.update.success': 'Intégration Splio mise à jour avec succès',
    'splio.subscriptionToMarketingNewsletter': 'Inscription à la newsletter marketing',
    'splio.subscriptionToLoyaltyNewsletter': 'Inscription à la newsletter fidélité',
    'splio.deleteModal.title': "Suppression de l'intégration Splio",
    'splio.deleteModal.text': "Êtes-vous sûr de vouloir supprimer l'intégration Splio ?",
    'splio.error.formLinkInvalid': 'Lien de formulaire invalide',
    'splio.error.changeProvider':
        "Une intégration fidélité est déjà configurée pour ce restaurant, veuillez la supprimer d'abord",

    // Points de collecte
    'pickupPoint.page.title': 'Points de collecte',
    'pickupPoint.page.description': 'Créez et gérez vos points de collecte',
    'pickupPoint.action.create': 'Créer un point de collecte',
    'pickupPoint.modal.createPickupPoint': "Création d'un point de collecte",
    'pickupPoint.modal.editPickupPoint': "Modification d'un point de collecte",
    'pickupPoint.modal.deletePickupPoint': "Suppression d'un point de collecte",
    'pickupPoint.modal.delete.title': 'Supprimer un point de collecte',
    'pickupPoint.modal.delete.description': 'Êtes-vous sûr de vouloir supprimer le point de collecte "{name}"?',
    'pickupPoint.modal.pickupPoint.name': 'Nom',
    'pickupPoint.modal.pickupPoint.address': 'Adresse',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo': "Complément d'adresse",
    'pickupPoint.modal.pickupPoint.name.placeholder': 'Nom du point de collecte',
    'pickupPoint.modal.pickupPoint.address.placeholder': 'Adresse du point de collecte',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo.placeholder': "Complément d'adresse du point de collecte",
    'pickupPoint.modal.warn.shift.title': 'Attention',
    'pickupPoint.modal.warn.shift.text':
        "Assurez-vous qu'aucune commande ne soit en cours avant de supprimer ce point de collecte. Une fois supprimé, il ne sera plus visible des clients et les commandes en cours seront perdues.",
    'pickupPoint.modal.warn.shift.button': 'Compris',

    // Como
    'como.title': 'Intégration - Fidélité Como',
    'como.description':
        'Renseigner la clé API dans le champ suivant pour associer votre programme Como avec votre restaurant et vos produits Innovorder.\nCette clé API est à récupérer depuis votre interface Como.',
    'como.apiKey': 'Clé API Como',
    'como.integrationEnabled': 'Intégration activée depuis {date}',
    'como.apiKey.placeholder': 'Saisissez votre clé API Como',
    'como.formLink': "Liens vers le formulaire de d'inscription",
    'como.useCasualTone': 'Activer le tutoiement',
    'como.authenticationMethods': "Méthodes d'authentification fidélité autorisées",
    'como.registerMethods': "Méthodes d'inscription fidélité autorisées",
    'como.methods.email': 'E-mail',
    'como.methods.phone': 'Téléphone',
    'como.methods.externalId': 'Identifiant fidélité',
    'como.error.formLinkInvalid': 'Lien de formulaire invalide',
    'como.update.success': 'Intégration Como mise à jour avec succès',
    'como.deleteModal.title': "Suppression de l'intégration Como",
    'como.deleteModal.text': "Êtes-vous sûr de vouloir supprimer l'intégration Como ?",
    'como.error.changeProvider':
        "Une intégration fidélité est déjà configurée pour ce restaurant, veuillez la supprimer d'abord",
    'como.error.invalidApiKey': 'La clé API renseignée est invalide.',

    // Zerosix
    'zerosix.title': 'Intégration - Fidélité Zerosix',
    'zerosix.description':
        'Renseigner la clé API dans le champ suivant pour associer votre programme Zerosix avec votre restaurant et vos produits Innovorder.\nCette clé API est à récupérer depuis votre interface Zerosix.',
    'zerosix.apiKey': 'Clé API Zerosix',
    'zerosix.integrationEnabled': 'Intégration activée depuis {date}',
    'zerosix.apiKey.placeholder': 'Saisissez votre clé API Zerosix',
    'zerosix.formLink': "Liens vers le formulaire de d'inscription",
    'zerosix.useCasualTone': 'Activer le tutoiement',
    'zerosix.authenticationMethods': "Méthodes d'authentification fidélité autorisées",
    'zerosix.registerMethods': "Méthodes d'inscription fidélité autorisées",
    'zerosix.methods.email': 'E-mail',
    'zerosix.methods.phone': 'Téléphone',
    'zerosix.methods.externalId': 'Identifiant fidélité',
    'zerosix.error.formLinkInvalid': 'Lien de formulaire invalide',
    'zerosix.update.success': 'Intégration Zerosix mise à jour avec succès',
    'zerosix.deleteModal.title': "Suppression de l'intégration Zerosix",
    'zerosix.deleteModal.text': "Êtes-vous sûr de vouloir supprimer l'intégration Zerosix ?",
    'zerosix.error.changeProvider':
        "Une intégration fidélité est déjà configurée pour ce restaurant, veuillez la supprimer d'abord",
    'zerosix.error.invalidApiKey': 'La clé API renseignée est invalide.',

    // Restaurant Info
    'restaurantInfo.title': 'Informations du restaurant',
    'restaurantInfo.information.title': 'À propos du restaurant',
    'restaurantInfo.name': 'Nom du restaurant',
    'restaurantInfo.address': 'Adresse du restaurant',
    'restaurantInfo.contactName': 'Nom du contact',
    'restaurantInfo.contactEmail': 'Adresse email',
    'restaurantInfo.contactPhone': 'Numéro de téléphone',
    'restaurantInfo.externalId': 'Identifiant externe',
    'restaurantInfo.tag': 'Tag du restaurant',
    'restaurantInfo.families': 'Familles du restaurant',
    'restaurantInfo.searchFamilies': 'Rechercher une famille',
    'restaurantInfo.image': 'Image du restaurant',
    'restaurantInfo.legal.title': 'Informations légales',
    'restaurantInfo.legal.description':
        'Ces informations servent à générer les conditions générales de vente et mentions légales des canaux de commande',
    'restaurantInfo.legal.socialReason': 'Raison sociale',
    'restaurantInfo.legal.organizationType': "Type d'organisation",
    'restaurantInfo.legal.capital': 'Capital social',
    'restaurantInfo.legal.commerceRegistryCity': "Ville d'enregistrement au rcs",
    'restaurantInfo.legal.siren': 'Siren',
    'restaurantInfo.legal.taxNumber': 'Numéro de tva',
    'restaurantInfo.legal.industryClassificationCode': 'Code NAF',
    'restaurantInfo.legal.publicationDirectorName': 'Nom du directeur de publication',
    'restaurantInfo.legal.publicationDirectorFunction': 'Fonction du directeur de publication',
    'restaurantInfo.legal.webmasterName': 'Nom du webmestre',
    'restaurantInfo.legal.webmasterEmail': 'Email du webmestre',
    'restaurantInfo.ewalletMinimum.title': 'Configuration du solde e-wallet minimum autorisé sur le Scan Plateau',
    'restaurantInfo.ewalletMinimum.inputTitle': 'MONTANT MINIMUM',
    'restaurantInfo.ewalletMinimum.caseZero':
        'Pour ne pas mettre de minimum badge, indiquer 0 dans le champs puis enregistrer.',
    'restaurantInfo.delete.title': 'Suppression de restaurant',
    'restaurantInfo.delete.description': 'Ce restaurant existe depuis le',
    'restaurantInfo.delete.button': 'Supprimer ce restaurant',
    'restaurantInfo.save.error': "Une erreur s'est produite lors de la sauvegarde, veuillez réessayer.",
    'restaurantInfo.delete.error': "Une erreur s'est produite, veuillez recommencer votre configuration.",
    'restaurantInfo.delete.confirmTitle': 'Suppression de restaurant',
    'restaurantInfo.delete.confirmDescription':
        'Êtes-vous sûr de vouloir supprimer ce restaurant ? Cette action est irréversible.',
    'restaurantInfo.schedule.title': 'Horaires de collecte autorisée',
    'restaurantInfo.schedule.manualEdit': 'Edition manuelle',
    'restaurantInfo.schedule.autoEdit': 'Edition automatique',
    'restaurantInfo.schedule.autoEditDescription': 'Permet de créer des tranches horaires rapidement.',
    'restaurantInfo.schedule.description':
        "Vous pouvez configurer différents horaires de collecte autorisée pour votre restaurant. Ces créneaux correspondent aux horaires d'ouverture de votre restaurant, pendant lesquels vos clients pourront récupérer leurs commandes effectuées en ligne.",
    'restaurantInfo.schedule.open': 'Ouvert',
    'restaurantInfo.schedule.closed': 'Fermé',
    'restaurantInfo.schedule.day.mon': 'Lun',
    'restaurantInfo.schedule.day.tue': 'Mar',
    'restaurantInfo.schedule.day.wed': 'Mer',
    'restaurantInfo.schedule.day.thu': 'Jeu',
    'restaurantInfo.schedule.day.fri': 'Ven',
    'restaurantInfo.schedule.day.sat': 'Sam',
    'restaurantInfo.schedule.day.sun': 'Dim',
    'restaurantInfo.schedule.mass.startHour': 'Heure de début',
    'restaurantInfo.schedule.mass.endHour': 'Heure de fin',
    'restaurantInfo.schedule.mass.granularity': 'Intervalle',
    'restaurantInfo.schedule.mass.15min': '15 min',
    'restaurantInfo.schedule.mass.30min': '30 min',
    'restaurantInfo.schedule.mass.1h': '1 heure',
    'restaurantInfo.schedule.mass.overwrite': 'Écraser les horaires existants',
    'restaurantInfo.schedule.mass.apply': 'Appliquer',
    'restaurantInfo.schedule.mass.noDays': 'Sélectionnez au moins un jour.',
    'restaurantInfo.schedule.mass.midnight': 'minuit',

    // Order
    'order.customer.loyalty.anonymous': 'Anonyme {email}',

    // VAT Rates Matrix
    'route.vatRatesMatrix': 'Référentiel TVA',
    'vatRatesMatrix.title': 'Référentiel TVA Global',
    'vatRatesMatrix.subtitle':
        'Source unique de vérité pour la fiscalité de tous les produits Innovorder. Les modifications sont automatiquement répercutées sur les nouveaux produits.',
    'vatRatesMatrix.vatGroup': 'Famille TVA',
    'vatRatesMatrix.codeLabel': 'Code',
    'vatRatesMatrix.eatIn': 'Sur place',
    'vatRatesMatrix.takeAway': 'À emporter',
    'vatRatesMatrix.delivery': 'Livraison',
    'vatRatesMatrix.exportCsv': 'Exporter CSV',
    'vatRatesMatrix.exportError': "Une erreur est survenue lors de l'export CSV. Veuillez réessayer.",
    'vatRatesMatrix.filterByZone': 'Filtrer par zone',
    'vatRatesMatrix.filterByGroup': 'Filtrer par famille',
    'vatRatesMatrix.filterByMode': 'Filtrer par mode',
    'vatRatesMatrix.loading': 'Chargement...',
    'vatRatesMatrix.error': 'Erreur lors du chargement des données.',
    'vatRatesMatrix.family.FOOD': 'Alimentation',
    'vatRatesMatrix.family.NON_ALCOHOL': 'Sans alcool',
    'vatRatesMatrix.family.ALCOHOL': 'Alcool',
    'vatRatesMatrix.family.NORMAL': 'Normal',
    'vatRatesMatrix.family.NONE': 'Aucune',

    // Promotional Banners
    'route.promotionalBanners': 'Bannières promotionnelles',
    'promotionalBanner.page.title': 'Gestion des bannières',
    'promotionalBanner.page.subtitle':
        'Créez et gérez vos bannières promotionnelles pour les afficher sur votre borne.',
    'promotionalBanner.page.emptyState':
        'Créez une bannière promotionnelle pour promouvoir vos produits et catégories sur votre borne.',
    'promotionalBanner.page.emptyStateCta': 'Créer une bannière',
    'promotionalBanner.page.noActiveMenu.title': 'Aucun menu borne actif',
    'promotionalBanner.page.noActiveMenu.desc':
        '👉 Activez un menu borne pour accéder à la configuration des bannières.',
    'promotionalBanner.page.noActiveMenu.cta': 'Gérer mes menus',
    'promotionalBanner.action.create': 'Créer une bannière',
    'promotionalBanner.action.edit': 'Modifier',
    'promotionalBanner.action.view': 'Voir',
    'promotionalBanner.action.delete': 'Supprimer',
    'promotionalBanner.action.activate': 'Activer',
    'promotionalBanner.action.deactivate': 'Désactiver',
    'promotionalBanner.table.listTitle': 'Liste des bannières promotionnelles',
    'promotionalBanner.modal.createTitle': 'Créer une bannière',
    'promotionalBanner.modal.editTitle': 'Modifier la bannière',
    'promotionalBanner.modal.viewTitle': 'Voir la bannière',
    'promotionalBanner.modal.close': 'Fermer',
    'promotionalBanner.modal.name': 'Nom',
    'promotionalBanner.modal.channel': 'Canal',
    'promotionalBanner.modal.image': 'Image',
    'promotionalBanner.modal.linkType': 'Type de lien',
    'promotionalBanner.modal.linkTarget': 'Cible',
    'promotionalBanner.modal.activateAndSave': 'Activer et enregistrer',
    'promotionalBanner.modal.saveAsDraft': 'Enregistrer en brouillon',
    'promotionalBanner.modal.updateBanner': 'Mettre à jour la bannière',
    'promotionalBanner.modal.deactivateBanner': 'Désactiver la bannière',
    'promotionalBanner.modal.imageSizeError': "L'image ne doit pas dépasser 5 Mo",
    'promotionalBanner.modal.nameHelper': 'Ce nom est uniquement visible dans le backoffice.',
    'promotionalBanner.modal.nameLabel': 'Nom de la bannière',
    'promotionalBanner.modal.channelLabel': 'Canal cible',
    'promotionalBanner.modal.channelKiosk': 'Borne',
    'promotionalBanner.modal.channelKioskDesc':
        'Affichage de la bannière au début du parcours de commande sur la borne.',
    'promotionalBanner.modal.channelWeb': 'CEL',
    'promotionalBanner.modal.channelWebDesc': 'Affichage dans le parcours de commande en ligne.',
    'promotionalBanner.modal.channelWebDisabled': 'Disponible prochainement.',
    'promotionalBanner.modal.imageLabel': 'Image de la bannière',
    'promotionalBanner.modal.imageSpecs': 'JPG, PNG, WebP · Max 5 Mo · Format 3:1',
    'promotionalBanner.modal.image.error.ratio': 'Le format doit être 3:1',
    'promotionalBanner.modal.imageFileDescription': '{name} · 1920×500px',
    'promotionalBanner.modal.linkTypeLabel': 'Type de lien',
    'promotionalBanner.modal.linkNone': 'Aucun lien',
    'promotionalBanner.modal.linkNoneDesc': 'Est informative et non cliquable.',
    'promotionalBanner.modal.linkProduct': 'Produit',
    'promotionalBanner.modal.linkProductDesc': 'Redirige vers la fiche produit si on clique dessus.',
    'promotionalBanner.modal.linkCategory': 'Catégorie',
    'promotionalBanner.modal.linkCategoryDesc': 'Redirige vers la catégorie si on clique dessus.',
    'promotionalBanner.modal.activateBanner': 'Activer la bannière',
    'promotionalBanner.modal.replace': 'Remplacer',
    'promotionalBanner.modal.searchCategory': 'Rechercher une catégorie...',
    'promotionalBanner.modal.searchProduct': 'Rechercher un produit avec nom ou SKU...',
    'promotionalBanner.table.name': 'Nom',
    'promotionalBanner.table.status': 'Statut',
    'promotionalBanner.table.source': 'Source',
    'promotionalBanner.table.linkType': 'Type de lien',
    'promotionalBanner.table.actions': 'Actions',
    'promotionalBanner.table.sourceRestaurant': 'Restaurant',
    'promotionalBanner.table.sourceBrand': 'Enseigne',
    'promotionalBanner.table.linkNone': 'Aucun lien',
    'promotionalBanner.table.linkCategory': 'Catégorie',
    'promotionalBanner.table.linkProduct': 'Produit',
    'promotionalBanner.table.statusActive': 'Actif',
    'promotionalBanner.table.statusInactive': 'Inactif',
    'promotionalBanner.table.linkDeleted': 'supprimé',
    'promotionalBanner.confirm.title': 'Un service est actuellement en cours',
    'promotionalBanner.confirm.message':
        'Cette action va recharger toutes les bornes et interrompre les commandes en cours.',
    'promotionalBanner.confirm.confirm': 'Confirmer',
    'promotionalBanner.confirm.cancel': 'Annuler',
    'promotionalBanner.delete.title': 'Supprimer la bannière',
    'promotionalBanner.delete.description': 'Êtes-vous sûr de vouloir supprimer cette bannière ?',

    // Bulk reload (Lot 3)
    'promotionalBanner.confirm.message.bulk':
        'Cette action va recharger les bornes de {count} restaurants et interrompre les commandes en cours.',

    // Duplicate (restaurant page, Lot 3)
    'promotionalBanner.action.duplicate': 'Dupliquer',
    'promotionalBanner.duplicate.fallback.title': 'Bannière dupliquée sans lien',
    'promotionalBanner.duplicate.fallback.product':
        "La copie de « {sourceName} » a été créée sans lien : le SKU n'a pas été trouvé dans votre menu borne actif.",
    'promotionalBanner.duplicate.fallback.category':
        "La copie de « {sourceName} » a été créée sans lien : la catégorie n'a pas été trouvée dans votre menu borne actif.",
    'promotionalBanner.duplicate.fallback.dismiss': "J'ai compris",

    // Route label (Lot 3)
    'route.brand.promotionalBanners': 'Bannières promotionnelles',

    // Brand promotional banners page (Lot 3)
    'brandPromotionalBanner.page.title': 'Bannières promotionnelles enseigne',
    'brandPromotionalBanner.page.subtitle': "Configurez et propagez les bannières sur les restaurants de l'enseigne.",
    'brandPromotionalBanner.page.empty': "Aucune bannière pour l'instant.",
    'brandPromotionalBanner.action.create': 'Créer une bannière',

    // Brand table
    'brandPromotionalBanner.table.name': 'Nom',
    'brandPromotionalBanner.table.status': 'Statut',
    'brandPromotionalBanner.table.source': 'Source',
    'brandPromotionalBanner.table.link': 'SKU ou catégorie',
    'brandPromotionalBanner.table.activeRestaurants': '{count} restaurant actifs',
    'brandPromotionalBanner.table.actions': 'Actions',

    // Brand modal
    'brandPromotionalBanner.modal.createTitle': 'Créer une bannière enseigne',
    'brandPromotionalBanner.modal.editTitle': 'Modifier la bannière',
    'brandPromotionalBanner.modal.name.label': 'Nom de la bannière',
    'brandPromotionalBanner.modal.image.label': 'Image',
    'brandPromotionalBanner.modal.image.hint': 'Format 3:1, max 5 Mo',
    'brandPromotionalBanner.modal.image.error.ratio': 'Le format doit être 3:1',
    'brandPromotionalBanner.modal.image.error.size': "L'image dépasse 5 Mo",
    'brandPromotionalBanner.modal.channel.label': 'Canal',
    'brandPromotionalBanner.modal.channel.comingSoon': 'Bientôt disponible',
    'brandPromotionalBanner.modal.link.label': 'Type de lien',
    'brandPromotionalBanner.modal.link.none': 'Aucun lien',
    'brandPromotionalBanner.modal.link.product': 'Produit (SKU)',
    'brandPromotionalBanner.modal.link.category': 'Catégorie',
    'brandPromotionalBanner.modal.link.product.hint':
        "Si le SKU n'est pas trouvé dans le menu borne actif d'un restaurant, la bannière sera affichée sans lien sur ce restaurant.",
    'brandPromotionalBanner.modal.link.category.hint':
        "Si la catégorie n'est pas trouvée dans le menu borne actif d'un restaurant, la bannière sera affichée sans lien sur ce restaurant.",
    'brandPromotionalBanner.modal.restaurants.label': 'Restaurants cibles',
    'brandPromotionalBanner.modal.restaurants.empty': 'Sélectionnez au moins un restaurant',
    'brandPromotionalBanner.modal.button.cancel': 'Annuler',
    'brandPromotionalBanner.modal.button.saveDraft': 'Enregistrer en brouillon',
    'brandPromotionalBanner.modal.button.activate': 'Activer la bannière',
    'brandPromotionalBanner.modal.button.deactivate': 'Désactiver la bannière',
    'brandPromotionalBanner.modal.button.update': 'Mettre à jour la bannière',

    // Brand delete
    'brandPromotionalBanner.delete.title': 'Supprimer la bannière ?',
    'brandPromotionalBanner.delete.message': 'La bannière sera retirée de tous les restaurants associés.',

    // Carousel delay
    'brandPromotionalBanner.carousel.title': "Délai d'affichage entre deux bannières",
    'brandPromotionalBanner.carousel.description': "Définissez le temps d'affichage entre deux bannières actives.",
    'brandPromotionalBanner.carousel.helper': "Temps d'attente entre l'affichage de deux bannières actives.",
    'brandPromotionalBanner.carousel.seconds': 'secondes',
    'brandPromotionalBanner.carousel.save': 'Enregistrer',
    'brandPromotionalBanner.carousel.saved': 'Délai mis à jour',
    'brandPromotionalBanner.carousel.help':
        "Ce délai s'appliquera à tous les restaurants de l'enseigne au prochain rechargement des bornes.",

    // Non-eligible restaurants
    'brandPromotionalBanner.modal.restaurants.ineligible.noChannel': "Ce restaurant n'a pas la borne activée.",
    'brandPromotionalBanner.modal.restaurants.ineligible.noMenu': "Ce restaurant n'a pas de menu borne actif.",
};

export type TranslationKey = keyof typeof translationFr;
export default translationFr;
